
// === AlertMessage.js ===
 var AlertMessage = React.createClass({
  propTypes: {
    alertType: React.PropTypes.oneOf(["success", "info", "warning", "danger"]),
    showDismiss: React.PropTypes.bool,
    onDismiss: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      alertType: "warning",
      showDismiss: false,
      onDismiss: function() {}
    }
  },
  render() {
    let dismiss;
    if (this.props.showDismiss) {
      dismiss = <button type="button" className="close" data-dismiss="alert" onClick={this.props.onDismiss}><span aria-hidden="true">&times;</span></button>;
    }

    return (
      <div className={"alert alert-" + this.props.alertType}>
        {dismiss}
        {this.props.children}
      </div>
    )
  }
})



// === AnswerStatusFilter.js ===
var AnswerStatusFilter = React.createClass({
  propTypes: {
    onStatusChanged: React.PropTypes.func,
    selectedStatusCode: React.PropTypes.string.isRequired
  },
  getDefaultProps() {
    return {
      selectedStatusCode: ""
    }
  },
  statusChanged(statusCode) {
    if (this.props.onStatusChanged) {
      this.props.onStatusChanged(statusCode);
    }
  },
  render() {
    let items = [
      {value: "",  label: Labels.getLabel("All")},
      {value: "1", label: Labels.getLabel("Answered")},
      {value: "0", label: Labels.getLabel("Unanswered")}
    ];

    return (
      <BrowseFilter title={Labels.getLabel("Status")} ariaLabel="Answer Status Filter">
        <FilterLinkList
          items={items}
          selectedValue={this.props.selectedStatusCode}
          onClick={this.statusChanged} />
      </BrowseFilter>
    )
  }
});

// === AttributeFilter.js ===
var AttributeFilter = React.createClass({
  propTypes: {
    attributeSets: React.PropTypes.array.isRequired,
    attributes: React.PropTypes.array,
    selectedSetName: React.PropTypes.string,
    selectedAttributeKeys: React.PropTypes.array,
    onAttributeSetChanged: React.PropTypes.func,
    onAttributesChanged: React.PropTypes.func,
	showAttributeFilter: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      attributeSets: [],
      attributes: [],
      selectedSetName: "",
	  showAttributeFilter: false
    }
  },
  isFilterApplied() {
    return this.props.selectedSetName.length != 0;
  },
  render() {
    let { showAttributeFilter } = this.props;
    if (!showAttributeFilter || this.props.attributeSets.length == 0) {
      return <span />
    }

    let component = this.isFilterApplied() ?
      <AttributesList attributeSetName={this.props.selectedSetName}
        selectedAttributeKeys={this.props.selectedAttributeKeys}
        attributes={this.props.attributes}
        showClear={this.isFilterApplied()}
        onAttributesChanged={this.props.onAttributesChanged} /> :
      <AttributeSetsList attributeSets={this.props.attributeSets}
        onAttributeSetChanged={this.props.onAttributeSetChanged} />;

    return (
      <BrowseFilter title={Labels.getLabel("Attributes")} filterType="filter-type__attribute" isOpen={this.props.isOpen} ariaLabel="Solution Attribute Filter">
        {component}
      </BrowseFilter>
    )
  }
});

// === AttributeSetsList.js ===
var AttributeSetsList = React.createClass({
  propTypes: {
    attributeSets: React.PropTypes.array.isRequired,
    onAttributeSetChanged: React.PropTypes.func
  },
  getItem(set) {
    return (
      <li className="filter__item" key={set.value}>
        <a href="#" className="filter__link" onClick={this.setClicked.bind(this, set.value)}>{set.value}</a>
      </li>
    )
  },
  setClicked(setName) {
    if (this.props.onAttributeSetChanged) {
      this.props.onAttributeSetChanged(setName);
    }
  },

  render() {
    return (
      <ul className="filter__list">
        {this.props.attributeSets.map(this.getItem)}
      </ul>
    )
  }
});

// === AttributesList.js ===
var AttributesList = React.createClass({
  propTypes: {
    attributeSetName: React.PropTypes.string,
    attributes: React.PropTypes.array.isRequired,
    selectedAttributeKeys: React.PropTypes.array,
    showClear: React.PropTypes.bool,
    onAttributesChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedAttributeKeys: []
    }
  },
  clearClicked() {
    if (this.props.onAttributesChanged) {
      this.props.onAttributesChanged("", []);
    }
  },
  attributeValueClicked(attrKey) {
    let selectedAttributeKeys = this.props.selectedAttributeKeys;
    let isSelected = this.isAttributeSelected(attrKey);

    if (!isSelected) {
      selectedAttributeKeys.push(attrKey);
    } else {
      selectedAttributeKeys = selectedAttributeKeys.filter(key => key != attrKey);
    }

    if (this.props.onAttributesChanged) {
      this.props.onAttributesChanged(this.props.attributeSetName, selectedAttributeKeys);
    }
  },
  isAttributeSelected(attrKey) {
    return this.props.selectedAttributeKeys.indexOf(attrKey) != -1;
  },
  getAttributeItems(attr) {
    let items = [];

    items.push(<li className="filter__item -in1" key={attr.name}>{attr.name}</li>);

    items = items.concat(attr.values.map(valueInfo => {
      let key = attr.name + "rasplit" + valueInfo.value;

      return (
        <li className="filter__item -in2" key={key}>
          <RACheck label={valueInfo.value}
            value={key}
            isChecked={this.isAttributeSelected(key)}
            onClick={this.attributeValueClicked} />
        </li>
      )
    }));

    return items;
  },

  render() {
    let clearItem = this.props.showClear ?
      <li className="filter__item"><a href="#" onClick={this.clearClicked}>{Labels.getLabel("Clear")}</a></li> : null;

    return (
      <ul className="filter__list">
        {clearItem}
        <li className="filter__item -active filterSetName">{this.props.attributeSetName}</li>
        {this.props.attributes.map(this.getAttributeItems)}
      </ul>
    )
  }
});

// === BasicPager.js ===
var BasicPager = React.createClass({
  propTypes: {
    currentPage: React.PropTypes.number.isRequired,
    maxPage: React.PropTypes.number.isRequired,
    onPageClicked: React.PropTypes.func.isRequired
  },
  pageClicked(num) {
    this.props.onPageClicked(num);
  },
  render() {
    let {
      currentPage,
      maxPage
    } = this.props;

    let prevClicked = this.pageClicked.bind(this, currentPage - 1);
    let nextClicked = this.pageClicked.bind(this, currentPage + 1);

    return (
      <div className="basic-pager">
        <button
          className="btn btn-default btn-sm"
          disabled={currentPage == 1}
		  aria-label={Labels.getLabel("Previous")} title={Labels.getLabel("Previous")}
          onClick={prevClicked}>
          <span className="fa fa-chevron-left"></span>
        </button>

        <span className="basic-pager__label">{`${Labels.getLabel("Page")} ${currentPage} ${Labels.getLabel("of")} ${maxPage}`}</span>

        <button
          className="btn btn-default btn-sm"
          disabled={currentPage == maxPage}
		  aria-label={Labels.getLabel("Next")} title={Labels.getLabel("Next")}
          onClick={nextClicked}>
          <span className="fa fa-chevron-right"></span>
        </button>
      </div>
    )
  }
})

// === BasicPagerList.js ===
var BasicPagerList = React.createClass({
  propTypes: {
    items: React.PropTypes.array.isRequired,
    renderItem: React.PropTypes.func.isRequired,
    pageSize: React.PropTypes.number,
    className: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      pageSize: 5,
    }
  },
  getInitialState() {
    return {
      pageNumber: 1
    }
  },
  pageClicked(num) {
    this.setState({pageNumber: num});
  },
  render() {
    let {
      items,
      pageSize,
      showEditControls,
      className
    } = this.props;

    let maxPage = Math.ceil(items.length / pageSize);
    let pageNumber = Math.min(this.state.pageNumber, maxPage);
    let startIndex = (pageNumber - 1) * pageSize;
    items = items.slice(startIndex, (startIndex + pageSize));

    let pager = maxPage > 1 ?
      <BasicPager
        currentPage={pageNumber}
        maxPage={maxPage}
        onPageClicked={this.pageClicked} /> : null;

    return (
      <div>
        <ul className={className}>
          {items.map(this.props.renderItem)}
        </ul>

        {pager}
      </div>
    )
  }
})

// === BrowseFilter.js ===
var BrowseFilter = React.createClass({
  propTypes: {
    title: React.PropTypes.string,
    filterType: React.PropTypes.string
  },
  getInitialState: () => {
    return {isDesktop: true, isAriaHidden: true};
  },
  componentDidMount() {
    this.updateState();
    window.addEventListener("resize", this.updateState);
  },
  componentDidUpdate(prevProps, prevState){
    this.checkForAriaHidden();
  },
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateState);
  },
  updateState(){
    this.setState({ isDesktop: window.innerWidth > 767 });
  },
  checkForAriaHidden() {
    if(!this.state.isDesktop){
      if(this.props.isOpen){
        this.state.isAriaHidden = false;
      } else{
        this.state.isAriaHidden = true;
      }
    }
    else{ 
      this.state.isAriaHidden = false;
    }
    this.refs.filterRef.setAttribute("aria-hidden", this.state.isAriaHidden);
  },
  renderTitle() {
    return this.props.title && this.props.title.length ?
        <h4 tabIndex="0" className="filter__title">{this.props.title}</h4> :
        null;
  },
  render() {
    let filterType = this.props.filterType ? " " + this.props.filterType : "";
    let ariaLabel = this.props.ariaLabel;

    return (
      <div className={"filter" + filterType} tabIndex="0"  ref={"filterRef"} aria-label={ariaLabel ? Labels.getLabel(ariaLabel):""}>
        {this.renderTitle()}
        {this.props.children}
      </div>
    )
  }
});

// === CategoryBrowser.js ===
var CategoryBrowser = React.createClass({
  componentDidMount() {
    RA.KBSearch.search({}, this.categoriesSearchDone);

    $(window).on("resize.ra.categoryBrowser", debounce(this.windowResized, 100).bind(this));
  },
  componentWillUnmount() {
    $(window).off(".categoryBrowser");
  },
  getInitialState() {
    return {
      categories: [],
      categoriesLoaded: false,
      categoryTitles: {},
      isMenuVisible: false,
      activeItem: null
    }
  },
  categoriesSearchDone(r) {
    this.setState({
      categories: r.browsePaths,
      categoriesLoaded: true
    });
  },
  windowResized() {
    let {
      activeItem,
      isMenuVisible
    } = this.state;

    if (!isMenuVisible) return;

    this.setState({
      menuPosition: this.getMenuPosition(activeItem.ref)
    });
  },
  getMenuPosition(ref) {
    let $item = $(ref);
    let $parent = $item.offsetParent();

    let offsetTop = ($item.offset().top - $parent.offset().top) + $item.outerHeight() + 10;

    return {
      offsetTop: offsetTop
    };
  },
  categoryClicked(category, ref) {
    let {
      activeItem,
      categoryTitles
    } = this.state;

    if (activeItem != null && activeItem.category == category) {
      activeItem = null;
      category.isActive = false;
    } else {
      category.isActive = true;
      activeItem = {
        ref: ref,
        category: category
      };

      if (!categoryTitles[category.value]) {
        RA.KBSearch.applyFilter({taxlevelValue: category.value}, (r) => {
          categoryTitles[category.value] = r.browsePaths;
          this.setState({ categoryTitles: categoryTitles });
        });
      }
    }

    this.setState({
      isMenuVisible: activeItem != null,
      activeItem: activeItem,
      menuPosition: this.getMenuPosition(ref)
    });
  },
  closeMenuClicked() {
    let { activeItem } = this.state;

    activeItem.category.isActive = false;

    this.setState({
      isMenuVisible: false,
      activeItem: null
    });
  },
  renderCategoryList() {
    return (
      <CategoryBrowser.List
        categories={this.state.categories}
        onClick={this.categoryClicked} />
    );
  },
  renderNoContent() {
    return <NoContent message={Labels.getLabel("No categories found")} />;
  },
  renderMenu() {
    let {
      isMenuVisible,
      activeItem,
      menuPosition,
      categoryTitles
    } = this.state;

    if (!isMenuVisible) return;

    let style = {
      top: `${menuPosition.offsetTop}px`
    };

    return (
      <CategoryBrowser.Menu
        title={activeItem.category.value}
        browsePaths={categoryTitles[activeItem.category.value]}
        offsetTop = {menuPosition.offsetTop}
        onCloseClicked={this.closeMenuClicked} />
    )
  },
  renderOverlay() {
    if (!this.state.isMenuVisible) return;

    return (
      <Overlay
       showImage={false}
       onClick={this.closeMenuClicked} />
     );
  },
  render() {
    let {
      categories,
      categoriesLoaded
    } = this.state;

    if (!categoriesLoaded) {
      return <Overlay wrap={true} />;
    }

    let content = categories.length == 0 ?
      this.renderNoContent() : this.renderCategoryList();

    return (
      <div className="cat-browser">
        {content}

        {this.renderMenu()}
        {this.renderOverlay()}
      </div>
    );
  }
});


CategoryBrowser.List = React.createClass({
  propTypes: {
    categories: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    onClick: React.PropTypes.func.isRequired
  },
  itemClicked(category, e) {
    this.props.onClick(category, e.currentTarget);
  },

  render() {
    let { categories } = this.props;

    let items = categories.map(category => {
      return (
        <CategoryBrowser.Item
          key={category.value}
          name={category.value}
          hits={category.hits}
          isActive={category.isActive}
          onClick={this.itemClicked.bind(this, category)} />
      );
    });

    return (
      <div className="cat-browser__list">
        {items}
      </div>
    )
  }
});


CategoryBrowser.Menu = React.createClass({
  propTypes: {
    offsetTop: React.PropTypes.number,
    title: React.PropTypes.string,
    browsePaths: React.PropTypes.arrayOf(React.PropTypes.object),
    onCloseClicked: React.PropTypes.func.isRequired
  },
  getDefaultProps() {
    return {
      offsetTop: 0,
      title: "",
      browsePaths: []
    }
  },
  renderItem(item) {
    let browsePath = item.value;
    let paths = browsePath.split("//");
	let url = RA.buildSearchUrl("", { taxonomypath: browsePath }) + simplifiedSocialLayoutParam + launchLinksInNewWindowParam + "#t=kbResults";
    let hits = Number.prototype.toLocaleString ? item.hits.toLocaleString() : item.hits;

    return (
      <li key={browsePath}>
        <a href={url}>
          {paths[paths.length - 1]}
        </a>
        <span className="text-muted"> ({hits})</span>
      </li>
    );
  },
  renderList() {
    let { browsePaths } = this.props;
    let count = browsePaths.length;

    let colOneData = browsePaths;
    let colTwoData = [];

    if (count > 1) {
      let colOneCount = (Math.floor(count / 2)) + (count % 2);
      let colTwoCount = Math.floor(count / 2);

      colOneData = browsePaths.slice(0, colOneCount);
      colTwoData = browsePaths.slice(colOneCount);
    }

    return (
      <div className="row cat-browser__title-list">
        <div className="col-md-6">
          <ul className="bullet-list -indent">
            {colOneData.map(this.renderItem)}
          </ul>
        </div>

        <div className="col-md-6">
          <ul className="bullet-list -indent">
            {colTwoData.map(this.renderItem)}
          </ul>
        </div>
      </div>
    )
  },
  render() {
    let {
      offsetTop,
      browsePaths,
      title
    } = this.props;

    let style = {
      top: `${offsetTop}px`
    };

    let url = RA.buildSearchUrl("", { taxonomypath: title }) + simplifiedSocialLayoutParam + launchLinksInNewWindowParam + "#t=kbResults";

    let content = browsePaths.length ?
      this.renderList() :
      <Overlay wrap={true} imageTimeout={200} />

    return (
      <div className="cat-browser__menu" style={style}>
        <a href="#" className="close" onClick={this.props.onCloseClicked}>&times;</a>
        <h3 className="cat-browser__menu-title">{title}</h3>
        <div className="cat-browser__all-wrap">
          <a href={url}>{Labels.getLabel("See all solutions")}</a>
        </div>
        {content}
      </div>
    );
  }
});


CategoryBrowser.Item = React.createClass({
  propTypes: {
    href: React.PropTypes.string,
    name: React.PropTypes.string,
    hits: React.PropTypes.number,
    isActive: React.PropTypes.bool,
    classNameModifier: React.PropTypes.string,
    onClick: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      href: "#",
      hits: 0,
      isActive: false
    }
  },
  itemClicked(e) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  },
  render() {
    let {
      name,
      hits,
      href,
      isActive,
      classNameModifier
    } = this.props;

    let label = hits == 1 ? "solution" : "solutions";
    hits = Number.prototype.toLocaleString ? hits.toLocaleString() : hits;

    return (
      <a role="button" href={href}
        className={classNames("cat-browser__item", {"-active": isActive}, classNameModifier)}
        onClick={this.itemClicked}>
        <div className="cat-browser__name">{name}</div>
        <div className="cat-browser__count">{`${hits} ${Labels.getLabel(label)}`}</div>
      </a>
    );
  }
});


// === CategoryFilter.js ===
var CategoryFilter = React.createClass({
  propTypes: {
    categories: React.PropTypes.array.isRequired,
    currentPath: React.PropTypes.string,
    onCategoryChanged:React.PropTypes.func
  },
  breakDownTaxonomy(taxPath) {
    return taxPath.split('//');
  },
  getDisplayValue(taxPath, index) {
    let splitTax = this.breakDownTaxonomy(taxPath);
    if (index == undefined) {
      index = splitTax.length - 1;
    }

    return splitTax[index];
  },
  getItem(category, indented) {
    if (RA.KBSearch.showBrowseHits) {
		return this.withHitCount(category, indented);
	} else {
		return this.withoutHitCount(category, indented);
	}
  },
  withHitCount(category, indented) {
	 let className = classNames("filter__item", {"-in2" : indented});
	 return (
      <li className={className} key={category.value}>
        <a href="#" className="filter__link" onClick={this.categoryClicked.bind(this, category.value)}>{this.getDisplayValue(category.value)}</a>
		&nbsp;<span class="text-muted">({category.hits})</span>
      </li>
    )
  },
  withoutHitCount(category, indented) {
	 let className = classNames("filter__item", {"-in2" : indented});
	 return (
      <li className={className} key={category.value}>
        <a href="#" className="filter__link" onClick={this.categoryClicked.bind(this, category.value)}>{this.getDisplayValue(category.value)}</a>
      </li>
    )
  },
  hasCurrentPath() {
    let currentPath = this.props.currentPath;
    return currentPath && currentPath.length;
  },
  getCurrentPathItems() {
    if (!this.hasCurrentPath()) return;

    let currentPath = this.props.currentPath;
    let items = [];

    // all categories
    items.push((
      <li className="filter__item" key="all">
        <a href="#" className="filter__link -back icon-link" onClick={this.categoryClicked.bind(this, "")}>
          <i className="glyphicon glyphicon-menu-left"> </i><span className="icon-link__text">{Labels.getLabel("All Categories")}</span>
        </a>
      </li>
    ));

    let paths = this.breakDownTaxonomy(currentPath);

    // all paths from start up to current path
    // Sage, starting array at 1 to avoid the blank item at the start of the list.
    for (let i = 1; i < paths.length - 1; i++) {
      let path = paths.slice(0, i + 1).join("//");

      items.push((
        <li className="filter__item" key={path}>
          <a href="#" className="filter__link -back icon-link" onClick={this.categoryClicked.bind(this, path)}>
            <i className="glyphicon glyphicon-menu-left"> </i><span className="icon-link__text">{paths[i]}</span>
          </a>
        </li>
      ));
    }

    // current path category name
    items.push(<li className="filter__item -in1 -active" key={currentPath}>{paths[paths.length - 1]}</li>);

    return items;
  },
  categoryClicked(category) {
    if (this.props.onCategoryChanged) {
      this.props.onCategoryChanged(category);
    }
  },

  render() {
    let categories = this.props.categories;

    if (categories.length == 0 && !this.hasCurrentPath()) {
      return <span />
    }

    let currentPathItems = this.getCurrentPathItems();
    let indented = this.hasCurrentPath();
    let items = categories.map(cat => this.getItem(cat, indented));

    return (
      <BrowseFilter title={Labels.getLabel("Categories")} filterType="filter-type__category" ariaLabel="Solution Category filter" isOpen={this.props.isOpen}>
        <CollapsingFilterList
          defaultItems={currentPathItems}
          items={items} />
      </BrowseFilter>
    )
  }
});

// === ChangeUserPasswordForm.js ===
var ChangeUserPasswordForm = React.createClass({
  propTypes: {
    user: React.PropTypes.object.isRequired,
    onSaveDone: React.PropTypes.func.isRequired,
    onCancel: React.PropTypes.func.isRequired
  },
  getInitialState() {
    return {
      currentPassword: "",
      password: "",
      confirm: ""
    }
  },
  inputChanged(e) {
    let key = e.target.getAttribute("name");
    let o = {};
    o[key] = e.target.value;
    this.setState(o);
  },
  saveClicked(e) {
    e.preventDefault();

    if (!this.validateForm()) return;

    let data = {
      currentPassword: this.state.currentPassword,
      password: this.state.password,
      SToken: Config.csrf.value
    };

    let url = `${Config.contextPath}/controller/save/userprofile/`;
    $.post(url, data)
      .done(r => {
        if (r.success) {
          this.props.onSaveDone(r.user);
        } else {
          this.showError(r.message);
        }
      });
  },
  validateForm() {
    let {
      currentPassword,
      password,
      confirm
    } = this.state;

    this.clearError();

    if (RA.Utils.isBlank(currentPassword)) {
      this.showError(Labels.getLabel("Enter your current password"));
      return false;
    }

    if (RA.Utils.isBlank(password)) {
      this.showError(Labels.getLabel("Enter your new password"));
      return false;
    }

	if (!RA.Utils.isValidPwdCharacters(password)) {
      this.showError(Labels.getLabel("Values cannot contain <,> or %."));
      return false;
    }

    if (password != confirm) {
      this.showError(Labels.getLabel("Passwords do not match."));
      return false;
    }

    return true;
  },
  clearError() {
    this.setState({errorMessage: ""});
  },
  showError(message) {
    this.setState({errorMessage: message});
    window.scrollTo(0, this.refs.form.offsetTop);
    $(this.refs.errorWrap).hide().fadeIn("fast");
  },
  renderError() {
    if (RA.Utils.isNotBlank(this.state.errorMessage)) {
      return  (
        <div ref="errorWrap">
          <AlertMessage alertType="danger">
            <strong>{Labels.getLabel("Error")}:</strong>
            {" " + this.state.errorMessage}
          </AlertMessage>
        </div>
      )
    }
  },
  render() {
    return (

      <form onSubmit={this.saveClicked} ref="form">
        <h2 className="form__title">{Labels.getLabel("Change Password")}</h2>

        {this.renderError()}

        <div className="form-group has-float-label">
          <input type="password" autocomplete="new-password" id="profileCurrentPassword" className="form-control" name="currentPassword"
            maxLength="50" onChange={this.inputChanged} value={this.state.currentPassword} placeholder="&nbsp;"/>
          <label htmlFor="profileCurrentPassword">{Labels.getLabel("Current Password")}</label>
        </div>

        <div className="form-group has-float-label">
          <input type="password" autocomplete="new-password" id="profilePassword" className="form-control" name="password"
            maxLength="50" onChange={this.inputChanged} value={this.state.password} placeholder="&nbsp;"/>
          <label htmlFor="profilePassword">{Labels.getLabel("New Password")}</label>
        </div>

        <div className="form-group has-float-label">
          <input type="password" autocomplete="new-password" id="profileConfirmPassword" className="form-control" name="confirm"
            maxLength="50" onChange={this.inputChanged} value={this.state.confirm} placeholder="&nbsp;"/>
          <label htmlFor="profileConfirmPassword">{Labels.getLabel("Confirm Password")}</label>
        </div>

        <div className="text-right">
          <button type="submit" className="btn btn-primary" onClick={this.saveClicked}>{Labels.getLabel("Save")}</button>
          {" "}
          <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{Labels.getLabel("Cancel")}</button>
        </div>
      </form>
    );
  }
});

// === ChildDelimited.js ===
var ChildDelimited = React.createClass({
  propTypes: {
    delimiter: React.PropTypes.node,
    className: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      delimiter: " | ",
      className: ""
    }
  },
  getDelimiter(i) {
    let {delimiter} = this.props;
    let key = `delimiter${i}`;

    if (React.isValidElement(delimiter)) {
      return React.cloneElement(delimiter, {key: key})
    } else {
      return <span key={key}>{delimiter}</span>
    }
  },
  render() {
    let children = React.Children.toArray(this.props.children);
    let items = [];

    children.forEach((child, i) => {
      items.push(child);
      if (i < children.length - 1) {
        items.push(this.getDelimiter(i));
      }
    });

    return (
      <div className={this.props.className}>
        {items}
      </div>
    )
  }
})

// === ClearFilters.js ===
var ClearFilters = React.createClass({
    propTypes: {
        resetFiltersClicked: React.PropTypes.func
    },
    render() {
        if (!Config.enableClearFilterOption) return null;
        return (
            <a role="button" className="text-uppercase" href="#" onClick={this.props.resetFiltersClicked}>{Labels.getLabel("Clear Filter")}</a>
        )
    }
});

// === CollapsingFilterList.js ===
var CollapsingFilterList = React.createClass({
  propTypes: {
    items: React.PropTypes.array,
    defaultItems: React.PropTypes.array,
    displayBeforeFold: React.PropTypes.number,
    isInitiallyExpanded: React.PropTypes.bool,
    listClassName: React.PropTypes.string,
  },
  getDefaultProps() {
    return {
      items: [],
      displayBeforeFold: 4,
      isInitiallyExpanded: false,
      listClassName: "filter__list"
    }
  },
  getInitialState() {
    return {
      expanded: this.props.isInitiallyExpanded
    }
  },
  componentWillReceiveProps(nextProps) {
    this.setState({expanded: this.props.isInitiallyExpanded});
  },
  moreClicked(e) {
    this.setState({expanded: true});
  },
  lessClicked() {
    this.setState({expanded: false});
    window.scrollTo(0, $(this.refs.list).offset().top);
  },
  getMoreList(items) {
    return (
      <div>
        <ul className={this.props.listClassName}>
          {items}
        </ul>
      </div>
    )
  },
  getLessLink(visible = true) {
    // Link will always be in DOM, and use style to control visibility
    // Addresses issue with ResponsiveFilterColumn closing when clicking these links because they are removed
    // from the DOM and no longer detected as children of the filter column.
    return (
      <a href="#"
        className="icon-link"
        style={{display: visible ? "" : "none"}}
        onClick={this.lessClicked}>
        <span>{"- "}</span><span className="icon-link__text">{Labels.getLabel("See Less")}</span>
      </a>
    )
  },
  getMoreLink(visible = true) {
    // Link will always be in DOM, and use style to control visibility
    // Addresses issue with ResponsiveFilterColumn closing when clicking these links because they are removed
    // from the DOM and no longer detected as children of the filter column.
    return (
      <a href="#"
        className="icon-link"
        style={{display: visible ? "" : "none"}}
        onClick={this.moreClicked}>
        <span>{"+ "}</span><span className="icon-link__text">{Labels.getLabel("See more")}</span>
      </a>
    )
  },

  render() {
    let items = this.props.items || [];
    let beforeFoldIndex = Math.min(this.props.displayBeforeFold, items.length);
    let beforeFoldItems = items.slice(0, beforeFoldIndex);
    let hasMoreItems = items.length > beforeFoldIndex;
    let afterFoldItems;
    let moreLink;
    let lessLink;
    let moreList;

    if (hasMoreItems) {
      if (this.state.expanded) {
        afterFoldItems = items.slice(beforeFoldIndex);
        moreList = this.getMoreList(afterFoldItems);

        moreLink = this.getMoreLink(false);
        lessLink = this.getLessLink();
      } else {
        moreLink = this.getMoreLink();
        lessLink = this.getLessLink(false);
      }
    }

    return (
      <div>
        <ul className={this.props.listClassName} ref="list">
          {this.props.defaultItems}
          {beforeFoldItems}
        </ul>

        {moreLink}

        {moreList}

        {lessLink}
      </div>
    )
  }
});

// === CollectionFilter.js ===
var CollectionFilter = React.createClass({
  propTypes: {
    customCollections: React.PropTypes.array.isRequired,
    selectedCollections: React.PropTypes.arrayOf(React.PropTypes.string),
    onCollectionsChanged: React.PropTypes.func,
	showCollectionFilter: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      selectedCollections: [],
	  showCollectionFilter: false
    }
  },
  collectionClicked(code) {
    let checkedCollections = this.props.selectedCollections;
    let isSelected = this.isCollectionSelected(code);

    if (!isSelected) {
      checkedCollections.push(code);
    } else {
      checkedCollections = checkedCollections.filter(val => val != code);
    }

    if (this.props.onCollectionsChanged) {
      this.props.onCollectionsChanged(checkedCollections);
    }
  },
  isCollectionSelected(code) {
    return this.props.selectedCollections.indexOf(code) != -1;
  },
  getItem(coll) {
    let productLabel = coll.code.replace("custom_", "productLabel_");

    return (
      <li className="filter__item" key={coll.code}>
        <RACheck label={Labels.getLabel(productLabel)}
          value={coll.code}
          isChecked={this.isCollectionSelected(coll.code)}
          onClick={this.collectionClicked} />
      </li>
    )
  },
  render() {
    let { showCollectionFilter } = this.props;
    if (!showCollectionFilter || this.props.customCollections.length == 0) {
      return <span />
    }

    let selectedItems = [];
    let otherItems = [];

    for (let i = 0; i <  this.props.customCollections.length; i++) {
      if (this.isCollectionSelected(this.props.customCollections[i].code)) {
        selectedItems.push(this.getItem(this.props.customCollections[i]));
      } else {
        otherItems.push(this.getItem(this.props.customCollections[i]));
      }
    }

    return (
      <BrowseFilter title={this.props.title ? this.props.title : Labels.getLabel("Collections")} filterType="filter-type__collection" ariaLabel="Solution Collections filter" isOpen={this.props.isOpen}>
        <CollapsingFilterList
          defaultItems={selectedItems}
          displayBeforeFold="8"
          items={otherItems}
        />
      </BrowseFilter>
    )
  }
});

// === CommDidYouMean.js ===
var CommDidYouMean = React.createClass({
  propTypes: {
    didYouMean: React.PropTypes.string
  },
  submitDidYouMeanSearch() {
    RA.SearchBar.setSearchText(this.props.didYouMean);

	let searchForm = $(".main-search__form");
	searchForm.submit();
  },
  render() {
    if (this.props.didYouMean === '') {
      return <span />
    }

    return (
		<div className="commDidYouMean">
			{Labels.getLabel("Did You Mean")}:&nbsp;
			<a href="#" className="text-muted" onClick={this.submitDidYouMeanSearch}>
				{this.props.didYouMean}
			</a>
		</div>
    );
  }
});




// === CommResultItem.js ===
var CommResultItem = React.createClass({
  propTypes: {
    hit: React.PropTypes.object.isRequired,
    showIcon: React.PropTypes.bool,
    showAuthor: React.PropTypes.bool,
    showCommunityPath: React.PropTypes.bool,
    showAnswerStatus: React.PropTypes.bool,
    showReplyCount: React.PropTypes.bool,
    showDate: React.PropTypes.bool,
    size: React.PropTypes.oneOf(["sm", ""])
  },
  getDefaultProps() {
    return {
      showIcon: true,
      showAuthor: true,
      showCommunityPath: true,
      showAnswerStatus: true,
      showReplyCount: true,
      showDate: true,
      size: ""
    }
  },
  getReplyCount() {
    let count = this.props.hit.discussion.answerCount;
    let label = Labels.getLabel("replies");
    let className = "";

    if (count == 0) {
      className = "text-danger";
    } else if (count == 1) {
      label = Labels.getLabel("reply");
    }

    return <span className={className}>{count} {label}</span>;
  },
  getAnswerStatus() {
    if (this.props.hit.discussion.answered) {
      return <span className="text-success"><span className="glyphicon glyphicon-ok"></span> {Labels.getLabel("Answered")}</span>;
    } else {
      return <span><span className="glyphicon glyphicon-question-sign"></span> {Labels.getLabel("Unanswered")}</span>
    }
  },
  getDate() {
    let discussion = this.props.hit.discussion;
    let date, label;

    if (discussion.answerCount > 0) {
      label = Labels.getLabel("Last reply");
      date = discussion.lastReplyDateDisplay;
    } else {
      label = Labels.getLabel("Asked");
      date = discussion.askedDateDisplay;
    }

    return <span>{`${label} ${date}`}</span>;
  },
  getAuthor() {
    let {hit} = this.props;
    let profileText = hit.member.initials;
    let isUserActive = hit.member.active && !hit.member.archived;
    let avatarPath = Config.contextPath + RA.defaultAvatar(isUserActive ? hit.member.avatar : '');
    console.log("Is User Active" + isUserActive);

    return <span>
    {Labels.getLabel("By")}{" "}
      <span className="user-image -xs">
        {RA.Utils.isNotBlank(this.props.hit.member.avatar) && isUserActive ? (
          <img src={avatarPath} alt="" className="user-image__avatar" />
        ) : profileText && isUserActive? (
          <div className="profile-section-avatar-text user-avatar-size">{profileText}</div>
        ) : (
          <img src={avatarPath} alt="" className="user-image__avatar" />
        )}
      </span>
    {" " + hit.member.username}
  </span>
  },
  getCommunityPath() {
    let hit = this.props.hit;
    let communityUrl = `${Config.contextPath}/${Config.portalInterface}/?tabname=community&communityID=${hit.community.id}`;
    let topicUrl = `${Config.contextPath}/${Config.portalInterface}/?tabname=community&communityID=${hit.community.id}&topicID=${hit.topic.id}`;

    return (
      <span>
        in <span className="view-link__path"><a href={communityUrl}>{hit.community.name}</a> &gt; <a href={topicUrl}>{hit.topic.name}</a></span></span>
    )
  },
  renderLine1() {
    let {
      showAuthor,
      showCommunityPath
    } = this.props;

    if (!showAuthor && !showCommunityPath) return;

    let author, communityPath;
    if (showAuthor) author = this.getAuthor();
    if (showCommunityPath) communityPath = this.getCommunityPath();

    return (
      <div className="view-link__sub-line">
        {author}
        {" "}{communityPath}
      </div>
    )
  },
  renderLine2() {
    let {
      showAnswerStatus,
      showReplyCount,
      showDate
    } = this.props;

    if (!showAnswerStatus && !showReplyCount && !showDate) return;

    let answerStatus, replyCount, date;
    if (showAnswerStatus) answerStatus = this.getAnswerStatus();
    if (showReplyCount) replyCount = this.getReplyCount();
    if (showDate) date = this.getDate();

    return (
      <ChildDelimited className="view-link__sub-line">
        {answerStatus}
        {replyCount}
        {date}
      </ChildDelimited>
    )
  },
  renderIcon() {
    if (this.props.showIcon) {
      let hit = this.props.hit;

      return (
        <div className={"view-link__icon " + (hit.discussion.answered ? "-success" : "-muted")}>
          <i className="glyphicon glyphicon-comment"></i>
        </div>
      )
    }
  },
  openLink(e) {
	let {hit, size } = this.props;
    let viewUrl = `${Config.contextPath}/controller/view/discussion/${hit.discussion.id}?` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;

	if (launchLinksInNewWindow) {
		e.preventDefault();
		RA.Utils.openCenteredWindow(viewUrl, '1100', '800');
	}
  },
  render() {
    let {
      hit,
      size
    } = this.props;
    let viewUrl = `${Config.contextPath}/controller/view/discussion/${hit.discussion.id}?` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
    let className = classNames("view-link",  {[`-${size}`]: size.length});


    return (
      <li className={className}>
        {this.renderIcon()}
        <div className={this.props.showIcon ? "view-link__content" : ""}>
          <a onClick={this.openLink} href={viewUrl} className="view-link__title">{hit.discussion.title}</a>
          <div className="view-link__subhead">
            {this.renderLine1()}
            {this.renderLine2()}
          </div>
        </div>
      </li>
    )
  }
})

// === CommResults.js ===
var CommResults = React.createClass({
  propTypes: {
    searchResults: React.PropTypes.object.isRequired,
    filterData: React.PropTypes.object.isRequired,
    eventHandler: React.PropTypes.func.isRequired
  },
  pageClicked(num) {
    this.props.eventHandler({actionType: 'pageClicked', num: num});
  },
  sortChanged(sortKey, index) {
    this.props.eventHandler({actionType: 'sortChanged', sortKey: sortKey});
  },
  answerStatusChanged(statusCode) {
    this.props.eventHandler({actionType: 'answerStatusChanged', statusCode: statusCode});
  },
  communityChanged(commID) {
    this.props.eventHandler({actionType: 'communityChanged', communityID: commID});
  },
  topicChanged(topicID) {
    this.props.eventHandler({actionType: 'topicChanged', topicID: topicID});
  },
  tagsChanged(tagIDs) {
    this.props.eventHandler({actionType:'tagsChanged', tagIDs: tagIDs});
  },
  dateChanged(startDate, endDate) {
    this.props.eventHandler({actionType: 'dateChanged', startDate: startDate,
      endDate: endDate });
  },
  resetFiltersClicked() {
    this.props.eventHandler({actionType: 'resetFilters'});
    RA.KBSearch.commFilterApplied = false;
  },
  findSelectedSortIndex() {
    let {
      searchResults,
      filterData
    } = this.props;
    let querySortBy = searchResults.query.sortBy.toLowerCase();
    let queryDescending = searchResults.query.sortDescending;

    for (let i = 0; i < filterData.sortKeys.length; i++) {
      let sortKey = filterData.sortKeys[i];
      let thisSortBy = sortKey.key.toLowerCase();
      let thisDescending = sortKey.descending;

      if (thisDescending == undefined) thisDescending = true;

      if (thisSortBy == querySortBy && thisDescending == queryDescending) {
        return i;
      }
    }

    return 0;
  },
  paramToArray(paramName) {
    let val = RA.CommunitySearch.query[paramName];
    return typeof val == "string" ? val.split(";") : [];
  },
  paramToNumberArray(paramName) {
    return this.paramToArray(paramName).map(val => Number(val));
  },
  getPager() {
    let searchResults = this.props.searchResults;
    let pagerDetail = searchResults.pagerDetail;

    return searchResults.totalHits > 0 && pagerDetail.totalPages > 1 ?
          <ResultsPager pagerDetail={pagerDetail} onPageClicked={this.pageClicked} /> : null;
  },
  getResultsSection() {
    let {filterData, searchResults} = this.props;
	let didYouMean = searchResults.didyoumean;

    return (
      <div>
        <div className="result-col__head clearfix">
          <ResultCountSummary totalHits={searchResults.totalHits}
            pageStart={searchResults.pagerDetail.pageStart}
            pageEnd={searchResults.pagerDetail.pageEnd} />
          <ResultSort sortKeys={filterData.sortKeys}
            selectedIndex={this.findSelectedSortIndex()}
            onSortChanged={this.sortChanged} />
        </div>
	<CommDidYouMean didYouMean={didYouMean}/>
        <CommResultsList hits={searchResults.results} />
        {this.getPager()}
      </div>
    )
  },
  render() {
    let searchResults = this.props.searchResults;
	let didYouMean = searchResults.didyoumean;

    if (searchResults.totalHits == 0 && !RA.CommunitySearch.isFilterApplied()) {
		return (
			<div>
				<NoResults />
				<KBDidYouMean didYouMean={didYouMean}/>
			</div>
		)
    }

    let resultsContent = searchResults.totalHits == 0 ?
      <NoResults showResetFilters={true}
        onFilterResetClicked={this.resetFiltersClicked} /> : this.getResultsSection();

	let noResultDymSection = searchResults.totalHits == 0 ?
		<KBDidYouMean didYouMean={didYouMean}/> : '';

    return (
      <div className="row">
        <ResponsiveFilterColumn className="col-xs-12 col-sm-3 filter-col">
          {
            RA.KBSearch.CommFilterApplied ?
            <div className="filter clear-filter-container">
              <nav className="search-filters-section">
                <ul className="pagination">
                  <li><ClearFilters resetFiltersClicked={this.resetFiltersClicked} /></li>
                </ul>
              </nav >
            </div> : <div></div>
          }
          <AnswerStatusFilter onStatusChanged={this.answerStatusChanged}
            selectedStatusCode={RA.CommunitySearch.query.answered} />
          <CommTopicFilter communities={searchResults.communities}
            topics={searchResults.topics}
            selectedCommunityID={RA.CommunitySearch.query.communityID}
            selectedTopicID={RA.CommunitySearch.query.topicID}
            onCommunityChanged={this.communityChanged}
            onTopicChanged={this.topicChanged} />
          <TagFilter tags={searchResults.tags}
            selectedTagIDs={this.paramToNumberArray("tags")}
            onTagsChanged={this.tagsChanged} />
          <DateFilter searchDates={this.props.filterData.searchDates}
            selectedStartDate={RA.CommunitySearch.query.beginLastModDate}
            onDateChanged={this.dateChanged} />
        </ResponsiveFilterColumn>
        <section className="col-xs-12 col-sm-9 result-col">
          {resultsContent}
		  {noResultDymSection}
        </section>
      </div>
    )
  }
});

// === CommResultsList.js ===
var CommResultsList = React.createClass({
  propTypes: {
    hits: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
  },
  render() {
    if (this.props.hits.length == 0) {
      return <span />
    }

    return (
      <ul className="solution-list">
        {this.props.hits.map(hit => <CommResultItem key={hit.discussion.id} hit={hit} {...this.props} />)}
      </ul>
    )
  }
});

// === CommSummary.js ===
var CommSummary = React.createClass({
  propTypes: {
    searchResults: React.PropTypes.object.isRequired,
    eventHandler: React.PropTypes.func.isRequired,
    resultCount: React.PropTypes.number,
    categoryCount: React.PropTypes.number
  },
  getDefaultProps() {
    return {
      resultCount: 5,
      categoryCount: 2
    }
  },
  communityClicked(id) {
    this.props.eventHandler({actionType: 'communityChanged', communityID: id});
    this.showCommunityTab();
  },
  showCommunityTab() {
    RA.ResultsPage.showTab("#commResults");
  },
  getSummaryHits() {
    let results = this.props.searchResults.results;
    let ubound = Math.min(results.length, this.props.resultCount);

    return results.slice(0, ubound);
  },
  getSummaryCommunities() {
    let communities = this.props.searchResults.communities;

    // sort affects other components using this variable - use map, then sort instead
    //communities.sort((a, b) => b.hits - a.hits);

    // convert to map of array {index, hit count}
    let hitCounts = communities.map((cat, i) => {
      return {index: i, count: cat.hits }
    });

    // sort by hit count - descending
    hitCounts.sort((a, b) => b.count - a.count);

    // get slice
    let ubound = Math.min(hitCounts.length, this.props.categoryCount);
    hitCounts = hitCounts.slice(0, ubound);

    // return array of communities with index position from the hitCount array
    return hitCounts.map(hitCount => {
      return communities[hitCount.index];
    });
  },
  renderSummary() {
    let { searchResults } = this.props;

    if (searchResults.totalHits == 0) {
      return <NoResults />
    }

    let resultsLabel = searchResults.totalHits == 1 ? "result" : "results";
	let didYouMean = searchResults.didyoumean;

    return (
      <div>
        <div className="result-summary__stats">
          <span className="text-muted">{`${searchResults.totalHits} ${resultsLabel} - `}</span>
          <a href="#" className="text-muted" onClick={this.showCommunityTab}>
            {Labels.getLabel("Show All")}
          </a>
		  <CommDidYouMean didYouMean={didYouMean}/>
        </div>
        <CommResultsList hits={this.getSummaryHits()} showAuthor={false} showCommunityPath={false} />
        <CommSummaryCommunities communities={this.getSummaryCommunities()}
          onCommunityClicked={this.communityClicked} />
      </div>
    )
  },

  render() {
     return (
      <div>
        <h3 className="result-summary__head">
          <a href="#" className="result-summary__head-link -comm" onClick={this.showCommunityTab}>
            <i className="glyphicon glyphicon-comment result-summary__head-icon"></i>
            {Labels.getLabel("Communities")}
          </a>
        </h3>

        {this.renderSummary()}
      </div>
    )
  }
});

// === CommSummaryCommunities.js ===
var CommSummaryCommunities = React.createClass({
  propTypes: {
    communities: React.PropTypes.arrayOf(React.PropTypes.object),
    onCommunityClicked: React.PropTypes.func,
  },
  getDefaultProps() {
    return {
      communities: []
    }
  },
  communityClicked(id) {
    if (this.props.onCommunityClicked) {
      this.props.onCommunityClicked(id);
    }
  },
  renderItem(community) {
    return (
        <li className="" key={community.id}>
          <a href="#" onClick={this.communityClicked.bind(this, community.id)}>{community.name}</a> <span className="text-muted">({community.hits})</span>
        </li>
      )
  },

  render() {
    if (this.props.communities.length == 0) {
      return <div></div>;
    }

    let items = this.props.communities.map(this.renderItem);

    return (
      <div className="cat-matches">
        <h3 className="cat-matches__title">{Labels.getLabel("Show results in these communities")}:</h3>
        <ul className="cat-matches__list bullet-list">
          {items}
        </ul>
      </div>
    )
  }
});

// === CommTopicFilter.js ===
var CommTopicFilter = React.createClass({
  propTypes: {
    communities: React.PropTypes.arrayOf(React.PropTypes.object),
    topics: React.PropTypes.arrayOf(React.PropTypes.object),
    selectedCommunityID: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    selectedTopicID: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    onCommunityChanged: React.PropTypes.func,
    onTopicChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      communities: [],
      topics: [],
      selectedCommunityID: 0,
      selectedTopicID: 0
    }
  },
  communityChanged(id) {
    if (this.props.onCommunityChanged) {
      this.props.onCommunityChanged(id);
    }
  },
  topicChanged(id) {
    if (this.props.onTopicChanged) {
      this.props.onTopicChanged(id);
    }
  },
  showCommunities() {
    return this.props.selectedCommunityID == 0;
  },
  getItems() {
    if (this.showCommunities()) {
      return this.getCommunityItems();
    } else {
      return this.getTopicItems();
    }
  },
  getCommunityItems() {
    return this.props.communities.map(comm => {
      return (
        <li className="filter__item" key={comm.id}>
          <a href="#" className="filter__link" onClick={this.communityChanged.bind(this, comm.id)}>{comm.name}</a>
        </li>
      )
    })
  },
  getTopicItems() {
    if (this.props.selectedTopicID != 0) return null;

    return this.props.topics.map(topic => {
      return (
        <li className="filter__item -in2" key={topic.id}>
          <a href="#" className="filter__link" onClick={this.topicChanged.bind(this, topic.id)}>{topic.name}</a>
        </li>
      )
    })
  },
  getDefaultItems() {
    if (this.props.selectedCommunityID == 0) return null;

    let allCommunities =  (
      <li className="filter__item" key="_all">
        <a href="#" className="filter__link -back icon-link" onClick={this.communityChanged.bind(this, "")}>
          <i className="glyphicon glyphicon-menu-left"> </i><span className="icon-link__text">{Labels.getLabel("All Communities")}</span>
        </a>
      </li>
    )

    let isCommunityActive = this.props.selectedTopicID == 0;
    let comm = this.props.communities[0];
    let communityItem;

    if (isCommunityActive) {
      communityItem = <li className="filter__item -in1 -active" key="_activeComm">{comm.name}</li>
    } else {
      communityItem = (
        <li className="filter__item" key="_allTopics">
          <a href="#" className="filter__link -back icon-link" onClick={this.topicChanged.bind(this, "")}>
            <i className="glyphicon glyphicon-menu-left"> </i><span className="icon-link__text">{comm.name}</span>
          </a>
        </li>
      )
    }

    let items = [ allCommunities, communityItem ];

    let topic = this.props.topics[0];
    let topicItem;

    if (!isCommunityActive) {
      topicItem = <li className="filter__item -in1 -active" key="_activeTopic">{topic.name}</li>
      items.push(topicItem);
    }

    return items;
  },
  render() {
    if (this.props.communities.length == 0) {
      return <span />;
    }

    let items = this.getItems();
    let defaultItems = this.getDefaultItems();

    return (
      <BrowseFilter title={Labels.getLabel("Communities")}>
        <CollapsingFilterList
          defaultItems={defaultItems}
          items={items} />
      </BrowseFilter>
    )
  }
});

// === Comment.js ===
var Comment = React.createClass({
  propTypes: {
    comment: React.PropTypes.object.isRequired,
    onReplySaved: React.PropTypes.func.isRequired,
    showReplyLink: React.PropTypes.bool,
    currentUserID: React.PropTypes.number,
    isResolutionAllowed: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      showReplyLink: false
    }
  },
  getInitialState() {
    return {
      showReplyBox: false
    }
  },
  replyClicked() {
    this.setState({showReplyBox: !this.state.showReplyBox});
  },
  replySaved(comment) {
    this.props.onReplySaved(comment);
    this.setState({showReplyBox: false});
  },
  replyBlock() {
    if (this.props.showReplyLink) {
      let replyLabel = this.state.showReplyBox ? Labels.getLabel("Cancel") : Labels.getLabel("Reply");
      return (
          <div className="comment__actions">
            <a href="#" className="comment__action-link" onClick={this.replyClicked}>{replyLabel}</a>
          </div>
      );
    } else {
      return (<span></span>);
    }
  },
  resolveComment(comment, isResolved) {
    if (isResolved) {
      let data = {
        commentID: comment.id, solutionID: RA.ViewKB.solution.id, SToken: Config.csrf.value
      }
      RAResolveComment.init(data);
    } else {
      let url = Config.contextPath + "/controller/resolveComment/solution/comment/";
      let data = {
        SToken: Config.csrf.value,
        solutionID: RA.ViewKB.solution.id,
        commentID: comment.id,
        isResolved: isResolved
      };

      $.post(url, data)
          .done(r => {
            RA.ViewKB.Comments.load(RA.ViewKB.Comments.currentPage);
          });
    }
  },
  render: function () {
    let comment = this.props.comment;
    let replies = comment.replies.map(r =>
      <Comment key={r.id}
        comment={r}
        showReplyLink={!r.isParentCommentResolved}
        onReplySaved={this.replySaved}/>
    );
    let resolvedComment = comment.resolvedComment,
        replyLink,
        commentBox;

    if (comment.parentID === 0 && resolvedComment != null) {
      if (resolvedComment.resolved) {
        if (this.props.isResolutionAllowed && comment.userID === this.props.currentUserID) {
          replyLink = (
            <div className="comment__actions">
              <a href="#" className="comment__action-link" onClick={() => this.resolveComment(comment, false)}>Unresolve</a>
            </div>
          );
        } else {
          replyLink = (
              <div className="comment__actions"><br/></div>
          );
        }
      } else {
        replyLink = this.replyBlock();
      }
    } else {
      replyLink = this.replyBlock();
    }

    if (this.state.showReplyBox) {
      commentBox = (
        <div className="comment__reply-wrap">
          <CommentBox
            parentID={comment.id}
            buttonLabel={Labels.getLabel("Post Reply")}
            placeholder={Labels.getLabel("Reply to this comment")}
            onCommentSaved={this.replySaved}
            sizeModifier="sm" />
        </div>
      )
    }

    let commentText = comment.comment.replace(/(\r?\n)/g, "<br>$1");
    let profileImagePath = comment.profileImagePath;
    let avatarPath = RA.defaultAvatar(profileImagePath);
    let showAvatar = Boolean(comment.showAvatar);
    let profileText = comment.profileText;

    let resolvedBlock;

    if (comment.parentID === 0 && resolvedComment != null) {
      if (!resolvedComment.resolved) {
        if (this.props.isResolutionAllowed && comment.userID === this.props.currentUserID) {
          resolvedBlock = (
              <a href="#" className="resolve-btn" onClick={() => this.resolveComment(comment, true)}><i
                  className="glyphicon glyphicon-check unresolved-mark-style"></i></a>
          );
        } else {
          resolvedBlock = (<span></span>);
        }
      } else {
        resolvedBlock = (
            <div>
              <i className="glyphicon glyphicon-check resolved-mark-style" title={"Resolved by: " + resolvedComment.resolvedBy}></i>
              <span className="text-success resolved-text">Resolved</span>
            </div>
        );
      }
    } else {
      resolvedBlock = (<span></span>);
    }

    $(window).on('load', function() {
      var url = window.location.href;
      var id = url.substring(url.lastIndexOf('#'));
      if(id !== null && id !== url) {
        var element = $(id);
        if (element.length > 0) {
          $('html, body').animate({
            scrollTop: $(id).offset().top - 150
          }, 'fast');
        }
      }
    });

    const renderProfileImage = () => {
      if (showAvatar && RA.Utils.isNotBlank(profileImagePath)) {
        return (<div className="user-image -sm pull-left">
          <img src={Config.contextPath + avatarPath} alt="" className="user-image__avatar"/>
          {resolvedBlock}
        </div>)
      } else if (showAvatar && RA.Utils.isNotBlank(profileText)) {
        return (<div className="user-image -sm pull-left">
          <span className="avatar-text-comment user-image__avatar">{profileText}</span>
          {resolvedBlock}
        </div>)
      } else {
        return (<div className="user-image -sm pull-left">
          <img src={Config.contextPath + avatarPath} alt="" className="user-image__avatar"/>
          {resolvedBlock}
        </div>)
      }
    }

    return (
        <div className="comment">
          {renderProfileImage()}
          <div className="comment__wrap">
            <div className="comment__title">
              <span className="comment__username">{comment.username}</span>
              <time className="comment__time" dateTime={comment.date}> - {comment.friendlyDate}</time>
            </div>
            <div className="comment-href">
              <a href={"#comment" + comment.id}>
                <div id={"comment" + comment.id} className="comment__content">
                  <p dangerouslySetInnerHTML={{__html: commentText}}/>
                </div>
              </a>
            </div>

            {replyLink}

          </div>

          {commentBox}

          {replies}

        </div>
  );
  }
  });

// === CommentBox.js ===
var CommentBox = React.createClass({
  propTypes: {
    onCommentSaved: React.PropTypes.func.isRequired,
    parentID: React.PropTypes.number,
    buttonLabel: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    sizeModifier: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      parentID: 0,
      buttonLabel: Labels.getLabel("Post Comment"),
      placeholder: Labels.getLabel("Comment on this solution")
    }
  },
  getInitialState() {
    return {
      isOpen: false,
      errorMsg: ""
    }
  },
  submitClicked(e, mentionsMenu) {
    e.preventDefault();

    let commentText = this.refs.commentsText.value;
    if (commentText.trim().length == 0) {
      return;
    }

    var tempMentionedUsersList = mentionsMenu.getMentionedUsersList();
    var mentionedUsersList = "";
    for(var i = 0; i < tempMentionedUsersList.length; i++) {
      if (!commentText.includes("@" + tempMentionedUsersList[i].username)) {
        tempMentionedUsersList.splice(i, 1);
        continue;
      }
      var mentionedUser = tempMentionedUsersList[i].userID + "-" + tempMentionedUsersList[i].userSource;
      if (!mentionedUsersList.includes(mentionedUser)) {
        mentionedUsersList += mentionedUser + ",";
      }
    }

    let comment = {
      text: commentText,
      parentID: this.props.parentID,
      mentionedUsersList: mentionedUsersList
    };

    let postCommentButton = $(e.currentTarget);
    $(postCommentButton).attr("disabled", true);

    RA.ViewKB.Comments.add(comment, res => {
      if (res.success) {
        this.resetForm();
        this.props.onCommentSaved(comment);
        mentionsMenu.resetMentionedUsersList();
      } else {
        this.setState({errorMsg: res.message ? res.message : Labels.getLabel("Unknown error")});
      }

      $(postCommentButton).removeAttr("disabled");
    });
  },
  resetForm() {
    this.refs.commentsText.value = "";
    this.setState({ errorMsg: "", isOpen: false });
  },
  entryFocused() {
    this.setState({isOpen: true});
  },
  entryBlurred() {
    if (!this.refs.commentsText.value.length) {
      this.resetForm();
    }
  },
  onTextChange(mentionsMenu, text, searchTerm, cursorPosition) {
    if(text.length !== 0) {
      mentionsMenu.onInput(text, searchTerm, cursorPosition);
    }
  },
  resetComment(mentionsMenu) {
    if(this.refs.commentsText != null) {
      this.refs.commentsText.value = "";
    }
    mentionsMenu.closeMenu();
  },
  render() {
    let mentionsMenu = new Mentionify(
      document.getElementById('textarea' + this.props.parentID),
      document.getElementById('menu' + this.props.parentID),
      resolveFn,
      replaceFn,
      menuItemFn
    );

    //setup before functions
    var typingTimer;                //timer identifier
    var doneTypingInterval = 1000;  //time in ms (1 second)
    var textareaID = '#textarea'+ this.props.parentID;

    $(textareaID).click((e) => {
      mentionsMenu.closeMenu()
    })

    //on keyup, start the countdown
    $(textareaID).keyup((e) => {
      // get keycode of current keypress event
      const code = (e.keyCode || e.which);
      // do nothing if it's an up or down arrow key
      if(code == 38 || code == 40) {
          return;
      }
      clearTimeout(typingTimer);
      const textID = textareaID.substr(1);
      const input = document.getElementById(textID);
      if (input.value) {
          const text = input.value;
          const cursorPosition = input.selectionStart;
          
          // Find @ before cursor position
          const textBeforeCursor = text.substring(0, cursorPosition);
          const atPosition = textBeforeCursor.lastIndexOf("@");
          
          if (atPosition !== -1) {  // If @ exists before cursor
              let isMentionTrigger = false;
              
              // Check if @ is first character or has space/newline before it
              if (atPosition === 0 || text[atPosition - 1] === " " || text[atPosition - 1] === "\n") {
                  // Check if this @ is the one being currently typed
                  const textBetweenAtAndCursor = text.substring(atPosition + 1, cursorPosition);
                  if (!textBetweenAtAndCursor.includes(" ")) {
                      isMentionTrigger = true;
                  }
              }
              
              if (isMentionTrigger) {
                  const searchTerm = text.substring(atPosition + 1, cursorPosition).trim();
                  typingTimer = setTimeout(() => 
                      this.onTextChange(mentionsMenu, input.value, searchTerm, cursorPosition), 
                      doneTypingInterval
                  );
              } else {
                  mentionsMenu.closeMenu();
              }
          } else {
              mentionsMenu.closeMenu();
          }
      } else {
          mentionsMenu.closeMenu();
      }
  });

    var mentionsMenuTextarea = document.getElementById(textareaID.substr(1));
    window.onclick = function(event) {
      if (event.target !== mentionsMenuTextarea) {
        if(mentionsMenu.menuRef !== null) {
          mentionsMenu.closeMenu();
        }
      }
    }

    let focusElements,
      errorItem,
      inputMod = "",
      inputWrapMod = "",
      userImageMod = " -md";

    if (this.props.sizeModifier == "sm") {
      inputMod = " -sm";
      inputWrapMod = " -sm";
      userImageMod = " -sm";
    }

    if (this.state.isOpen) {
      inputMod += " -open";
      focusElements = (
        <div className="comment-form__input-footer">
          <button type="submit" className="btn btn-primary btn-sm" onClick={(event) =>  this.submitClicked(event, mentionsMenu)}>{this.props.buttonLabel}</button>
        </div>
      );
    }

    if (this.state.errorMsg.length) {
      errorItem = (
        <div className="alert alert-danger">
          <strong>{Labels.getLabel("Error")}:</strong>{" " + this.state.errorMsg}
        </div>
      );
    }

    let profileImagePath = RA.ViewKB.user.profileImage;
    let avatarPath = RA.defaultAvatar(profileImagePath);
    let profileText = RA.ViewKB.user.profileText;

    const renderProfileImage = () => {
      if (RA.Utils.isNotBlank(profileImagePath)) {
        return (
            <div className={"pull-left comment-form__user-image user-image" + userImageMod}>
              <img src={Config.contextPath + avatarPath} alt="" className="user-image__avatar"/>
            </div>
        );
      } else if (RA.Utils.isNotBlank(profileText)) {
        return (
            <div className={"pull-left comment-form__user-image user-image" + userImageMod}>
              <span className="avatar-text-comment user-image__avatar">{profileText}</span>
            </div>
        );
      } else {
        return (
            <div className={"pull-left comment-form__user-image user-image" + userImageMod}>
              <img src={Config.contextPath + avatarPath} alt="" className="user-image__avatar"/>
            </div>
        );
      }
    }

    return (
      <form className="comment-form">
        {errorItem}
        {renderProfileImage()}
        <div className={"comment-form__input-wrap" + inputWrapMod}>
          <textarea id={"textarea" + this.props.parentID} className={"comment-form__input" + inputMod}
            placeholder={this.props.placeholder}
            onFocus={this.entryFocused}
            onBlur={this.entryBlurred}
            ref="commentsText">
          </textarea>
          <div id={"menu"+ this.props.parentID} className="menu" role="listbox"></div>
          {focusElements}
        </div>
      </form>
    );
  }
});

// === CommentCountAction.js ===
var CommentCountAction = React.createClass({
  getDefaultProps() {
    return {
      count: 0
    }
  },
  linkClicked(e) {
    e.preventDefault();
    RA.ViewKB.Comments.scrollTo();
  },
  render() {
    let label = this.props.count < 2 ? Labels.getLabel("Comment") : Labels.getLabel("Comments"),
      count = this.props.count < 1 ? "" : this.props.count + " ";

    return (
      <a href="#comments" className="actions-list__link -comment" onClick={this.linkClicked} title={`${label}`}>
        <span className="glyphicon glyphicon-comment actions-list__icon"></span>
        <span>{` ${count} ${label}`}</span></a>
    )
  }
});

// === CommentsHead.js ===
var CommentsHead = React.createClass({
  propTypes: {
    totalComments: React.PropTypes.number
  },
  getDefaultProps() {
    return {
      totalComments: 0
    };
  },
  render() {
    let label = this.props.totalComments == 1 ? Labels.getLabel("Comment Thread") : Labels.getLabel("Comment Threads");

    return (
      <div className="comments__head">
        <h3 className="comments__title">
          <span className="glyphicon glyphicon-comment"></span>
          <span> {this.props.totalComments + " " + label}</span>
        </h3>
      </div>
    )
  }
});

// === CommentsList.js ===
var CommentsList = React.createClass({
  propTypes: {
    comments: React.PropTypes.arrayOf(React.PropTypes.object),
    onReplySaved: React.PropTypes.func.isRequired,
    showReplyLink: React.PropTypes.bool,
    currentUserID: React.PropTypes.number,
    isResolutionAllowed: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      comments: []
    }
  },
  render() {
    let comments = this.props.comments.map(c =>
      <Comment
        comment={c}
        key={c.id}
        showReplyLink={this.props.showReplyLink}
        onReplySaved={this.props.onReplySaved}
        currentUserID={this.props.currentUserID}
        isResolutionAllowed={this.props.isResolutionAllowed}/>
    );

    return (
      <div>
        {comments}
      </div>
    );
  }
});

// === CommunityShortcut.js ===
var CommunityShortcut = React.createClass({
  propTypes: {
    communities: React.PropTypes.array.isRequired,
  },
  getItem(comm) {
    let imagePath = Config.contextPath + (RA.Utils.isNotBlank(comm.image) ? comm.image : '/app/images/default-community.png');
    let url = `${Config.contextPath}/${Config.portalInterface}/?tabname=community&communityID=${comm.id}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
    let questionLabel = comm.hits == 1 ? "question" : "questions";
    let topicLabel = comm.topics.length == 1 ? "topic" : "topics";

    return (
      <div className="shortcut-panel__item" key={comm.id}>
        <a href={url} className="shortcut-panel__link">
          <div className="shortcut-panel__icon">
            <div className="shortcut-panel__image-wrap">
              <img src={imagePath} className="shortcut-panel__image" alt="" />
            </div>
          </div>
          <div className="shortcut-panel__label">
            {comm.name}
          </div>
        </a>
      </div>
    );
  },
  render() {
    let items = this.props.communities.map(this.getItem);

    return <div className="shortcut-panel__list">{items}</div>;
  }
});


// === CommunityTitle.js ===
var CommunityTitle = React.createClass({
  propTypes: {
    community: React.PropTypes.object.isRequired,
    className: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      className: "",
    };
  },
  render() {
    let comm = this.props.community;
    let imgPath = Config.contextPath + (RA.Utils.isNotBlank(comm.image) ? comm.image : "/app/images/default-community.png");

    return (
      <div className={"comm-title " + this.props.className}>
        <div className="comm-title__image-wrap -center">
          <img src={imgPath} className="comm-title__image" alt={comm.name} />
        </div>
        <div className="comm-title__content">
          <h2 className="comm-title__name">{comm.name}</h2>
          {this.props.children}
        </div>
      </div>
    )
  }
})

// === DateFilter.js ===
var DateFilter = React.createClass({
  propTypes: {
    searchDates: React.PropTypes.object.isRequired,
    selectedStartDate: React.PropTypes.string,
    onDateChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedStartDate: ""
    }
  },
  dateClicked(startDate) {
    let endDate = startDate.length ? this.props.searchDates.today.endDate : "";

    if (this.props.onDateChanged) {
      this.props.onDateChanged(startDate, endDate);
    }
  },
  render() {
    let {searchDates} = this.props;
    let items = [
      {label: Labels.getLabel("Any Time"),      value: ""},
      {label: Labels.getLabel("Today"),         value: searchDates.today.startDate},
      {label: Labels.getLabel("Past week"),     value: searchDates.pastWeek.startDate},
      {label: Labels.getLabel("Past month"),    value: searchDates.pastMonth.startDate},
      {label: Labels.getLabel("Past 6 months"), value: searchDates.pastSixMonths.startDate},
    ];

    return (
     <BrowseFilter title={Labels.getLabel("Modified Date")} filterType="filter-type__date" ariaLabel="Solution Modified Date filter" isOpen={this.props.isOpen}>
        <FilterLinkList
          items={items}
          selectedValue={this.props.selectedStartDate}
          onClick={this.dateClicked} />
      </BrowseFilter>
    )
  }
});

// === EditBasicUserForm.js ===
var EditBasicUserForm = React.createClass({
  propTypes: {
    user: React.PropTypes.object.isRequired,
    onSaveDone: React.PropTypes.func.isRequired,
    onCancel: React.PropTypes.func.isRequired
  },
  getInitialState() {
    let user = this.props.user;

    return {
      fname: user.firstName,
      lname: user.lastName,
      username: user.username,
      email: user.emailAddress,
      errorMessage: ""
    }
  },
  saveClicked(e) {
    e.preventDefault();

    if (!this.validateForm()) return;

    let data = {
      fname: this.state.fname,
      lname: this.state.lname,
      email: this.state.email,
      SToken: Config.csrf.value
    };

    let url = `${Config.contextPath}/controller/save/userprofile/`;
    $.post(url, data)
      .done(r => {
        if (r.success) {
          this.props.onSaveDone(r.user);
        } else {
          this.showError(r.message);
        }
      });
  },
  inputChanged(e) {
    let key = e.target.getAttribute("name");
    let o = {};
    o[key] = e.target.value;
    this.setState(o);
  },
  validateForm() {
    let {
      fname,
      lname,
      email,
      username
    } = this.state;

    this.clearError();

    if (RA.Utils.isBlank(fname)) {
      this.showError(Labels.getLabel("First name cannot be blank"));
      return false;
    }

    if (RA.Utils.isBlank(lname)) {
      this.showError(Labels.getLabel("Last name cannot be blank"));
      return false;
    }

    if (RA.Utils.isBlank(email)) {
      this.showError(Labels.getLabel("Email address cannot be blank"));
      return false;
    }

    var emailPattern = /^([a-zA-Z0-9_\.\-'!#\$%\&\*\+\/=\?\^`\{\}\|~])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,})+$/;
    if (!emailPattern.test(email)) {
      this.showError(Labels.getLabel("Email address does not appear to be valid"));
      return false;
    }

    return true;
  },
  clearError() {
    this.setState({errorMessage: ""});
  },
  showError(message) {
    this.setState({errorMessage: message});
    window.scrollTo(0, this.refs.form.offsetTop);
    $(this.refs.errorWrap).hide().fadeIn("fast");
  },
  renderError() {
    if (RA.Utils.isNotBlank(this.state.errorMessage)) {
      return  (
        <div ref="errorWrap">
          <AlertMessage alertType="danger">
            <strong>{Labels.getLabel("Error")}:</strong>
            {" " + this.state.errorMessage}
          </AlertMessage>
        </div>
      )
    }
  },
  render() {
    let {user} = this.props;

    return (
      <form onSubmit={this.saveClicked} ref="form">
        <h2 className="form__title">{Labels.getLabel("Edit Basic Info")}</h2>
        {this.renderError()}

        <div className="form-group has-float-label">
          <input type="text"
            id="profileFname"
            className="form-control"
            name="fname"
            maxLength="50"
            required={true}
            onChange={this.inputChanged}
            value={this.state.fname}
			placeholder="&nbsp;"/>
          <label htmlFor="profileFname">{Labels.getLabel("First Name")}</label>
        </div>

        <div className="form-group has-float-label">
          <input type="text"
            id="profileLname"
            className="form-control"
            name="lname"
            maxLength="50"
            required={true}
            onChange={this.inputChanged}
            value={this.state.lname}
			placeholder="&nbsp;"/>
          <label htmlFor="profileLname">{Labels.getLabel("Last Name")}</label>
        </div>

        <div className="form-group has-float-label">
          <input type="email"
            id="profileEmailAddress"
            className="form-control"
            name="email"
            maxLength="50"
            required={true}
            onChange={this.inputChanged}
            value={this.state.email}
			placeholder="&nbsp;"/>
          <label htmlFor="profileEmailAddress">{Labels.getLabel("Email Address")}</label>
        </div>

        <div className="text-right">
          <button type="submit" className="btn btn-primary" onClick={this.saveClicked}>{Labels.getLabel("Save")}</button>
          {" "}
          <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{Labels.getLabel("Cancel")}</button>
        </div>
      </form>
    );
  }
});

// === EditLinkToggle.js ===
var EditLinkToggle = React.createClass({
  propTypes: {
    editEnabled: React.PropTypes.bool.isRequired,
    onClick: React.PropTypes.func.isRequired,
    className: React.PropTypes.string
  },
  render() {
    let {
      editEnabled,
      className
    } = this.props;
    let children;

    if (this.props.editEnabled) {
      children = Labels.getLabel("Done");
    } else {
      children = (
        <span>
          <span className="glyphicon glyphicon-pencil"></span> <span className="icon-link__text">{Labels.getLabel("Edit")}</span>
        </span>
      )
    }

    return (
      <a href="#" className={classNames({"icon-link": !editEnabled}, {"btn btn-default": !editEnabled}, {"btn btn-primary": editEnabled}, className)} role="button" onClick={this.props.onClick}>
        {children}
      </a>
    )
  }
})

// === EditableListItem.js ===
var EditableListItem = React.createClass({
  propTypes: {
    showDelete: React.PropTypes.bool,
    showEdit: React.PropTypes.bool,
    onDelete: React.PropTypes.func,
    onEdit: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      showEdit: false,
      showDelete: false
    };
  },
  getInitialState() {
    return {
      isConfirmVisible: false
    };
  },
  componentWillReceiveProps(nextProps) {
    if (!nextProps.showDelete) {
      this.setState({isConfirmVisible: false});
    }
  },
  hasControls() {
    return this.props.showEdit || this.props.showDelete;
  },
  showConfirmDelete() {
    this.setState({isConfirmVisible: true});
  },
  hideConfirmDelete() {
    this.setState({isConfirmVisible: false});
  },
  deleteConfirmClicked(confirmed) {
    this.setState({isConfirmVisible: false});

    let {onDelete} = this.props;

    if (confirmed && onDelete) {
      onDelete();
    }
  },
  editClicked() {
    this.props.onEdit();
  },
  renderConfirm() {
    return (
      <div className="edit-item__controls">
        <div className="btn-group">
          <button
           type="button"
           className="btn btn-danger btn-xs"
		   aria-label={`${Labels.getLabel("Delete")}`} title={`${Labels.getLabel("Delete")}`}
           onClick={this.deleteConfirmClicked.bind(this, true)}>
           <i className="glyphicon glyphicon-trash"></i>
           {` ${Labels.getLabel("Delete")}`}
         </button>
          <button
            type="button"
            className="btn btn-default btn-xs"
            onClick={this.hideConfirmDelete}>
            <i className="fa fa-ban"></i>
          </button>
        </div>
      </div>
    );
  },
  renderControls() {
    if (this.state.isConfirmVisible) {
      return this.renderConfirm();
    }

    let {
      showEdit,
      showDelete,
    } = this.props;

    let deleteButton = showDelete ?
      <button
        type="button"
        className="btn btn-danger btn-xs"
		aria-label={`${Labels.getLabel("Delete")}`} title={`${Labels.getLabel("Delete")}`}
        onClick={this.showConfirmDelete}>
        <i className="glyphicon glyphicon-trash"></i>
      </button> : null;

    let editButton = showEdit ?
      <button
        type="button"
        className="btn btn-default btn-xs"
		aria-label={`${Labels.getLabel("Edit")}`} title={` ${Labels.getLabel("Edit")}`}
        onClick={this.editClicked}>
        <i className="glyphicon glyphicon-pencil"></i>
      </button> : null;

    return (
      <div className="edit-item__controls">
        <div className="btn-group">{editButton}{deleteButton}</div>
      </div>
    );
  },
  render() {
    let hasControls = this.hasControls();
    let content = hasControls ?
        <div className="edit-item__content">{this.props.children}</div> : this.props.children;

    return (
      <li className={classNames({"edit-item": hasControls, clearfix: hasControls})} >
        {hasControls ? this.renderControls() : null}
        {content}
      </li>
    )
  }
})


// === Favorite.js ===
var Favorite = React.createClass({
  requestPending: false,
  feedbackTimeout: null,
  getInitialState() {
    return {
      favorite: {}
    };
  },
  componentDidMount() {
    let url = Config.contextPath + "/controller/find/myfavorites/?solutionID=" + RA.ViewKB.solution.id;

    $.get(url)
      .done(r => {
        let favorite = r;
        this.setState({favorite: favorite});

        if (favorite.id && (favorite.description != RA.ViewKB.solution.title)) {
          this.updateFavorite();
        }
      });
  },
  favoriteClicked() {
    if (this.state.favorite.id) {
      this.removeFavorite();
    } else {
      this.addFavorite();
      RA.ViewKB.logAction("ADDFAVORITES");
    }
  },
  addFavorite() {
    if (this.requestPending) return;

    let url = Config.contextPath + "/controller/add/myfavorites/";

	let solutionUrl = window.location.href.split("?")[0] + "?solutionid=" + RA.ViewKB.solution.id;

    let data = {
      solutionID: RA.ViewKB.solution.id,
      description: RA.ViewKB.solution.title,
      url: solutionUrl,
      SToken: Config.csrf.value
    };

    this.requestPending = true;
    $.post(url, data)
      .done(r => {
        this.requestPending = false;

        if (r.success) {
          let $feedback = $(this.refs.feedback);

          this.setState({favorite: r.favorite});
          $feedback.fadeIn();
          this.setFeedbackTimeout();
        }
      });
  },
  updateFavorite() {
    let url = Config.contextPath + "/controller/update/myfavorites/" + this.state.favorite.id;
    let data = {
      solutionID: RA.ViewKB.solution.id,
      description: RA.ViewKB.solution.title,
      url: window.location.href,
      SToken: Config.csrf.value
    };

    $.post(url, data);
  },
  removeFavorite() {
    if (this.requestPending) return;

    let url = Config.contextPath + "/controller/delete/myfavorites/" + this.state.favorite.id;

    let data = {
     SToken: Config.csrf.value
    };

    this.requestPending = true;
    $.post(url, data)
      .done(r => {
        this.requestPending = false;
        this.setState({favorite: {}});
      });
  },
  clearFeedbackTimeout() {
    if (this.feedbackTimeout) {
      clearTimeout(this.feedbackTimeout);
      this.feedbackTimeout = null;
    }
  },
  setFeedbackTimeout() {
    this.feedbackTimeout = setTimeout(() => {
      let $feedback = $(this.refs.feedback);
      $feedback.fadeOut();
    }, 2000);
  },

  render() {
    let favUrl = `${Config.contextPath}/${Config.portalInterface}/?tabname=account#favorites`;
    let isFavorite = this.state.favorite.id != undefined;
    let className = classNames(
      "glyphicon actions-list__icon",
      (isFavorite ? "glyphicon-star" : "glyphicon-star-empty")
    );

	let linkClass = ``;
	if (isSimplifiedSocialLayout) {
		favUrl = `#`;
		linkClass = `disguiseFavoriteLink`;
	}

    return (
      <div>
        <a href="#" onClick={this.favoriteClicked} className="actions-list__link -favorite" title={Labels.getLabel("Favorite")}>
          <span className={className}></span>&nbsp;
          <span>{Labels.getLabel("Favorite")}</span>
        </a>
        <div className="actions-list__feedback" ref="feedback" onMouseOver={this.clearFeedbackTimeout} onMouseOut={this.setFeedbackTimeout}>
          <span>{Labels.getLabel("Solution added to") + " "}<a href={favUrl} className={linkClass}>{Labels.getLabel("My Favorites")}</a></span>
        </div>
      </div>
    );
  }
});

// === FavoriteFilter.js ===
var FavoriteFilter = React.createClass({
    propTypes: {
        showFavoriteFilter: React.PropTypes.bool,
        favoritesOnly: React.PropTypes.bool,
        onFavoriteChanged: React.PropTypes.func,
        resetFiltersClicked: React.PropTypes.func,
        isFiltered: React.PropTypes.bool
    },
    getDefaultProps() {
        return {
            favoritesOnly: false,
            showFavoriteFilter: false
        }
    },
    handleAllClick() {
        if (this.props.favoritesOnly) {
            this.props.favoritesOnly = false;
            if (this.props.onFavoriteChanged) {
                this.props.onFavoriteChanged(this.props.favoritesOnly);
            }
        }
    },
    handleFavoriteClick() {
        if (!this.props.favoritesOnly) {
            this.props.favoritesOnly = true;
            if (this.props.onFavoriteChanged) {
                this.props.onFavoriteChanged(this.props.favoritesOnly);
            }
        }
    },
    render() {
        this.props.favoritesOnly = this.props.favoritesOnly === "true" || this.props.favoritesOnly === true ? true : false;
        if (Config.isGuestPortal || !this.props.showFavoriteFilter)
            return <span></span>
        return (
            <BrowseFilter title="" filterType="filter-type__favorite" isOpen={this.props.isOpen} ariaLabel="Solution Favorite Filter">
                <div id="favoriteFilter">
                    <nav className="search-filters-section" aria-label="page">
                        <ul className="pagination">
                            <li id="allButton" className={!this.props.favoritesOnly ? 'active' : null}>
                                <a role="button" className="text-uppercase" href="#" onClick={this.handleAllClick}>{Labels.getLabel("All")}</a>
                            </li>
                            <li id="favoriteButton" className={this.props.favoritesOnly ? 'active' : null}>
                                <a role="button" className="text-uppercase" href="#" onClick={this.handleFavoriteClick}>{Labels.getLabel("Favorites")}</a>
                            </li>
                        </ul>
                        {
                            this.props.isFiltered ?
                                <ul className="pagination">
                                    <li><ClearFilters resetFiltersClicked={this.props.resetFiltersClicked} /></li>
                                </ul> : null
                        }
                    </nav >
                </div>
            </BrowseFilter>
        )
    }
});

// === FilterLinkList.js ===
var FilterLinkList = React.createClass({
  propTypes: {
    items: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    selectedValue: React.PropTypes.any.isRequired,
    onClick: React.PropTypes.func.isRequired,
    isInline: React.PropTypes.bool
  },
  itemClicked(val) {
    this.props.onClick(val);
  },
  renderItem(item, index) {
    let isActive = item.value === this.props.selectedValue;
    let className = classNames("filter__item", {"-active": isActive});

    let inner = isActive ? <span>{item.label}</span> :
      <a href="#" role="button" className="filter__link" onClick={this.itemClicked.bind(this, item.value)}>{item.label}</a>;

    return <li className={className} key={index}>{inner}</li>;
  },
  render() {
    let className = "filter__list" + (this.props.inline ? " list-inline" : "");
    let items = this.props.items.map(this.renderItem);

    return (
      <ul className={className}>
        {items}
      </ul>
    );
  }
})

// === GlossaryTooltip.js ===
var GlossaryTooltip = React.createClass({
    propTypes: {
      glossaryTermPosition: React.PropTypes.array,
      dataTerm: React.PropTypes.string,
      glossaryData: React.PropTypes.object
    },
    componentDidMount () {
      this.removeOverFlowAiChatMessage();
    },
    componentDidUpdate () {
      this.removeOverFlowAiChatMessage();
    },
    removeOverFlowAiChatMessage: function () {
      const aiChatContainer = document.querySelector(".ai-chat-message-container");
      const overflowWidth = aiChatContainer.scrollWidth - aiChatContainer.clientWidth;
      const glossaryTooltipDiv = document.querySelector(".glossary-def-tooltip");
      if (overflowWidth > 0) {
        glossaryTooltipDiv.style.width = (glossaryTooltipDiv.clientWidth - (overflowWidth + 10)) + "px";
      }
    },
    render() {
      const { glossaryData, glossaryTermPosition = [] } = this.props;
      const [x = 0, y = 0] = glossaryTermPosition;
      if (glossaryData &&
        Object.keys(glossaryData).length !== 0 &&
        glossaryData.constructor === Object) {
        var { title, summary, glossary } = glossaryData;
      }
      const positioningStyle = {
        top: x + "px",
        left: y + "px"
      };
      return (
        <div className="glossary-def-tooltip" style={positioningStyle}>
          <div className="glossary-def-title">{title}</div>
          <div className="glossary-def-summary">{summary}</div>
          <div>
            <a className="glossary-def-link" href={"/portal/app/portlets/results/" + glossary} rel="noopener" target="_blank">{Labels.getLabel("View More...")}</a>
          </div>
        </div>
      );
    }
  });

// === IncompleteSolutions.js ===
var IncompleteSolutions = React.createClass({
  propTypes: {
    initialItems: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    pageSize: React.PropTypes.number,
    enableScrolling: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      initialItems: [],
      pageSize: 5,
      enableScrolling: true
    }
  },
  getInitialState() {
    return {
      items: this.props.initialItems,
      isEditMode: false,
      activeTab: "complete"
    }
  },
  componentDidMount() {
    if (window.location.hash === "#incomplete") {
      this.setState({ activeTab: "incomplete" });
      // Only scroll if enableScrolling prop is true and coordinator exists
      if (this.props.enableScrolling && window.PortalContentCoordinator && this.refs.incompleteSolutionsContainer) {
        PortalContentCoordinator.scrollWhenReady(this.refs.incompleteSolutionsContainer, ["recentViews", "recentSearches", "incompleteSolutions"]);
      }
    }
    // Mark this component as loaded
    if (window.PortalContentCoordinator) {
      PortalContentCoordinator.markComponentLoaded('incompleteSolutions');
    }
  },
  pageClicked(num) {
    this.setState({pageNumber: num});
  },
  deleteClicked(item) {
    let { items } = this.state;
    let index = items.indexOf(item);

    let url = `${Config.contextPath}/app/core/solchecks.jsp`;
    let data = {
      operation: "delete",
      solutionid: item.solutionID,
      SToken: Config.csrf.value
    };

    $.post(url, data);

    // optimistic remove from array
    items.splice(index, 1);
    this.setState({items: items});
  },
  renderItem(item) {
    let { isEditMode } = this.state;

    let progress = Math.round((item.completedSteps.length / item.totalSteps) * 100);
    progress = <div className="text-muted small">{`${progress}% ${Labels.getLabel("complete")}`}</div>;

    return (
      <EditableListItem
        key={item.id}
        showDelete={isEditMode}
        onDelete={this.deleteClicked.bind(this, item)}>
        <a href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${item.solutionID}`}>
          <div>{item.title}</div>
          {isEditMode ? null : progress}
        </a>
        {isEditMode ? progress : null}
      </EditableListItem>
    )
  },
  editToggleClicked() {
    this.setState({isEditMode: !this.state.isEditMode});
  },
  navClicked(value) {
    this.setState({activeTab: value,
      isEditMode: false});
  },
  renderNav() {
    let {
      items,
      activeTab
    } = this.state;

    if (items.length == 0) return;

    return (
      <TabBar activeKey={activeTab} onChange={this.navClicked} className="-sm">
        <Tab eventKey="complete">{Labels.getLabel("Complete")}</Tab>
        <Tab eventKey="incomplete">{Labels.getLabel("Incomplete")}</Tab>
      </TabBar>
    )
  },
  renderToolbar() {
    let {
      items,
      isEditMode
    } = this.state;

    if (items.length == 0) return;

    return (
      <div className="aside__wrap aside__ctrls text-right">
        <EditLinkToggle
          onClick={this.editToggleClicked}
          editEnabled={isEditMode} />
      </div>
    )
  },
  render() {
    let { pageSize } = this.props;
    let {
      items,
      isEditMode,
      activeTab
    } = this.state;
	
	const filteredItems = items.filter(item => {
		return activeTab === 'complete' ? item.completed : !item.completed;
	});

    let content = filteredItems.length ?
      <BasicPagerList
        className={classNames({"link-list": !isEditMode, "padded-list": isEditMode},  "-bordered", "-hover")}
        items={filteredItems}
        renderItem={this.renderItem}
        pageSize={pageSize} /> :
      <NoContent message={Labels.getLabel("No in progress solutions")} />

    return (
      <div ref="incompleteSolutionsContainer">
        <h2 className="aside__title">
          {Labels.getLabel("Solutions")}
        </h2>

		{this.renderNav()}
        {this.renderToolbar()}

        {content}
      </div>
    )
  }
});

// === KBDidYouMean.js ===
var KBDidYouMean = React.createClass({
  propTypes: {
    didYouMean: React.PropTypes.string
  },
  submitDidYouMeanSearch() {
    RA.SearchBar.setSearchText(this.props.didYouMean);

	let searchForm = $(".main-search__form");
	searchForm.submit();
  },
  render() {
    if (this.props.didYouMean === '' || !RA.KBSearch.showDidYouMean) {
      return <span />
    }

    return (
		<div className="kbDidYouMean">
			{Labels.getLabel("Did You Mean")}:&nbsp;
			<a href="#" className="text-muted" onClick={this.submitDidYouMeanSearch}>
				{this.props.didYouMean}
			</a>
		</div>
    );
  }
});




// === KBResultItem.js ===
var KBResultItem = React.createClass({
  propTypes: {
    hit: React.PropTypes.object.isRequired,
    showStars: React.PropTypes.bool,
    showSummary: React.PropTypes.bool,
    showHitSummary: React.PropTypes.bool,
	queryText: React.PropTypes.string,
    onEmailClicked: React.PropTypes.func.isRequired,
    onPreviewClicked: React.PropTypes.func.isRequired,
    favoritesOnly: React.PropTypes.bool
  },
  emailClicked(hit, e) {
    this.props.onEmailClicked(hit, e);
  },
  previewClicked(hit, e) {
    this.props.onPreviewClicked(hit, e);
  },
  getDefaultProps() {
    return {
      showStars: false,
      showSummary: true,
      showHitSummary: true,
	  queryText: "",
      favoritesOnly: false
    }
  },
  getCleanHitSummary() {
    let hitSummary = this.props.hit.hitSummary;
	if(hitSummary === null || hitSummary === undefined) {
		return "";
	}
    hitSummary = hitSummary.replace(/<B>/g, "raopenbold").replace(/<\/B>/g, "raclosebold");
    hitSummary = hitSummary.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    return hitSummary.replace(/raopenbold/g, "<B>").replace(/raclosebold/g, "</B>");
  },
  getIconClassName() {
    let iconCode = this.props.hit.solution.iconCode;

    switch (iconCode) {
      case "show":
        return "glyphicon-film";
      case "automate":
        return "glyphicon-cog";
      case "diagnostic":
        return "glyphicon-question-sign";
      case "form":
        return "glyphicon-list-alt";
      case "rightpath":
        return "glyphicon-ok-circle";
      case "word":
      case "excel":
      case "ppt":
      case "pdf":
      case "lotus":
      case "file":
        return "glyphicon-file";
      case "rake":
        return "glyphicon-transfer";
      case "custom":
      default:
        return "glyphicon-book"
    }
  },
  renderSummary() {
    if (!this.props.showSummary) return;

    let { hit } = this.props;

    let fileTypeTag = hit.solution.type == "Document" ? <span>[{hit.solution.iconCode}] </span> : null;

    return (
      <div className="view-link__summary">
        {fileTypeTag}
        <span dangerouslySetInnerHTML={{__html:hit.summary}}></span>
      </div>
    );
  },
  renderHitSummary() {
    if (!this.props.showHitSummary) return;

    return <div className="view-link__hit-summary" dangerouslySetInnerHTML={{__html: this.getCleanHitSummary()}}></div>;
  },
  renderStarImage() {
    if (!this.props.showStars) return;

    let score = this.props.hit.score;
    let stars = 1;

    if (score > .8) {
      stars = 5;
    } else if (score > .6 && score < .8) {
      stars = 4;
    } else if (score > .4 && score < .6) {
      stars = 3;
    } else if (score > .2 && score < .4) {
      stars = 2;
    }

    return <span className={"star-rating -star" + stars}></span>;
  },
  renderIsNewUpdatedLabel() {
      if (!this.props.hit.solution.isNewUpdated) return;

      let displayIsNewUpdated = (this.props.hit.solution.isNewUpdated === 1 ? Labels.getLabel('NEW') : Labels.getLabel('UPDATED'));

      if (this.renderStarImage() === undefined) {
        return (
          <span className="label label-default">{displayIsNewUpdated}</span>
        );
      } else {
        return(
          <span>
            <span>&nbsp;</span> 
            <span className="label label-default">{displayIsNewUpdated}</span> 
          </span>
        );
      }
  },
  openLink(e) {
	 let { hit } = this.props;

    let positionParams = "";
	let q = this.props.queryText;
    let favoritesOnly = this.props.favoritesOnly;

	if ("page" in hit && "position" in hit) {
      positionParams = `&page=${hit.page}&position=${hit.position}&q=` + encodeURIComponent(q);
    }

    let ticketId = "";
    if(Config.copyToIncidentEnabled) {
        ticketId = `&ticketid=` + $("#ticketID").val();
    }

    let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}${ticketId}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam + `&isfavorite=${favoritesOnly}`;

    if (hit.solution.type === "Rake Solution" && Config.openRakeResultDirectly) {
        url = hit.solution.rakeUrl;
            
        let logData = {
            action: "VIEWRAKEDOCUMENT",
            docid: hit.solution.id,
            description: hit.solution.title,
            typeofview: "other_externalsource",
            accessmethod: sessionStorage.getItem("accessmethod")
        };

        RA.logAction(logData);
    }

	if (launchLinksInNewWindow) {
		e.preventDefault();
		RA.Utils.openCenteredWindow(url, '1100', '800');
	}
  },
  renderEmailButton(divStyle, hit) {
    if (!Config.ShowResultEmail) return;
    return (
        <li>
          <a href="#" className="email-link" style={divStyle} title={Labels.getLabel("Email Solution")} onClick={this.emailClicked.bind(this, hit)}>
            <small><i className="glyphicon glyphicon-envelope"></i></small>
          </a>
        </li>
    )
  },
  renderPreviewButton(divStyle, hit) {
    if (!Config.ShowResultEmail) return;
    return (
        <li>
          <a href="#" className="preview-link" style={divStyle} title={Labels.getLabel("Preview")} onClick={this.previewClicked.bind(this, hit)}>
            <small><i className="glyphicon glyphicon-search"></i></small>
          </a>
        </li>
    )
  },
  render() {
    let { hit } = this.props;

    let positionParams = "";
	let q = this.props.queryText;
    let favoritesOnly = this.props.favoritesOnly;

	if ("page" in hit && "position" in hit) {
      positionParams = `&page=${hit.page}&position=${hit.position}&q=` + encodeURIComponent(q);
    }

	var divStyle = {
        float: "right",
        margin: "7px"
    };

    let target = "_self";
    let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam + `&isfavorite=${favoritesOnly}`;
    let className = `view-link__title s-${hit.solution.isSolr}`;

    if (hit.solution.type == "Rake Solution" && Config.openRakeResultDirectly) {
        url = hit.solution.rakeUrl;
        target = "_blank";
    }

    return (
      <li className="view-link">
        <div className="view-link__icon">
          <i className={"glyphicon " + this.getIconClassName()}></i>
        </div>
        <div className="view-link__content">
          <a onClick={this.openLink} href={url} target={target} className={className} dangerouslySetInnerHTML={{__html: hit.solution.title}}></a>
          <div className="view-link__subhead">
            <ul className="actions">
              {this.renderEmailButton(divStyle, hit)}
              {this.renderPreviewButton(divStyle, hit)}
            </ul>
            {this.renderSummary()}
            {this.renderHitSummary()}
            <div className="view-link__sub-line">
              {this.renderStarImage()}
              {this.renderIsNewUpdatedLabel()}
            </div>
          </div>
        </div>
        <div className="preview-pane muted">
          <div className="content">
            <div >
              <strong>{Labels.getLabel("Preview")}</strong>
            </div>
            <div className="solution"></div>
          </div>
        </div>
      </li>
    )
  }
})

// === KBResults.js ===
var KBResults = React.createClass({
    propTypes: {
        searchResults: React.PropTypes.object.isRequired,
        filterData: React.PropTypes.object.isRequired,
        eventHandler: React.PropTypes.func.isRequired,
        showCollectionFilter: React.PropTypes.bool,
        showAttributeFilter: React.PropTypes.bool,
        onEmailClicked: React.PropTypes.func.isRequired,
        onPreviewClicked: React.PropTypes.func.isRequired,
        directView: React.PropTypes.bool
    },
    pageClicked(num) {
        this.props.eventHandler({ actionType: 'pageClicked', num: num });
    },
    sortChanged(sortKey, index) {
        this.props.eventHandler({ actionType: 'sortChanged', sortKey: sortKey });
    },
    searchCriteriaChanged(searchCriteriaKey, index) {
        this.props.eventHandler({ actionType: 'searchCriteriaChanged', searchCriteriaKey: searchCriteriaKey });
    },
    attributeSetChanged(setName) {
        this.props.eventHandler({ actionType: 'attributeSetChanged', setName: setName });
    },
    attributesChanged(setName, attributes) {
        this.props.eventHandler({
            actionType: 'attributesChanged', setName: setName,
            attributes: attributes
        });
    },
    collectionsChanged(collections) {
        this.props.eventHandler({ actionType: 'collectionsChanged', collections: collections });
    }, favoriteChanged(favorite) {
        this.props.eventHandler({ actionType: 'favoriteChanged', favorite: favorite });
    },
    typesChanged(types) {
        this.props.eventHandler({ actionType: 'typesChanged', types: types });
    },
    categoryChanged(taxPath) {
        this.props.eventHandler({ actionType: 'categoryChanged', taxPath: taxPath });
    },
    dateChanged(startDate, endDate) {
        this.props.eventHandler({
            actionType: 'dateChanged', startDate: startDate,
            endDate: endDate
        });
    },
    languagesChanged(languages) {
        this.props.eventHandler({ actionType: 'languagesChanged', languages: languages });
    },
    resetFiltersClicked() {
        this.props.eventHandler({ actionType: 'resetFilters' });
        RA.KBSearch.kbFilterApplied = false;
    },
    findSelectedSortIndex() {
        let {
            searchResults,
            filterData
        } = this.props;
        let querySortBy = searchResults.query.sortBy.toLowerCase();
        let queryDescending = searchResults.query.sortDescending;

        for (let i = 0; i < filterData.sortKeys.length; i++) {
            let sortKey = filterData.sortKeys[i];
            let thisSortBy = sortKey.key.toLowerCase();
            let thisDescending = sortKey.descending;

            if (thisDescending == undefined) thisDescending = true;

            if (thisSortBy == querySortBy && thisDescending == queryDescending) {
                return i;
            }
        }

        return 0;
    },

    findSelectedSearchCriteriaIndex() {
        let {
            searchResults,
            filterData
        } = this.props;

        const neuralSearchEnabled = searchResults.query.neuralSearchEnabled;
        if (!neuralSearchEnabled) {
            return -1;
        }

        let querySearchCriteria = searchResults.query.searchCriteria.toLowerCase();

        for (let i = 0; i < filterData.searchCriteriaKeys.length; i++) {
            let searchCriteriaKey = filterData.searchCriteriaKeys[i];
            let thisSearchCriteria = searchCriteriaKey.key.toLowerCase();

            if (thisSearchCriteria === querySearchCriteria) {
                return i;
            }
        }

        return 0;
    },
    paramToArray(paramName) {
        let val = RA.KBSearch.query[paramName];
        return typeof val == "string" ? val.split(";") : [];
    },
    getParam(paramName) {
        return RA.KBSearch.query[paramName];
    },
    getPager() {
        let searchResults = this.props.searchResults;
        let pagerDetail = searchResults.pagerDetail;
        return searchResults.totalHits > 0 && pagerDetail.totalPages > 1 ?
            <ResultsPager pagerDetail={pagerDetail} onPageClicked={this.pageClicked} /> : null;
    },
    autoClicked() {
        let hit = this.props.searchResults.results[0];
        let favoritesOnly = this.props.searchResults.favoritesOnly;
        let positionParams = `&page=${hit.page}&position=${hit.position}&linw=true&q=` + encodeURIComponent(RA.KBSearch.query.querytext) + `&isfavorite=${favoritesOnly}`;

        let ticketId = "";
        if (Config.copyToIncidentEnabled) {
            ticketId = `&ticketid=` + $("#ticketID").val();
        }

        let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}${ticketId}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
        window.open(url);
    },
    showAICHat() {
        const showAIChat = RA.KBSearch.query.querytext && RA.KBSearch.query.querytext.trim().replace(/\s+/gi, " ").split(" ").length > 0;
        const preventChatTrigger = this.props.searchResults.preventChatTrigger;
        return RA.KBSearch.isAiChatEnabled() && showAIChat && !preventChatTrigger;
    },
    getResultsSection() {
        let { filterData, searchResults } = this.props;
        let didYouMean = searchResults.didYouMean;

        if (searchResults.results.length == 1 && Config.viewOneSolutionResult && this.props.directView) {
            this.autoClicked();
        }

        return (
            <div>
                <div className="result-col__head clearfix">
                    {this.showAICHat() ? <AIChat query={RA.KBSearch.query.querytext} /> : null}
                    <ResultCountSummary
                        totalHits={searchResults.totalHits}
                        pageStart={searchResults.pagerDetail.pageStart}
                        pageEnd={searchResults.pagerDetail.pageEnd}
                    />
                    <div className="result-col__head-right">
                        <ResultSearchCriteria
                            searchCriteriaKeys={filterData.searchCriteriaKeys}
                            selectedIndex={this.findSelectedSearchCriteriaIndex()}
                            onSearchCriteriaChanged={this.searchCriteriaChanged}
                        />
                        <ResultSort sortKeys={filterData.sortKeys}
                            selectedIndex={this.findSelectedSortIndex()}
                            onSortChanged={this.sortChanged}
                        />
                    </div>
                </div>
                <KBDidYouMean didYouMean={didYouMean} />
                <KBResultsList hits={searchResults.results} onEmailClicked={this.props.onEmailClicked}
                    onSolClicked={this.props.onSolClicked}
                    onPreviewClicked={this.props.onPreviewClicked}
                    favoritesOnly={searchResults.favoritesOnly} />
                {this.getPager()}
            </div>
        )
    },
    getEmptyResultSection: function (filterData) {
        return <div>
            <div className="result-col__head-right">
                <ResultSearchCriteria
                    searchCriteriaKeys={filterData.searchCriteriaKeys}
                    selectedIndex={this.findSelectedSearchCriteriaIndex()}
                    onSearchCriteriaChanged={this.searchCriteriaChanged}
                />
            </div>
            <NoResults showResetFilters={RA.KBSearch.isFilterApplied()} onFilterResetClicked={this.resetFiltersClicked} />
        </div>;
    },
    render() {
        let { filterData, searchResults } = this.props;
        let didYouMean = searchResults.didYouMean;
        let pauseSolutionAutoView = localStorage.getItem('pauseSolutionAutoView');
        this.props.directView = ((searchResults.totalHits == 1) && pauseSolutionAutoView !== 'true');

        let hitsCount = searchResults.totalHits === 0;
        let resultsContent = hitsCount ? this.getEmptyResultSection(filterData) : this.getResultsSection();

        let noResultDymSection = hitsCount ? <KBDidYouMean didYouMean={didYouMean} /> : '';

        let isFiltered = RA.KBSearch.kbFilterApplied;
        /*** RPS - 482 sage customizations products filter on the top. Change the order of the filters. and putting collectionfilter on top after favorites filter ***/
        return (
            <div className="row">
                <ResponsiveFilterColumn className="col-xs-12 col-sm-3 filter-col">
                    <FavoriteFilter showFavoriteFilter={this.props.showFavoriteFilter}
                        favoritesOnly={this.getParam("favoritesOnly")}
                        onFavoriteChanged={this.favoriteChanged} resetFiltersClicked={this.resetFiltersClicked}
                        isFiltered={isFiltered} />
                    <CollectionFilter showCollectionFilter={this.props.showCollectionFilter}
                        customCollections={this.props.filterData.customCollections}
                        selectedCollections={this.paramToArray("searchaliases")}
                        onCollectionsChanged={this.collectionsChanged}/>
                    <CategoryFilter categories={searchResults.browsePaths}
                        currentPath={RA.KBSearch.query.taxlevelValue}
                        onCategoryChanged={this.categoryChanged} />
                    <AttributeFilter showAttributeFilter={this.props.showAttributeFilter}
                        attributeSets={searchResults.attributeSets}
                        attributes={searchResults.attributes}
                        selectedSetName={RA.KBSearch.query.attributesetname}
                        selectedAttributeKeys={this.paramToArray("attributes")}
                        onAttributeSetChanged={this.attributeSetChanged}
                        onAttributesChanged={this.attributesChanged} />
                    <DateFilter searchDates={this.props.filterData.searchDates}
                        selectedStartDate={RA.KBSearch.query.advstartdate}
                        onDateChanged={this.dateChanged} />
                    <TypeFilter defaultTypes={this.props.filterData.defaultTypes}
                        selectedTypes={this.paramToArray("advkeywords")}
                        onTypesChanged={this.typesChanged}/>
                    <LanguageFilter searchLanguages={this.props.filterData.searchLanguages}
                        selectedLanguages={searchResults.query.selectedLanguages}
                        onLanguagesChanged={this.languagesChanged} />
                </ResponsiveFilterColumn>
                <section className="col-xs-12 col-sm-9 result-col" role="region" aria-label={Labels.getLabel("Results")}
                    title={Labels.getLabel("Results")}>
                    {resultsContent}
                    {noResultDymSection}
                </section>
            </div>
        )
    }
})

// === KBResultsList.js ===
var KBResultsList = React.createClass({
  propTypes: {
    hits: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    onEmailClicked: React.PropTypes.func.isRequired,
    onPreviewClicked: React.PropTypes.func.isRequired,
    onSolClicked: React.PropTypes.func.isRequired,
    favoritesOnly: React.PropTypes.bool
  },

  render() {
    if (this.props.hits.length == 0) {
      return <span />
    }

    let showStars = RA.KBSearch.showRelevancyStars && RA.Utils.isNotBlank(RA.KBSearch.query.querytext);
    let queryText = RA.KBSearch.query.querytext;

    if (showStars) {
      queryText = queryText.split(/\s+/).slice(0, 30).join(" ");
    }

    return (
      <ul className="solution-list">
        {this.props.hits.map(hit =>
          <KBResultItem
            key={hit.solution.id}
            hit={hit}
            showStars={showStars}
            queryText={queryText}
            favoritesOnly={this.props.favoritesOnly}
            showHitSummary={RA.KBSearch.showHitSummary}
            onEmailClicked={this.props.onEmailClicked}
            onPreviewClicked={this.props.onPreviewClicked}
            onSolClicked={this.props.onSolClicked}
            {...this.props} />
        )
        }
      </ul>
    )
  }
});

// === KBSummary.js ===
var KBSummary = React.createClass({
  propTypes: {
    eventHandler: React.PropTypes.func.isRequired,
    searchResults: React.PropTypes.object.isRequired,
    resultCount: React.PropTypes.number,
    categoryCount: React.PropTypes.number,
    onSolClicked: React.PropTypes.func.isRequired,
    onEmailClicked: React.PropTypes.func.isRequired,
    onPreviewClicked: React.PropTypes.func.isRequired
  },
  getDefaultProps() {
    return {
      resultCount: 5,
      categoryCount: 2
    }
  },
  categoryClicked(taxPath) {
    this.props.eventHandler({actionType: 'categoryChanged', taxPath: taxPath});
    this.showKBTab();
  },
  showKBTab() {
    RA.ResultsPage.showTab("#kbResults");
  },
  getSummaryHits() {
    let results = this.props.searchResults.results;
    let ubound = Math.min(results.length, this.props.resultCount);

    results = results.slice(0, ubound);

    return results;
  },
  getSummaryBrowsePaths() {
    let categories = this.props.searchResults.browsePaths;

    // sort affects other components using this variable - use map, then sort instead
    //categories.sort((a, b) => b.hits - a.hits);

    // convert to map of array {index, hit count}
    let hitCounts = categories.map((cat, i) => {
      return {index: i, count: cat.hits }
    });

    // sort by hit count - descending
    hitCounts.sort((a, b) => b.count - a.count);

    // get slice
    let ubound = Math.min(hitCounts.length, this.props.categoryCount);
    hitCounts = hitCounts.slice(0, ubound);

    // return array of categories with index position from the hitCount array
    return hitCounts.map(hitCount => {
      return categories[hitCount.index];
    });

  },
  renderSummary() {
    let { searchResults } = this.props;

    if (searchResults.totalHits == 0) {
      return <NoResults />
    }

    let resultsLabel = searchResults.totalHits == 1 ? Labels.getLabel("result") : Labels.getLabel("results");
	let didYouMean = searchResults.didYouMean;
	let selectedTaxonomy = searchResults.query.taxPath;
	let selectedTaxonomyLabel = Labels.getLabel("Currently searching");

    return (
      <div>
        <div className="result-summary__stats">
          <span className="text-muted">{`${searchResults.totalHits} ${resultsLabel} - `}</span>
          <a href="#" className="text-muted" onClick={this.showKBTab}>
            {Labels.getLabel("Show All")}
          </a>
		  <KBDidYouMean didYouMean={didYouMean}/>
        </div>
        <KBResultsList hits={this.getSummaryHits()} showSummary={false} showHitSummary={false}  onEmailClicked={this.props.onEmailClicked}
        onSolClicked={this.props.onSolClicked} onPreviewClicked={this.props.onPreviewClicked}/>
		{ selectedTaxonomy ? <div className="cat-matches"><h3 className="cat-matches__title"><span className="alltab_taxonomy_clicked">{selectedTaxonomyLabel} </span> {selectedTaxonomy}</h3></div> : <span></span>}
        <KBSummaryCategories browsePaths={this.getSummaryBrowsePaths()} onCategoryClicked={this.categoryClicked} />
      </div>
    )
  },
  render() {
    return (
      <div>
         <h3 className="result-summary__head">
          <a href="#" className="result-summary__head-link -kb" onClick={this.showKBTab}>
            <i className="glyphicon glyphicon-book result-summary__head-icon"></i>
            {Labels.getLabel("Knowledgebase")}
          </a>
        </h3>
        {this.renderSummary()}
      </div>
    )
  }
});

// === KBSummaryCategories.js ===
var KBSummaryCategories = React.createClass({
  propTypes: {
    browsePaths: React.PropTypes.array,
    onCategoryClicked: React.PropTypes.func.isRequired
  },
  getDefaultProps() {
    return {
      browsePaths: []
    }
  },
  categoryClicked(path) {
    this.props.onCategoryClicked(path);
  },
  renderItem(path) {
    let pathArray = path.value.split("//");
    let displayName = pathArray[pathArray.length - 1];

    return (
        <li className="" key={path.value}>
          <a href="#" onClick={this.categoryClicked.bind(this, path.value)}>{displayName}</a> <span className="text-muted">({path.hits})</span>
        </li>
      )
  },

  render() {
    if (this.props.browsePaths.length == 0) {
      return <div></div>;
    }

    let items = this.props.browsePaths.map(this.renderItem);

    return (
      <div className="cat-matches">
        <h3 className="cat-matches__title">{Labels.getLabel("Show results in these categories")}:</h3>
        <ul className="cat-matches__list bullet-list">
          {items}
        </ul>
      </div>
    )
  }
});

// === LanguageFilter.js ===
var LanguageFilter = React.createClass({
  propTypes: {
    searchLanguages: React.PropTypes.array.isRequired,
    selectedLanguages: React.PropTypes.arrayOf(React.PropTypes.string),
    onLanguagesChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedLanguages: []
    }
  },
  languageClicked(code) {
    let checkedLanguages;

    // If "All Languages" (empty code) is clicked, clear all selections
    if (code === '') {
      checkedLanguages = [];
    } else {
      checkedLanguages = this.props.selectedLanguages.slice(); // Clone array
      let isSelected = this.isLanguageSelected(code);

      if (!isSelected) {
        checkedLanguages.push(code);
      } else {
        checkedLanguages = checkedLanguages.filter(val => val !== code);
      }
    }

    if (this.props.onLanguagesChanged) {
      this.props.onLanguagesChanged(checkedLanguages);
    }
  },
  languageClickedSingle(code) {
    let checkedLanguages = code === '' ? [] : [code];
    if (this.props.onLanguagesChanged) {
      this.props.onLanguagesChanged(checkedLanguages);
    }
  },
  languageChanged(e) {
    let code = e.target.value;
    let checkedLanguages = code === '' ? [] : [code];
    if (this.props.onLanguagesChanged) {
      this.props.onLanguagesChanged(checkedLanguages);
    }
  },
  isLanguageSelected(code) {
    return this.props.selectedLanguages.indexOf(code) !== -1;
  },
  isAllLanguagesSelected() {
    return this.props.selectedLanguages.length === 0;
  },
  getItem(lang) {
    return (
      <li className="filter__item" key={lang.key}>
        <RACheck label={lang.displayValue}
          value={lang.key}
          isChecked={this.isLanguageSelected(lang.key)}
          onClick={this.languageClicked} />
      </li>
    )
  },
  renderMultiSelect() {
    return (
      <BrowseFilter title={Labels.getLabel("Languages")} filterType="filter-type__language" ariaLabel="Solution Language filter" isOpen={this.props.isOpen}>
        <ul className="filter__list">
          <li className="filter__item" key="all-languages">
            <RACheck label={Labels.getLabel("All Languages")}
              value=""
              isChecked={this.isAllLanguagesSelected()}
              onClick={this.languageClicked} />
          </li>
          {this.props.searchLanguages.map(this.getItem)}
        </ul>
      </BrowseFilter>
    )
  },
  renderSingleSelect() {
    let selectedValue = this.props.selectedLanguages.length > 0 ? this.props.selectedLanguages[0] : '';
    return (
      <BrowseFilter title={Labels.getLabel("Languages")} filterType="filter-type__language" ariaLabel="Solution Language filter" isOpen={this.props.isOpen}>
        <select className="form-control filter__language" value={selectedValue} onChange={this.languageChanged}>
          {this.props.searchLanguages.map(lang => {
            return <option key={lang.key} value={lang.key}>{lang.displayValue}</option>
          })}
        </select>
      </BrowseFilter>
    )
  },
  render() {
    if (this.props.searchLanguages.length == 0) {
      return <span />;
    }

    if (Config.enableMultiLanguageSearch) {
      return this.renderMultiSelect();
    }

    return this.renderSingleSelect();
  }
});


// === ManageFavorites.js ===
var ManageFavorites = React.createClass({
  propTypes: {
    initialMyFavorites: React.PropTypes.arrayOf(React.PropTypes.object),
    groupFavorites: React.PropTypes.arrayOf(React.PropTypes.object),
    pageSize: React.PropTypes.number,
    showFavoriteSearch: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      pageSize: 5,
      initialMyFavorites: [],
      groupFavorites: [],
      showFavoriteSearch: false
    }
  },
  getInitialState() {
    return {
      activeTab: "my",
      showEditControls: false,
      myFavorites: this.props.initialMyFavorites,
      favoriteQuery: ''
    }
  },
  navClicked(value) {
    this.setState({activeTab: value,
      showEditControls: false});
  },
  editClicked() {
    this.setState({showEditControls: !this.state.showEditControls});
  },
  deleteClicked(fav) {
    let {myFavorites} = this.state;
    let index = myFavorites.indexOf(fav);
    let data = { favoriteID: fav.id }
    data.SToken = Config.csrf.value;

    let url = `${Config.contextPath}/controller/delete/myfavorites/`;
    $.post(url, data);

    // optimistic remove from array
    myFavorites.splice(index, 1);
    this.setState({myFavorites: myFavorites});
  },handleChange: function(e) {
    this.setState({ favoriteQuery: e.target.value });
  },
   handleKeyPress: function(event){
    if(event.key === 'Enter' || event.keyCode == '13'){
        event.preventDefault();
        let favoriteQuery = this.state.favoriteQuery;
        let url = `${Config.contextPath}/ss/?querytext=${favoriteQuery}&favoritesOnly=true&tabid=2#t=kbResults`;
        window.location.href = url;
    }
  },
  favClicked(fav, e) {
    e.preventDefault();

    let url = `${Config.contextPath}/app/core/ralogger.jsp`;
    let data = {
      action: "VIEWFAVORITE",
      description: fav.description,
      docid: fav.solutionID,
      SToken: Config.csrf.value,
      accessmethod: sessionStorage.getItem("accessmethod")
    };

    let targetUrl = fav.isSolution ?
      `${Config.contextPath}/app/portlets/results/viewsolution.jsp?ifv=true&solutionid=${fav.solutionID}` : fav.url;

    $.post(url, data)
      .always(() => location.href = targetUrl);
  },
  renderNav() {
    let { groupFavorites } = this.props;
    let {
      myFavorites,
      activeTab
    } = this.state;

    if (groupFavorites.length == 0) return;

    return (
      <TabBar activeKey={activeTab} onChange={this.navClicked} className="-sm">
        <Tab eventKey="my">{Labels.getLabel("My Favorites")}</Tab>
        <Tab eventKey="group">{Labels.getLabel("Suggested Favorites")}</Tab>
      </TabBar>
    )
  },
  renderSearchForm(){
    if (!this.props.showFavoriteSearch) {
      return(
        <span></span>
      )
    }
    let href = `${Config.contextPath}/ss/?querytext=${this.state.favoriteQuery}&favoritesOnly=true&tabid=2#t=kbResults`;
    return (
      <div id="liveSearchSS" className="live-search">
        <input type="text" id="grid-search-box" name="grid-search-box" aria-label="Grid Search box" className="form-control"
               placeholder={Labels.getLabel("Search Favorites")} maxlength="200" onChange={this.handleChange} onKeyPress ={this.handleKeyPress}
        />
          <a href={href} aria-label={Labels.getLabel("Search Favorites, new tab")}>
            <i id="grid-search-box-icon" className="glyphicon glyphicon-search"></i>
          </a>
      </div>
    )
  },
  renderToolbar() {
    let {
      activeTab,
      myFavorites,
      showEditControls
    } = this.state;

    let showEditLink = activeTab == "my" && myFavorites.length > 0;

    if (!showEditLink) return;

    return (
      <div id="favoriteToolBar" className="aside__wrap aside__ctrls text-right">
        <EditLinkToggle
          onClick={this.editClicked}
          editEnabled={showEditControls} />
      </div>
    )
  },
  renderMyFavorite(fav) {
    let href = fav.isSolution ?
      `${Config.contextPath}/app/portlets/results/viewsolution.jsp?ifv=true&solutionid=${fav.solutionID}` : fav.url;

    return (
      <EditableListItem
        key={fav.id}
        showDelete={this.state.showEditControls}
        onDelete={this.deleteClicked.bind(this, fav)}>
        <a href={href} onClick={this.favClicked.bind(this, fav)}>{fav.description}</a>
      </EditableListItem>
    );
  },
  renderGroupFavorite(fav) {
    return (
      <li>
        <a href={fav.url} onClick={this.favClicked.bind(this, fav)}>{fav.description}</a>
      </li>
    );
  },
  render() {
    let {
      activeTab,
      myFavorites,
      showEditControls
    } = this.state;

    let items, renderItem, pageSize;
    if (activeTab == "my") {
      renderItem = this.renderMyFavorite;
      items = myFavorites;
    } else {
      renderItem = this.renderGroupFavorite;
      items = this.props.groupFavorites;
    }

	pageSize = this.props.pageSize;

    let content = items.length ?
      <BasicPagerList
        className={classNames({"padded-list": showEditControls, "link-list": !showEditControls}, "-bordered", "-hover")}
        items={items}
        renderItem={renderItem}
		pageSize={pageSize} /> :
      <NoContent message={Labels.getLabel("No saved favorites")} />;

    return (
      <div>
        <h2 className="aside__title">
          {Labels.getLabel("Favorites")}
        </h2>

        {this.renderNav()}

        <div className="row">
          <div className="col-md-12">
            <div className="input-group">
              <span className="input-group-btn" role="presentation">
                {this.renderToolbar()}
              </span>
              {this.renderSearchForm()}
            </div>
          </div>
        </div>

        {content}
      </div>
    )
  }
})

// === ManageProfileImage.js ===
var ManageProfileImage = React.createClass({
  propTypes: {
    user: React.PropTypes.object.isRequired
  },
  render() {
    const {user} = this.props;
    const avatarPath = Config.contextPath + RA.defaultAvatar(user.avatar);
    const profileImagePath = this.props.user.avatar;
    const profileText = this.props.user.initials;

    const renderProfileImage = () => {
      if (RA.Utils.isNotBlank(profileImagePath)) {
        return (
              <img src={avatarPath} alt={user.username} className="user-image__avatar"/>
        );
      }

      if (RA.Utils.isNotBlank(profileText)) {
        return (
              <span className="user-image__avatar avatar-text-alt">{profileText}</span>
        );
      }
    }

    return (
      <div className="user-image -lg">
        {renderProfileImage()}
        <div><a href={`${Config.contextPath}/app/portlets/usermanagement/update-avatar.jsp`} target="_blank" rel="opener"><span className="sr-only">{Labels.getLabel("New Window")}</span>{Labels.getLabel("Change")}</a></div>
      </div>
    )
  }
});

// === ManageUserAccount.js ===
var ManageUserAccount = React.createClass({
  propTypes: {
    initialUser: React.PropTypes.object.isRequired,
    editBasicEnabled: React.PropTypes.bool,
    changePasswordEnabled: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      editBasicEnabled: false,
      changePasswordEnabled: false
    }
  },
  getInitialState() {
    return {
      user: this.props.initialUser,
      mode: "view",
      showSaveMessage: false
    }
  },
  saveDone(user) {
    this.setState({user: user,
      mode: "view",
      showSaveMessage: true});

    setTimeout(() => {
      this.setState({showSaveMessage: false})
    }, 2000);
  },
  showEditBasic() {
    this.setState({ mode: "editBasic" });
  },
  showChangePassword() {
    this.setState({ mode : "changePassword" });
  },
  showView() {
    this.setState({ mode: "view" });
  },
  renderEditBasic() {
    return (
      <EditBasicUserForm
        user={this.state.user}
        onSaveDone={this.saveDone}
        onCancel={this.showView} />
    )
  },
  renderChangePassword() {
    return (
      <ChangeUserPasswordForm
        user={this.state.user}
        onSaveDone={this.saveDone}
        onCancel={this.showView} />
    )
  },
  renderView() {
    let {
      user,
      showSaveMessage
    } = this.state;

    return (
      <div>
        <h2 className="h2 account__title">{user.firstName} {user.lastName}</h2>
        <div className="account__subtitle">
          {user.username}<span className="dot" role="presentation"></span><a href={`mailto:${user.emailAddress}`}><span className="sr-only">{Labels.getLabel("email to")}</span>{user.emailAddress}</a>
        </div>

        {this.props.editBasicEnabled ?
          <ul className="bullet-list">
            <li>
              <a href="#" role="button" onClick={this.showEditBasic}>{Labels.getLabel("Edit")}</a>
            </li>
          </ul> : null
        }

        <div className={classNames("account__success-wrap", "alert", "alert-success", {"-in": showSaveMessage})}>
          <span className="text-success">{Labels.getLabel("Save successful")}</span>
        </div>

        <div className="clearfix">
          {this.props.changePasswordEnabled ?
            <div className="account__section">
              <h3 className="account__section-title">{Labels.getLabel("Password")}</h3>
              <div className="account__section-text">
               {Labels.getLabel("Last changed")} {user.password.passwordChangeDateDisplay}
              </div>

              <ul className="bullet-list">
                <li><a href="#" role="button" onClick={this.showChangePassword}>{Labels.getLabel("Change Password")}</a></li>
              </ul>
            </div> : null
          }

          <div className="account__section">
            <h3 className="account__section-title">{Labels.getLabel("More Options")}</h3>

            <ul className="bullet-list">
              <li><a href={`${Config.contextPath}/controller/route/mysubscriptions/view`}>{Labels.getLabel("Email Notifications")}</a></li>
            </ul>
          </div>
        </div>

      </div>
    )
  },
  render() {
    let {user, mode} = this.state;
    let content;

    if (mode == "editBasic") {
      content = this.renderEditBasic();
    } else if (mode == "changePassword") {
      content = this.renderChangePassword();
    } else {
      content = this.renderView();
    }

    return (
      <div>
        <h1 className="page-title">{Labels.getLabel("My Account")}</h1>

        <section className="section account">
          <div className="account__image">
            <ManageProfileImage user={user} />
          </div>

          <div className="account__content">
            {content}
          </div>
        </section>
      </div>
    )
  }
});

// === Modal.js ===
/**
 * A very ghetto React implementation of Bootstrap modal
 * which still relies on jQuery and Bootstrap's JS.
 **/
var Modal = React.createClass({
  propTypes: {
    onHide: React.PropTypes.func.isRequired,
    show: React.PropTypes.bool.isRequired,
    transition: React.PropTypes.bool,
    hideOnBackdropClick: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      transition: true,
      hideOnBackdropClick: true
    }
  },
  childContextTypes: {
    modalOnHide: React.PropTypes.func
  },
  getChildContext() {
    return {
      modalOnHide: this.props.onHide
    }
  },
  componentWillReceiveProps(nextProps) {
    if (!nextProps.show && this.props.show) {
      this.doHide = true;
      this.$modal.modal("hide");
    }

    if (nextProps.show && !this.props.show) {
      this.$modal.modal("show");
    }
  },
  hideTriggered() {
    if (this.doHide) {
      // allow jQuery to hide the modal and reset private control var
      this.doHide = false;
    } else {
      // do not allow jQuery to hide. Call onHide function from parent
      this.props.onHide();
      return false;
    }
  },
  gotDOMRef(element) {
    if (this.$modal == undefined) {
      // initialization
      this.$modal = $(element);
      this.$modal.on("hide.bs.modal", this.hideTriggered);

      if (this.props.show) {
        this.$modal.modal("show");
      }
    }
  },
  render() {
    let className = classNames("modal", {"fade" : this.props.transition});
    let attr = {
      className: className,
      role: "dialog",
      tabIndex: -1,
      "data-backdrop": this.props.hideOnBackdropClick ? "true" : "static"
    };

    return (
      <div {...attr} ref={this.gotDOMRef}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
})


Modal.Header = React.createClass({
  propTypes: {
    onHide: React.PropTypes.func,
    closeButton: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      closeButton: true
    }
  },
  contextTypes: {
    modalOnHide: React.PropTypes.func
  },
  onHide() {

  },
  renderClose() {
    if (!this.props.closeButton) return;

    let onHide = this.props.onHide || this.context.modalOnHide;

    return (
      <button type="button" className="close" aria-label="Close" onClick={onHide}>
        <span aria-hidden="true">&times;</span>
      </button>
    )
  },
  render() {
    return (
      <div className="modal-header">
        {this.renderClose()}
        {this.props.children}
      </div>
    )
  }
})


Modal.Title = React.createClass({
  render() {
    return (
      <h4 className="modal-title">{this.props.children}</h4>
    )
  }
})


Modal.Body = React.createClass({
  render() {
    return (
      <div className="modal-body">
        {this.props.children}
      </div>
    )
  }
})


Modal.Footer = React.createClass({
  render() {
    return (
      <div className="modal-footer">
        {this.props.children}
      </div>
    )
  }
})

// === MyPosts.js ===
var MyPosts = React.createClass({
  componentDidMount() {
    this.statusItems = [
      {label: Labels.getLabel("All"), value: ""},
      {label: Labels.getLabel("Answered"), value: 1},
      {label: Labels.getLabel("Unanswered"), value: 0}
    ];

    this.sortKeys = [
      { key: "last_modified_date", label: Labels.getLabel("Newest on Top") },
      { key: "last_modified_date", descending: false, label: Labels.getLabel("Oldest on Top") }
    ];

    let query = {
      userID: this.props.userID,
      sortBy: "last_modified_date",
      hitcount: 5
    };

    RA.CommunitySearch.search(query, this.searchComplete);
  },
  getInitialState() {
    return {
      searchResults: {},
      loading: true,
      selectedSortIndex: 0,
      selectedStatusValue: ""
    }
  },
  searchComplete(searchResults) {
    if (!this.isMounted()) return;

    this.setState({searchResults: searchResults,
      loading: false});
  },
  statusChanged(e) {
    let value = e.currentTarget.value
    this.setState({selectedStatusValue: value,
      loading: true});

    RA.CommunitySearch.applyFilter({answered: value}, this.searchComplete);
  },
  sortChanged(e) {
    let index = e.currentTarget.value;
    let sortKey = this.sortKeys[index];

    this.setState({selectedSortIndex: index,
      loading: true});

    let descending = sortKey.descending == undefined ? "" : sortKey.descending;

    RA.CommunitySearch.applyFilter({sortBy: sortKey.key, descending: descending},
          this.searchComplete);
  },
  pageClicked(num) {
    this.setState({loading: true});

    //window.scrollTo(0, $(this.refs.rootElement).offset().top);

    RA.CommunitySearch.loadPage(num, this.searchComplete);
  },
  renderNoContent() {
    let message = this.state.selectedStatusValue == "" ?
      "You haven't posted any questions yet" :
      "No matching questions found" ;

    return <NoContent message={Labels.getLabel(message)} />
  },
  renderFilters() {
    return (
      <MyPosts.Filters
        sortKeys={this.sortKeys}
        statusItems={this.statusItems}
        selectedSortIndex={this.state.selectedSortIndex}
        selectedStatusValue={this.state.selectedStatusValue}
        onSortChanged={this.sortChanged}
        onStatusChanged={this.statusChanged} />
    )
  },
  render() {
    let {
      searchResults,
      loading,
      selectedStatusValue
    } = this.state;

    if (!searchResults.results) return <div />;

    let {
      pagerDetail,
      totalHits
    } = searchResults;
    let hits = searchResults.results;
    let hasResults = totalHits > 0;
    let isFiltered = selectedStatusValue != "";

    let resultsList = hasResults ?
      <ul className="solution-list">
        {hits.map(hit =>
          <CommResultItem
            key={hit.discussion.id}
            hit={hit}
            size="sm"
            showAuthor={false}
            showReplyCount={false} />)}
      </ul> : null;

    let pager = hasResults && pagerDetail.totalPages > 1 ?
      <BasicPager
        currentPage={pagerDetail.currentPage}
        maxPage={pagerDetail.totalPages}
        onPageClicked={this.pageClicked} /> : null;
    let overlay = loading ? <Overlay /> : null;

    return (
      <div className="my-posts" ref="rootElement">
        <h2 className="section__title">{Labels.getLabel("My Posts")}</h2>

        {hasResults || isFiltered ? this.renderFilters() : null}

        {!hasResults ? this.renderNoContent() : null}

        <div className="my-posts__results">
          {resultsList}
          {pager}
          {overlay}
        </div>
      </div>
    )
  }
});

MyPosts.Filters = React.createClass({
  componentDidMount() {
    try {
      $('#myPostsSort').selectpicker('refresh');
      $('#myPostsStatus').selectpicker('refresh');
    } catch (e) {
      //Do nothing in case bootstrap-select library is not found.
	}
  },
  render() {
    return (
      <form className="form-inline my-posts__filter-row">
        <div className="row">
          <div className="pull-right col-xs-6 col-lg-4">
            <div className="has-float-label">
              <select
                id="myPostsSort"
                className="form-control -sm"
                value={this.props.selectedSortIndex}
                onChange={this.props.onSortChanged}>
                {this.props.sortKeys.map((item, i) =>
                  <option value={i} key={i}>{item.label}</option>)}
              </select>
              <label
                className="control-label my-posts__filter-label"
                htmlFor="myPostsSort">
                  {Labels.getLabel("Sort")}:
              </label>
            </div>
          </div>
          <div className="col-xs-6 col-lg-4">
            <div className="has-float-label">
              <select
                id="myPostsStatus"
                className="form-control -sm"
                value={this.props.selectedStatusValue}
                onChange={this.props.onStatusChanged}>
                {this.props.statusItems.map(item =>
                  <option value={item.value} key={item.value}>{item.label}</option>)}
              </select>
              <label
                className="control-label my-posts__filter-label"
                htmlFor="myPostsStatus">
                  {Labels.getLabel("Status")}:
                </label>
            </div>
          </div>
        </div>
      </form>
    )
  }
})

// === NoContent.js ===
var NoContent = React.createClass({
  propTypes: {
    message: React.PropTypes.string,
    center: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      message: "",
      center: true
    }
  },
  render() {
    return (
      <div className={classNames("no-content", {"-center": this.props.centered})}>
        {this.props.message}
        {this.props.children}
      </div>
    )
  }
})

// === NoResults.js ===
var NoResults = React.createClass({
  propTypes: {
    showResetFilters: React.PropTypes.bool,
    onFilterResetClicked: React.PropTypes.func,
    message: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      showResetFilters: false,
      message: Labels.getLabel("No results were found for your search.")
    }
  },
  getResetLink() {
    return (
      <li>
        {Labels.getLabel("Try to")} <a role="button" href="#" onClick={this.props.onFilterResetClicked}>{Labels.getLabel("reset filters")}</a>
      </li>
    )
  },
  render() {
    return (
      <div className="no-results">
        <p>{this.props.message}</p>

        <ul className="bullet-list">
          {this.props.showResetFilters ? this.getResetLink() : null}
        </ul>
      </div>
    )
  }
})

// === Overlay.js ===
var Overlay = React.createClass({
  propTypes: {
    imageTimeout: React.PropTypes.number,
    showImage: React.PropTypes.bool,
    imageUrl: React.PropTypes.string,
    onClick: React.PropTypes.func,
    wrap: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      imageTimeout: 3000,
      imageUrl: `${Config.contextPath}/app/images/loading-circle.gif`,
      showImage: true,
      wrap: false
    }
  },
  getInitialState() {
    return {
      imageVisible: false
    }
  },
  componentDidMount() {
    if (this.props.showImage) {
      setTimeout(() => {
        if (this.isMounted()) this.setState({imageVisible: true})
      }, this.props.imageTimeout);
    }
  },
  overlayClicked: function() {
    if (this.props.onClick) {
      this.props.onClick();
    }
  },
  wrapOverlay(overlay) {
    return (
      <div className="overlay-wrap">{overlay}</div>
    )
  },

  render() {
    let {
      showImage,
      imageUrl,
      wrap
    } = this.props;

    let img = showImage ?
        <img src={imageUrl} className={this.state.imageVisible ? "in" : ""}/> : null;

    let overlay = (
      <div className="overlay" onClick={this.overlayClicked}>
        {img}
      </div>
    );

    return wrap ? this.wrapOverlay(overlay) : overlay;
  }
})

// === RA.AIChat.js ===
var AIChat = React.createClass({
    getInitialState: function () {
        return {
            isInterrogativeFirstRequestGpt: false
        };
    },
    setIsInterrogativeFirstRequestGpt(value) {
        this.setState({ isInterrogativeFirstRequestGpt: value });
    },
    render: function () {
        return (
            <div hidden={!this.state.isInterrogativeFirstRequestGpt} className="ai-chat-app">
                <AIChatWindow setIsInterrogativeFirstRequestGpt={this.setIsInterrogativeFirstRequestGpt} />
            </div>
        );
    }
});

// === RA.AIChatMessage.js ===
var AIChatMessage = React.createClass({

    getInitialState: function () {
        return {
            likeDisabled: false,
            dislikeDisabled: false,
        };
    },

    handleReaction: function (message, reaction) {
        let url = `${Config.contextPath}/controller/services/gpt?action=feedback`;
        let data = {
            conversationId: this.props.chatItem.conversationId,
            messageId: message.id,
            feedback: reaction,
            ticketId: this.getTicketId()
        };

        var headers = new Headers();
        headers.append('SToken', Config.csrf.value);

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(res => {
                if (reaction === 1) {
                    this.setState({ likeDisabled: true, dislikeDisabled: false });
                } else if (reaction === -1) {
                    this.setState({ likeDisabled: false, dislikeDisabled: true });
                }

                this.processFeedbackAndCopyback(message, reaction);
            })
            .catch(error => {
                console.error('Error sending or receiving chatItems:', error);
            });
    },

    handleCopyToClipboard: function () {
        const textToCopy = this.props.chatItem.details.text;
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);

        textArea.select();
        document.execCommand('copy');

        document.body.removeChild(textArea);
        alert('Message copied to clipboard!');
    },

    processFeedbackAndCopyback: function (message, reaction) {
        if (message && message.references && message.references.length > 0) {
            let solutionIDs = [];
            for (const solution of message.references) {
                solutionIDs.push(solution.id);
            }

            // Logging Feedback
            this.logFeedback(message, reaction, solutionIDs);

            // Processing solutions copyback
            if (Config.copyToIncidentEnabled && reaction === 1) {
                this.doGenAnswersCopyback(message, solutionIDs);
            }
        }
    },

    logFeedback: function (message, reaction, solutionIDs) {
        let feedbackLogAction;
        if (reaction === 1) {
            feedbackLogAction = "AI_HELPFUL";
        } else {
            feedbackLogAction = "AI_NOT_HELPFUL";
        }

        let logData = {
            conversationId: this.props.chatItem.conversationId,
            solutionIDs: solutionIDs,
            logAction: feedbackLogAction,
            description: RA.KBSearch.query.querytext
        };

        let headers = new Headers();
        headers.append('SToken', Config.csrf.value);

        let url = `${Config.contextPath}/controller/services/gpt?action=aiConversationLog`;
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(logData)
        }).catch(error => {
            console.error('Error logging AI Conversation:', error);
        });
    },

    doGenAnswersCopyback: function (message, solutionIDs) {
        let data = {
            answer: message.text,
            solutionReferencesIDs: solutionIDs
        };

        if (!Config.copyToIncident) {
            console.error('Error: Cannot do Gen Answers Copyback. Copyback URL is not configured.');
            return;
        }

        let url = Config.contextPath + Config.copyToIncident + "?genanswer=true";
        let headers = new Headers();
        headers.append('SToken', Config.csrf.value);

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Copyback request failed: ' + response.status);
            }
            return response.text();
        })
        .then(function (html) {
            // JSON in the script can contain "</script>" and the parser would truncate
            let lastScriptOpen = html.lastIndexOf('<script');
            if (lastScriptOpen === -1) {
                console.error('Error processing copyback script.');
                return;
            }
            let scriptStart = html.indexOf('>', lastScriptOpen) + 1;
            let scriptEnd = html.lastIndexOf('</script>');
            if (scriptStart <= 0 || scriptEnd < scriptStart) {
                console.error('Error processing copyback script.');
                return;
            }
            let scriptContent = html.substring(scriptStart, scriptEnd);
            let scriptEl = document.createElement('script');
            scriptEl.textContent = scriptContent;
            document.body.appendChild(scriptEl);
            scriptEl.remove();
        })
        .catch(function (error) {
            console.error('Error processing copyback:', error);
        });
    },

    getTicketId: function() {
        let ticketId = $("#ticketID").val();
        if (ticketId === "") {
            ticketId = sessionStorage.getItem('hdticketid');
            if (!ticketId) {
                console.log("No ticket id passed.");
                ticketId = "";
            }
        }
        return ticketId;
    },

    render: function () {
        var self = this;
        let chatItem = this.props.chatItem;
        let details = chatItem.details;
        let references = details.references;
        return (
            <div key={this.props.key} className={`ai-chat-message-item ${chatItem.sender}`}>
                <div id={details.id} className={`ai-chat-message ${chatItem.sender}`}>
                    <div dangerouslySetInnerHTML={{ __html: details.text }} />
                    {chatItem.sender === "bot" && references && references.length > 0 && (
                        <div className="ai-chat-message-citations-container">
                            <span hidden={!references}>Learn more:</span>
                            <div className="ai-chat-message-citations-list">
                                {references.map((reference, index) =>
                                    <div key={reference.id} className="ai-chat-message-citation">
                                        <a
                                            href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${reference.id}&page=-1&position=${index}`}
                                            target="_blank"
                                            title={reference.title}
                                        >
                                            {reference.title}
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {chatItem.sender === 'bot' && details.isFeedbackAllowed && (
                        <div className="ai-chat-message-buttons">
                            <button title="Like" onClick={() => self.handleReaction(details, 1)} disabled={this.state.likeDisabled}>
                                <span className="glyphicon glyphicon-thumbs-up"></span>
                            </button>
                            <button title="Dislike" onClick={() => self.handleReaction(details, -1)} disabled={this.state.dislikeDisabled}>
                                <span className="glyphicon glyphicon-thumbs-down"></span>
                            </button>
                            <button title="Copy to Clipboard" onClick={this.handleCopyToClipboard}>
                                <span className="glyphicon glyphicon-copy"></span>
                            </button>
                        </div>
                    )}
                </div>
            </div>

        );
    }
});


// === RA.AIChatWindow.js ===
var AIChatWindow = React.createClass({
    getInitialState: function () {
        return { chatItems: [], conversationId: '', addScrollEvent: true, stopEventScroll: false, clickedChatItem: [], glossaryTermPosition: [] };
    },

    componentDidMount: function () {
        let sessionGenAIResponse = JSON.parse(sessionStorage.getItem("genAIResponse"));
        if (sessionGenAIResponse && sessionGenAIResponse.length) {
            this.setState({ chatItems: sessionGenAIResponse });
        }
        const aiChatContainer = this.refs.aiChatContainer;
        aiChatContainer.addEventListener("scroll", this.hideTooltipOnScroll);
    },

    componentDidUpdate: function () {
        let activeTab = document.getElementsByClassName("tab-pane active")[0].id;
        if (this.state.addScrollEvent) {
            let chatApp = document.getElementsByClassName("ai-chat-app");
            if (chatApp && chatApp.length > 0) {
                chatApp = chatApp[0];
                let kbTabPaneId = chatApp.closest(".tab-pane").id;
                
                if (activeTab !== kbTabPaneId) {
                    let that = this;
                    document.querySelectorAll(`a[href="#${kbTabPaneId}"]`).forEach((kbLink) => {
                        let kbTab = kbLink.closest("li");
                        if (kbTab) {
                            kbTab.addEventListener("click", that.handleScrollEvent.bind(that));
                            that.setState({ addScrollEvent: false });
                        }
                    });
                }
            }
        }
        this.handleScroll();
    },

    componentWillUnmount: function () {
        const aiChatContainer = this.refs.aiChatContainer;
        aiChatContainer.removeEventListener("scroll", () => {});
    },

    handleScroll: function () {
        let messageContainer = document.querySelector(".ai-chat-message-container");
        let lastUserMsg = document.querySelectorAll(".ai-chat-message-item.user");
        
        if (messageContainer && lastUserMsg && lastUserMsg.length > 0 && messageContainer.nextElementSibling.className !== "glossary-def-tooltip") {
            lastUserMsg = lastUserMsg[lastUserMsg.length -1];
            let lastMsgOffset = lastUserMsg.offsetTop;
            lastMsgOffset = lastMsgOffset > 25 ? lastMsgOffset - 25 : lastMsgOffset;
            messageContainer.scrollTo({
                top: lastMsgOffset,
                behavior: "smooth"
            });
        }
    },

    handleScrollEvent: function () {
        let that = this;
        if (!that.state.stopEventScroll) {
            setTimeout(() => {
                let chatApp = document.getElementsByClassName("ai-chat-app");
                if (chatApp && chatApp.length > 0) {
                    chatApp = chatApp[0];
                    let kbTab = chatApp.closest(".tab-pane");

                    if (kbTab.classList.contains("active")) {
                        that.handleScroll();
                        that.setState({ stopEventScroll: true });
                    }
                }
            }, 100);
        }
    },

    handleBotResponse: function (res) {
        const {response:botResponse = {}}  = res;
        if (!botResponse) {
            return;
        }
        this.setState({ conversationId: botResponse.conversationId });
        var chatItem = {
            requestText: botResponse.requestText,
            details: botResponse.message,
            conversationId: botResponse.conversationId,
            isInterrogativeOrRequest: botResponse.isInterrogativeOrRequest,
            sender: 'bot',
            contextCleared: botResponse.contextCleared,
            glossary: res.glossary
        };
        var chatItems = this.state.chatItems.concat([chatItem]);
        sessionStorage.setItem("genAIResponse", JSON.stringify(chatItems));
        this.setState({ chatItems: chatItems });
    },

    handleUserMessage: function (userMessage) {
        var newUserMessage = { details: { text: userMessage }, sender: 'user' };
        var updatedMessages = this.state.chatItems.concat([newUserMessage]);
        this.setState({ chatItems: updatedMessages });
    },

    resetMessages: function () {
        this.setState({ chatItems: [] });
        sessionStorage.removeItem("genAIResponse");
    },

    hideTooltipOnScroll: function() {
        const glossaryTooltip = document.querySelector(".glossary-def-tooltip");
        if (glossaryTooltip) {
            glossaryTooltip.style.display = "none";
        }
    },

    handleClickMessageContainer: function (e) {
        let clickedChatItem, xPosition, yPosition;
        const target = e.target;
        const dataTerm = target.getAttribute("data-term");
        const aiChatContainer = this.refs.aiChatContainer;
        const glossaryTooltip = document.querySelector(".glossary-def-tooltip");
        if (target.classList.contains("glossary-def")) {
            clickedChatItem = this.state.chatItems.find( (item) => item.glossary && item.glossary[dataTerm]).glossary[dataTerm];
            xPosition = (target.offsetTop + target.offsetParent.offsetTop + 30) - aiChatContainer.scrollTop;
            yPosition = target.offsetLeft + 20;
            this.setState((prevState) => (Object.assign(prevState, { glossaryTermPosition: [xPosition, yPosition], clickedChatItem })));
            if (glossaryTooltip) {
                glossaryTooltip.style.display = "block";
            }
        }

        if (!target.classList.contains("glossary-def") && !target.classList.contains("glossary-def-tooltip") && !target.classList.contains("search-text-highligher")) {
            this.setState({clickedChatItem:[]});
        }

    },

    render: function () {
        var self = this;
        var chatItems = this.state.chatItems.map(function (chatItem, index) {
            return <AIChatMessage key={index} chatItem={chatItem} />;
        });

        return (
            <div className="chat-window">
                <div className="ai-chat-message-container" ref="aiChatContainer" onClick={this.handleClickMessageContainer}>
                    {chatItems}
                </div>
                {Object.keys(this.state.clickedChatItem).length > 0 ?
                        <GlossaryTooltip glossaryTermPosition={this.state.glossaryTermPosition} glossaryData={this.state.clickedChatItem}/>
                        : null}
                <AIMessageInput 
                    onBotResponse={this.handleBotResponse} 
                    onUserMessage={this.handleUserMessage} 
                    onSearchChanged={this.resetMessages}
                    setIsInterrogativeFirstRequestGpt={this.props.setIsInterrogativeFirstRequestGpt}
                />
            </div>
        );
    }
});


// === RA.AIMessageInput.js ===
var AIMessageInput = React.createClass({
    getInitialState: function () {
        return {
            firstRequest: false, inputText: '',
            conversationId: '', isLoading: false,
            followupQuestions: [], contextCleared: false,
            sameRequestCount: 0,
            wordDict: Config.aiChatTriggerList,
            gptCurrentRequestId: 0
        };
    },

    componentDidMount: function () {
        if (RA.KBSearch.query.querytext && RA.KBSearch.query.querytext.length > 0) {
            let sessionGenAIResponse = JSON.parse(sessionStorage.getItem("genAIResponse"));
            if (sessionGenAIResponse && sessionGenAIResponse.length) {
                if (sessionGenAIResponse[0].requestText !== RA.KBSearch.query.querytext) {
                    sessionStorage.removeItem("genAIResponse");
                    this.setState({
                        firstRequest: true,
                        inputText: RA.KBSearch.query.querytext,
                        followupQuestions: []
                    }, () => {
                        this.handleSubmit();
                    });
                } else {
                    let lastMsg = sessionGenAIResponse.slice(-1)[0]
                    if (lastMsg.details.followupQuestions && lastMsg.details.followupQuestions.length) {
                        this.setState({ followupQuestions: lastMsg.details.followupQuestions })
                    }

                    this.setState({
                        contextCleared: lastMsg.contextCleared,
                        conversationId: lastMsg.conversationId
                    });
                    this.props.setIsInterrogativeFirstRequestGpt(lastMsg.isInterrogativeOrRequest);
                }
            } else {
                this.setState({ firstRequest: true, inputText: RA.KBSearch.query.querytext }, () => {
                    this.handleSubmit();
                });
            }
        }

        // Add 'keyup' event listener to input elements
        const inputElements = document.getElementsByClassName("main-search__input");
        for (const element of inputElements) {
            element.addEventListener('keyup', this.handleSearchInputChange);
        }

        // Add 'click' event listener to button elements
        const buttonElements = document.getElementsByClassName("main-search__button");
        for (const element of buttonElements) {
            element.addEventListener('click', this.handleSearchButtonClick);
        }

    },

    componentDidUpdate() {
        if (RA.KBSearch.isFilterApplied() && RA.KBSearch.filterApplied) {
            this.handleSubmitValidation()
        }
    },

    componentWillUnmount() {
        // Remove 'keyup' event listener from input elements
        const inputElements = document.getElementsByClassName("main-search__input");
        for (const element of inputElements) {
            element.removeEventListener('keyup', this.handleSearchInputChange);
        }

        // Remove 'click' event listener from button elements
        const buttonElements = document.getElementsByClassName("main-search__button");
        for (const element of buttonElements) {
            element.removeEventListener('click', this.handleSearchButtonClick);
        }

        if (this.currentController) {
            this.currentController.abort();
        }
    },

    handleSubmitValidation() {
        let sessionGenAIResponse = JSON.parse(sessionStorage.getItem("genAIResponse"));
        let $queryInput = $(".main-search__input");
        if (sessionGenAIResponse && sessionGenAIResponse.length) {
            if (sessionGenAIResponse[0].requestText === $queryInput.val()) {
                if (this.state.sameRequestCount >= 10 || RA.KBSearch.filterApplied) {
                    this.setState({
                        sameRequestCount: 0,
                        firstRequest: true,
                        inputText: $queryInput.val(),
                        followupQuestions: []
                    }, () => {
                        this.handleSubmit();
                    });
                    this.props.onSearchChanged();
                } else {
                    this.setState({ sameRequestCount: this.state.sameRequestCount += 1 });
                }
            } else {
                this.setState({
                    sameRequestCount: 0,
                    firstRequest: true,
                    inputText: $queryInput.val(),
                    followupQuestions: []
                }, () => {
                    this.handleSubmit();
                });
                this.props.onSearchChanged();
            }
        }
    },

    handleSearchInputChange: function (event) {
        let $queryInput = $(".main-search__input");
        if ($queryInput.val().trim() !== "" && event.key === 'Enter') {
            this.handleSubmitValidation()
        }
    },

    handleSearchButtonClick(event) {
        let $queryInput = $(".main-search__input");
        if ($queryInput.val().trim() !== "" && event.pointerType === "mouse") {
            this.handleSubmitValidation()
        }
    },

    handleInputChange: function (event) {
        this.setState({ inputText: event.target.value });
    },

    sendFollowUpQuestion: function (followupQuestion) {
        this.setState({ inputText: followupQuestion }, () => {
            this.handleSubmit();
        });
    },

    handleSubmit: function () {
        RA.KBSearch.filterApplied = false;
        let self = this;

        const requestId = self.state.gptCurrentRequestId + 1;
        self.setState({ gptCurrentRequestId: requestId });

        if (self.currentController) {
            self.currentController.abort();
        }

        self.currentController = new AbortController();
        const { signal } = self.currentController;

        self.setState({ isLoading: true });

        let tempInputText = self.state.inputText;
        let url = `${Config.contextPath}/controller/services/gpt?action=chat`;
        let data = {
            conversationId: self.state.firstRequest ? '' : self.state.conversationId,
            text: self.state.inputText,
            query: RA.KBSearch.query
        };

        var headers = new Headers();
        headers.append('SToken', Config.csrf.value);


        if (!self.state.firstRequest) {
            self.props.onUserMessage(self.state.inputText);
        }

        if (self.state.wordDict.length === 1 && self.state.wordDict[0] === "*") {
            self.props.setIsInterrogativeFirstRequestGpt(true);
        } else {
            const chatTriggerList = self.state.wordDict.map(word => word.toLowerCase());
            const regex = new RegExp(`\\b(${chatTriggerList.join("|")})\\b`, "i");

            const text = self.state.inputText.toLowerCase();
            const isMatch = regex.test(text);

            if (isMatch) {
                self.props.setIsInterrogativeFirstRequestGpt(true);
            }
        }

        self.setState({ inputText: '' });
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data),
            signal,
        })
            .then(response => response.json())
            .then(res => {
                if (self.state.firstRequest && !res.response.isInterrogativeOrRequest) {
                    self.props.setIsInterrogativeFirstRequestGpt(res.response.isInterrogativeOrRequest);
                } else {
                    self.props.setIsInterrogativeFirstRequestGpt(true);
                    self.setState({ firstRequest: false });
                    if (res.code === 200) {
                        self.setState({ conversationId: res.response.conversationId });
                        self.setState({ followupQuestions: res.response.message.followupQuestions });
                        self.setState({ contextCleared: res.response.contextCleared });
                    }
                }
                if (res.code === 200) {
                    res.response.requestText = tempInputText;
                    self.props.onBotResponse(res);
                }

                // Logging solutions included in the AI chat response with AI_USE action
                let chatMessage = res.response.message;
                if (chatMessage && chatMessage.references && chatMessage.references.length > 0) {
                    let solutionIDs = [];
                    for (const solution of chatMessage.references) {
                        solutionIDs.push(solution.id);
                    }

                    let logData = {
                        conversationId: self.state.conversationId,
                        solutionIDs: solutionIDs,
                        logAction: "AI_USE",
                        description: RA.KBSearch.query.querytext
                    };

                    let urlHeaders = new Headers();
                    urlHeaders.append('SToken', Config.csrf.value);

                    let url = `${Config.contextPath}/controller/services/gpt?action=aiConversationLog`;
                    fetch(url, {
                        method: 'POST',
                        headers: urlHeaders,
                        body: JSON.stringify(logData)
                    }).catch(error => {
                        console.error('Error logging AI Conversation:', error);
                    });
                }
            })
            .catch(error => {
                console.error('Error sending or receiving messages:', error);
            })
            .finally(() => {
                if (self.state.gptCurrentRequestId === requestId) {
                    self.setState({ isLoading: false });
                }
            });
    },

    getLinkedTermsUrl: () => {
        const aiAnswerGenerationUrl = RA.KBSearch.getAiAnswerGenerationUrl();
        if (aiAnswerGenerationUrl && aiAnswerGenerationUrl.includes("openai")) {
            return "https://help.uplandsoftware.com/disclaimers/openai.htm";
        }

        return "https://help.uplandsoftware.com/disclaimers/upland.htm";
    },

    render: function () {
        return (
            this.state.isLoading ? (
                <div className="typing-indicator">
                    <div className="typing-indicator-dot"></div>
                    <div className="typing-indicator-dot"></div>
                    <div className="typing-indicator-dot"></div>
                </div>
            ) : (
                <div className="ai-chat-message-input">
                    {this.state.followupQuestions && this.state.followupQuestions.length > 0 &&
                        <div className="suggestion-container">
                            {this.state.followupQuestions.map((followupQuestion, index) => (
                                <div key={index}
                                    className="ai-chat-suggestion" style={{ cursor: 'pointer' }}
                                    onClick={() => this.sendFollowUpQuestion(followupQuestion)}>
                                    <div>
                                        <span className="glyphicon glyphicon-question-sign"></span>
                                        {followupQuestion}
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                    {!this.state.contextCleared && (
                        <div className="input-container">
                            <input
                                type="text"
                                placeholder="Type your message..."
                                value={this.state.inputText}
                                onChange={this.handleInputChange}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        this.handleSubmit();
                                    }
                                }}
                            />
                            <button onClick={this.handleSubmit}
                                disabled={!this.state.inputText}
                                className={!this.state.inputText ? 'ai-disabled-button' : ''}>
                                <span className="glyphicon glyphicon-send"></span>
                            </button>
                        </div>
                    )}
                    <div className="disclaimer-message">
                        <span>Upland AI Disclaimer:</span>
                        AI responses can be inaccurate. Consider checking important information.
                        <p>
                            By accessing the functionality, you agree to the
                            <a target="_blank" href={this.getLinkedTermsUrl()}>linked terms.</a>
                        </p>
                    </div>
                </div>
            )
        );
    }
});


// === RA.CommunityBrowser.js ===
RA.CommunityBrowser = {
  init(community) {
    this.community = community;

    if (!RA.Utils.isDigits(this.community.id)) {
      this.showInvalidCommunity();
      return;
    }

    this.setVariables();
    this.bindEvents();

    this.refreshTitle();
    this.refreshTopics();
    this.updateCommunityContext();

    RA.showOverlay(this.$content);
    RA.CommunitySearch.search(this.createQuery(), this.initSearchDone.bind(this));
  },
  setVariables() {
    this.$quickSearches = $("#commQuickSearches");
    this.$content = $("#commBrowserContent");
    this.source = "all";
    this.filterTopicIDs = [];
    this.pageNumber = 1;
  },
  loadSource() {
    let source = this.source;

    RA.showOverlay(this.$content);

    if (source == "trending") {
      this.loadTrending();
    } else if (source == "latest") {
      this.loadLatest();
    } else if (source == "noreplies") {
      this.loadNoReplies();
    } else {
      this.loadAll();
    }
  },
  bindEvents() {
    this.$quickSearches.find("a").on("click", this.quickSearchClicked.bind(this));
  },
  loadAll() {
    let query = this.createQuery();
    query.sortBy = "last_modified_date";

    RA.CommunitySearch.search(query, this.searchDone.bind(this));
  },
  loadTrending() {
    let url = Config.contextPath + "/controller/socialsearch/trending/";

    $.get(url, this.createQuery())
      .done(this.otherDone.bind(this))
      .fail(RA.handleAjaxError);
  },
  loadLatest() {
    let url = Config.contextPath + "/controller/socialsearch/latest/";

    $.get(url, this.createQuery())
      .done(this.otherDone.bind(this))
      .fail(RA.handleAjaxError);
  },
  loadNoReplies() {
    let query = this.createQuery();
    query.startAnswerCount = 0;
    query.endAnswerCount = 0;
    query.descending = false;

    RA.CommunitySearch.search(query, this.searchDone.bind(this));
  },
  createQuery() {
    let query = {communityID: this.community.id,
      sortBy: "last_modified_date",
      descending: true};

    if (this.filterTopicIDs.length != 0) {
      query.topicID = this.filterTopicIDs.join(";");
    }

    if (this.pageNumber > 1) {
      query.currentpage = this.pageNumber;
    }

    return query;
  },
  resetFilter() {
    this.filterTopicIDs = [];
    this.pageNumber = 1;
  },
  initSearchDone(searchResults) {
    this.showHits(searchResults);
    this.refreshTitle(searchResults);
    RA.hideOverlay(this.$content);
    this.updateTopicCounts(searchResults.topics);
    this.refreshTopics();

    let topicIDs = RA.Utils.getQueryParam("topicID");
    let doTopicFilter = false;

    if (RA.Utils.isNotBlank(topicIDs)) {
      topicIDs = topicIDs.split(";")
        .filter(RA.Utils.isDigits)
        .map(idStr => parseInt(idStr));

      let allTopicIDs = this.community.topics.map(t => t.id);
      topicIDs = topicIDs.filter(id => allTopicIDs.indexOf(id != -1));
      doTopicFilter = topicIDs.length > 0;
    }

    let source = RA.Utils.getQueryParam("source");
    let doSourceChange = RA.Utils.isNotBlank(source) && source !== "all";

    let pageNumber = RA.Utils.getQueryParam("page");
    let doPageChange = RA.Utils.isDigits(pageNumber) && pageNumber != 1;

    if (doSourceChange) {
      this.source = source;
      this.$quickSearches.find("a[href='#" + this.source + "']").tab("show");
    }
    if (doTopicFilter) {
      this.filterTopicIDs = topicIDs;
      this.updateCommunityContext()
    }
    if (doPageChange) this.pageNumber = pageNumber;

    if (doTopicFilter || doSourceChange || doPageChange) {
      this.loadSource();
    }
  },
  searchDone(searchResults) {
    if (this.filterTopicIDs.length == 0) {
      this.updateTopicCounts(searchResults.topics);
    }

    this.showHits(searchResults);
    RA.hideOverlay(this.$content);
    this.refreshTopics();
  },
  otherDone(searchResults) {
    if (this.filterTopicIDs.length == 0) {
      let topicCounts = this.getTopicCountsFromHits(searchResults.results);
      this.updateTopicCounts(topicCounts);
    }

    this.showHits(searchResults);
    RA.hideOverlay(this.$content);
    this.refreshTopics();
  },
  quickSearchClicked(e) {
    let $link = $(e.currentTarget);
    let target = $link.attr("href").substring(1);

    if (target == this.source) {
       return false;
    }

    this.$quickSearches.find(".active").removeClass("active");
    $link.closest("li").addClass("active");

    this.source = target;
    this.resetFilter();
    this.loadSource();
    this.updateHistory();

    return false;
  },
  resetTopicsClicked() {
    this.filterTopicIDs = [];
    this.loadSource();
    this.updateCommunityContext();
    this.updateHistory();
  },
  pageClicked(num) {
    this.pageNumber = num;

    window.scrollTo(0, this.$content.offset().top - 60);

    this.loadSource();

    this.updateHistory();
  },
  topicClicked(id) {
    if (this.filterTopicIDs.length && this.filterTopicIDs[0] == id) {
      return;
    }

    this.filterTopicIDs = [ id ];

    this.pageNumber = 1;
    this.loadSource();
    this.updateCommunityContext();
    this.updateHistory();
  },
  refreshTitle(searchResults) {
    let totalHits = "-";
    let countLabel = "questions";
    let topicLabel = this.community.topics.length == 1 ? "topic" : "topics";

    if (searchResults) {
       countLabel = searchResults.totalHits == 1 ? "question" : "questions";
       totalHits = searchResults.totalHits;
    }

    ReactDOM.render(
      <CommunityTitle community={this.community}
        className="-lg">
        <div className="text-muted">
          {`${totalHits} ${Labels.getLabel(countLabel)}`}
          {" | "}
          {`${this.community.topics.length} ${Labels.getLabel(topicLabel)}`}
          {" | "}
          <a href={`${Config.contextPath}/controller/post/discussion/?communityID=${this.community.id}`} data-action="post">
            {Labels.getLabel("Post your question")}
          </a>
        </div>
      </CommunityTitle>,
      document.getElementById("communityTitle")
    );
  },
  showHits(searchResults) {
    let hits = searchResults.results;
    let pagerDetail = searchResults.pagerDetail;

    if (hits.length == 0) {
      ReactDOM.render( this.getNoContent(), document.getElementById("commResults"));
      return;
    }

    let questionLabel = hits.length == 1 ? "question" : "questions";
    let pager = hits.length > 0 && pagerDetail && pagerDetail.totalPages > 1 ?
      <ResultsPager pagerDetail={pagerDetail}
        onPageClicked={this.pageClicked.bind(this)} />
      : null;

    ReactDOM.render(
      <div className="">
        {this.getResultHeader(searchResults)}
        <CommResultsList hits={hits} />
        {pager}
      </div>,
      document.getElementById("commResults")
    );
  },
  refreshTopics() {
    ReactDOM.render(
      <TopicsFilter topics={this.community.topics}
        selectedTopicsIDs={this.filterTopicIDs}
        onTopicClicked={this.topicClicked.bind(this)}
        onResetClicked={this.resetTopicsClicked.bind(this)} />,
      document.getElementById("commTopics")
    );
  },
  getResultHeader(searchResults) {
    let totalHits = searchResults.totalHits ? searchResults.totalHits : searchResults.results.length;
    let pagerDetail = searchResults.pagerDetail;
    let pageStart = 0;
    let pageEnd = 0;
    let questionLabel = totalHits == 1 ? "question" : "questions";

    if (pagerDetail) {
      pageStart = pagerDetail.pageStart;
      pageEnd = pagerDetail.pageEnd;
    }

    return (
      <div className="result-col__head">
        <ResultCountSummary totalHits={totalHits}
          pageStart={pageStart}
          pageEnd={pageEnd}
          resultName={Labels.getLabel(questionLabel)} />
      </div>
    )
  },
  getNoContent() {
      return (
        <NoContent message={Labels.getLabel("No matching questions found")} center={false} />
      );
  },
  showInvalidCommunity() {
    ReactDOM.render(
      <AlertMessage alertType="danger">
        <strong>{Labels.getLabel("Error")}</strong>:
        {" " + Labels.getLabel("The community you are trying to access does not exist.") + " "}
        <a href={`${Config.contextPath}/${Config.portalInterface}/?tabname=communities`} className="alert-link">
          {Labels.getLabel("Show all communities")}
        </a>
      </AlertMessage>,
      document.getElementById("communityBrowser")
    );
  },
  updateTopicCounts(topicData) {
    this.resetTopicCounts();

    topicData.forEach(topic => this.setTopicCount(topic.id, topic.hits));
  },
  resetTopicCounts() {
    this.community.topics.forEach(topic => topic.hits = 0);
  },
  setTopicCount(topicID, count) {
    this.community.topics.filter(topic => topic.id == topicID)[0].hits = count;
  },
  getTopicCountsFromHits(hits) {
    // create map with key=topicID, val=hitCount
    let countMap = hits.reduce((prevObj, currHit) => {
      if (prevObj[currHit.topic.id]) {
        prevObj[currHit.topic.id]++
      } else {
        prevObj[currHit.topic.id] = 1;
      }

      return prevObj;
    }, {});

    // Change to an array of objects {id: topicID, hits: hitCount}
    let topics = [];
    for (let topicID in countMap) {
      topics.push({id: topicID, hits: countMap[topicID]});
    }

    return topics;
  },
  updateCommunityContext() {
    let {community, filterTopicIDs} = this;

    let communityContext = { community: community };

    if (filterTopicIDs.length == 1) {
      let selectedTopic = community.topics.filter(t => t.id == filterTopicIDs[0]);
      if (selectedTopic.length == 1) {
        selectedTopic = selectedTopic[0];
        communityContext.topic = selectedTopic;
      }
    }

    RA.setCommunityContext(communityContext);
  },
  updateHistory() {
    if (!history.replaceState) return;

    let params = RA.Utils.getQueryParams();

    if (this.filterTopicIDs.length) {
      params.topicID = this.filterTopicIDs.join(";");
    } else {
      delete params.topicID;
    }

    if (this.pageNumber == 1) {
      delete params.page;
    } else {
      params.page = this.pageNumber;
    }

    params.source = this.source;

    history.replaceState({}, "", RA.Utils.buildQueryString(params));
  }
}


var TopicsFilter = React.createClass({
  propTypes: {
    topics: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    selectedTopicsIDs: React.PropTypes.arrayOf(React.PropTypes.number),
    onTopicClicked: React.PropTypes.func,
    onResetClicked: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedTopicsIDs: [],
      onResetClicked: function() {}
    };
  },
  topicClicked(topic, e) {
    e.target.blur();

    if (this.props.onTopicClicked) {
      this.props.onTopicClicked(topic.id);
    }
  },
  createItem(topic) {
    let isSelected = this.props.selectedTopicsIDs.indexOf(topic.id) != -1;
    let hitCount = topic.hits ? topic.hits : 0;

    return (
      <a href="#" className={"button-group__item" + (isSelected ? " active" : "")} key={topic.id} onClick={this.topicClicked.bind(this, topic)}>
        <span className="button-group__item-count">{hitCount}</span>
        {topic.name}
      </a>
    );
  },
  render() {
    let allLink;

    allLink = (
      <a href="#" className={"button-group__item" + (this.props.selectedTopicsIDs.length == 0 ? " active" : "")} onClick={this.props.onResetClicked}>
        {Labels.getLabel("All Topics")}
      </a>
    );

    return (
      <div className="filter">
        <h4 className="filter__title">{Labels.getLabel("Topics")}</h4>

        <div className="filter__list button-group">
          {allLink}
          {this.props.topics.map(this.createItem)}
        </div>
      </div>
    )
  }
})

// === RA.EmailNotifications.js ===
RA.EmailNotifications = {
  init() {
    this.setVariables();

    let url = `${Config.contextPath}/controller/get/mysubscriptions/`;
    $.get(url)
      .done(r => {
        this.solutions = r.kb;
        this.pageSize = r.pageSize;

        if (r.community) {
          this.discussions = r.community.discussions;
          this.topics = r.community.topics;
          this.communities = r.community.communities;
        }

        this.refreshLists();
        this.refreshEdit();
      });
  },
  setVariables() {
    this.solutions = [];
    this.discussions = [];
    this.topics = [];
    this.communities = [];
    this.showEditControls = false;
  },
  editClicked() {
    this.showEditControls = !this.showEditControls;
    this.refreshLists();
    this.refreshEdit();
  },
  deleteKBClicked(sub) {
    let solutions = this.solutions;
    let index = solutions.indexOf(sub);

    let url = `${Config.contextPath}/controller/delete/mysubscriptions/`;
    let data = {
      solutionID: sub.solutionID,
      SToken: Config.csrf.value
    };

    $.post(url, data);

    // optimistic remove from array
    solutions.splice(index, 1);
    this.refreshLists();
    this.refreshEdit();
  },
  deleteCommClicked(sub) {
    let {
      discussions,
      topics,
      communities
    } = this;
    let type = this.getItemType(sub);
    let url = `${Config.contextPath}/controller/delete/mysubscriptions/`;
    let data;

    if (type == "discussion") {
      data = { discussionID: sub.discussionID };
      discussions.splice(discussions.indexOf(sub), 1);
    } else if (type == "topic") {
      data = { topicID: sub.topicID };
      topics.splice(topics.indexOf(sub), 1);
    } else {
      data = { communityID: sub.communityID };
      communities.splice(communities.indexOf(sub), 1);
    }

    data.SToken = Config.csrf.value;

    $.post(url, data);

    this.refreshLists();
    this.refreshEdit();
  },
  getItemType(sub) {
    if (sub.solutionID) {
      return "solution";
    } else if (sub.discussionID) {
      return "discussion";
    } else if (sub.topicID) {
      return "topic";
    } else if (sub.communityID) {
      return "community";
    }
  },
  renderKBItem(sub) {
    return (
      <EditableListItem
        key={sub.solutionID}
        showDelete={this.showEditControls}
        onDelete={this.deleteKBClicked.bind(this, sub)}>
        <a href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${sub.solutionID}`}>{sub.title}</a>
      </EditableListItem>
    )
  },
  renderCommItem(sub) {
    let type = this.getItemType(sub);

    let href, text;
    if (type == "discussion") {
      href = `controller/view/discussion/${sub.discussionID}`;
      text = sub.title;
    } else if (type == "topic") {
      href = `${Config.portalInterface}/?tabname=community&topicID=${sub.topicID}&communityID=${sub.communityID}`;
      text = `${sub.community} > ${sub.topic}`;
    } else if (type == "community") {
      href = `${Config.portalInterface}/?tabname=community&communityID=${sub.communityID}`;
      text = sub.community;
    }

    return (
      <EditableListItem
        showDelete={this.showEditControls}
        key={sub.id}
        onDelete={this.deleteCommClicked.bind(this, sub)}>
        <a href={`${Config.contextPath}/${href}`}>{text}</a>
      </EditableListItem>
    )
  },
  refreshEdit() {
    let link = (
      <EditLinkToggle
        onClick={this.editClicked.bind(this)}
        editEnabled={this.showEditControls} />
    );

    if (this.solutions.length == 0 &&
      this.discussions.length == 0 &&
      this.communities.length == 0 &&
      this.topics.length == 0) link = <span />;

    ReactDOM.render(
      link,
      document.getElementById("editSubToggle")
    );
  },
  refreshLists() {
    let solutionSub = this.solutions.length ?
      <BasicPagerList
        className="bullet-list"
        items={this.solutions}
        renderItem={this.renderKBItem.bind(this)} /> :
      <NoContent message={Labels.getLabel("Not subscribed to any solutions")} />;

    let discussionSub = this.discussions.length ?
      <BasicPagerList
        className="bullet-list"
        pageSize={this.pageSize}
        items={this.discussions}
        renderItem={this.renderCommItem.bind(this)} /> :
      <NoContent message={Labels.getLabel("Not subscribed to any discussions")} />;

    let topicSub = this.topics.length ?
      <BasicPagerList
        className="bullet-list"
        pageSize={this.pageSize}
        items={this.topics}
        renderItem={this.renderCommItem.bind(this)} /> :
      <NoContent message={Labels.getLabel("Not subscribed to any topics")} />;

    let communitySub = this.communities.length ?
      <BasicPagerList
        className="bullet-list"
        pageSize={this.pageSize}
        items={this.communities}
        renderItem={this.renderCommItem.bind(this)} /> :
      <NoContent message={Labels.getLabel("Not subscribed to any communities")} />;

    ReactDOM.render(
      solutionSub,
      document.getElementById("solutionSub")
    );

    if (Config.isCommunityEnabled) {
      ReactDOM.render(
        discussionSub,
        document.getElementById("discussionSub")
      );

      ReactDOM.render(
        topicSub,
        document.getElementById("topicSub")
      );

      ReactDOM.render(
        communitySub,
        document.getElementById("communitySub")
      );
    }
  }
};

// === RA.Header.js ===
RA.Header = {
  init() {
    this.setVariables();
    this.bindEvents();

    this.initLoginLink();
  },
  setVariables() {
    this.$guestLoginLink = $("#guestLoginLink");
    this.$guestSignupLink  = $("#guestSignupLink");
    this.$profileButton = $("#profileButton");
    this.$profileMenu = this.$profileButton.next(".dropdown-menu");
    this.$langSelect = $("#language-selection-dropdown li a");
	this.$menuLinks = $("#mainNavCollapse ul li a");
  },
  bindEvents() {
    this.$langSelect.on("click.ra", this.languageChanged.bind(this));
    this.$profileButton.on("click.ra", this.profileButtonClicked.bind(this));
	this.$menuLinks.on("click.ra", this.menuLinkClicked.bind(this));
  },
  initLoginLink() {
    let prefix = location.search.length ? "&" : "?";
    let qs = location.search.replace(/%20/g, "+");
    qs = qs + prefix + "guest=0";
	qs = qs.replace(/&/g, "_amp_");

    let redirectTarget = encodeURIComponent(location.pathname + qs);
    let url = `${Config.contextPath}/${Config.portalInterface}/logout.jsp?redir=${redirectTarget}`;

    this.$guestLoginLink.attr("href", url);
    this.$guestSignupLink.attr("href", url);
  },
  languageChanged(e) {
    this.closeProfileMenu();

	let selectedLanguageCode = e.currentTarget.getAttribute("data-language");

    let url = `${Config.contextPath}/app/portlets/languagesettings/sessionbrowsercode.jsp`;
    let data = { code: selectedLanguageCode,
      SToken: Config.csrf.value
    };

    $.post(url, data)
      .done(() => window.location.reload());
  },
  profileButtonClicked(e) {
    let isOpen = this.$profileMenu.is(":visible");

    if (isOpen) {
      this.closeProfileMenu();
    } else {
      this.openProfileMenu();
    }
  },
  documentClicked(e) {
    let $target = $(e.target);
    let isChild = $target.closest(this.$profileMenu).length == 1;
    let isButton = $target.closest(this.$profileButton).length == 1;
    let isChildLink = isChild && $target.is("a");

    if (isButton || isChild) {
      if (!isChildLink) {
        return;
      }
    }

    this.closeProfileMenu();
  },
  openProfileMenu() {
    this.$profileMenu.show();
    this.$profileButton.attr("aria-expanded", true);
    this.$profileButton.addClass("-active");
    $(document).on("click.ra.profileMenu", this.documentClicked.bind(this));
  },
  closeProfileMenu() {
    this.$profileMenu.hide();
    this.$profileButton.attr("aria-expanded", false);
    this.$profileButton.removeClass("-active");
    $(document).off(".profileMenu");
  },
  menuLinkClicked() {
    var $menu = $("#mainNavCollapse");
	if ($menu.hasClass("in")) {
		$menu.removeClass("in");
		$menu.attr("aria-expanded", false);
	}
  }
}

// === RA.KBSearch.js ===
RA.KBSearch = {
  searchUrl: Config.contextPath + "/controller/search/json",
  showBrowseHits: false,
  showDidYouMean: false,
  showHitSummary: true,
  showRelevancyStars: true,
  filterApplied: false,
  kbFilterApplied: false,
  nonFederatedKbFilterApplied: false,
  commFilterApplied: false,
  query: {},

  getShowCollectionFilter() {
	  return Config.showCollectionFilter;
  },getShowAttributeFilter() {
	  return Config.showAttributeFilter;
  },getShowFavoriteFilter() {
    return Config.maxSearchableFavorites > 0;
  },isAiChatEnabled() {
    return Config.aiChatIsEnabled;
  },
  getAiAnswerGenerationUrl() {
    return Config.aiAnswerGenerationUrl;
  },
  search(query, callback, extraParams) {
    this.query = query;

    const excludedKeys = ["querytext", "advstatuses", "sortBy", "sortChanged", "searchCriteria"];

    if (Object.entries(this.query).filter(([key]) => !excludedKeys.includes(key)).some(([key, value]) => value)) {
      if (this.searchUrl.includes("socialsearch")) {
        RA.KBSearch.commFilterApplied = true
      } else if (this.searchUrl.includes("nonfederatedrakesearch")) {
        RA.KBSearch.nonFederatedKbFilterApplied = true;
      } else {
        RA.KBSearch.kbFilterApplied = true;
      }
    } else {
      if (this.searchUrl.includes("socialsearch")) {
        RA.KBSearch.commFilterApplied = false
      } else if (this.searchUrl.includes("nonfederatedrakesearch")) {
        RA.KBSearch.nonFederatedKbFilterApplied = false;
      } else {
        RA.KBSearch.kbFilterApplied = false;
      }
    }

    let data = $.extend({}, this.query);
    if (extraParams) {
      $.extend(data, extraParams);
    }

    $.get(this.searchUrl, data)
      .done(res => {
        res.preventChatTrigger = extraParams && extraParams.doSearchLogging === false;
        callback(res);
      })
      .fail(RA.handleInvisibleAjaxError);
  },
  applyFilter(filter, callback, extraParams) {
    $.extend(this.query, filter);
    this.filterApplied = true;
    // Reset page and remove any empty query params
    delete this.query.currentpage;
    for (let key in this.query) {
      if (this.query[key] === "") {
        delete this.query[key];
      }
    }

    if (!extraParams) {
      extraParams = {isbrowse: true};
    }

    this.search(this.query, callback, extraParams);
  },
  resetFilters(callback) {
    let queryText = this.query.querytext;

    this.query = {};

    if (queryText != undefined && queryText.length) {
      this.query.querytext = queryText;
    }

    this.applyFilter(this.query, callback);
  },
  
  resetNonFederatedRakeTabFilters(callback, extraParams) {
    let queryText = this.query.querytext;

    this.query = {};

    if (queryText != undefined && queryText.length) {
      this.query.querytext = queryText;
    }

    this.applyFilter(this.query, callback, extraParams);
  },
  
  loadPage(num, callback) {
    this.query.currentpage = num;
    this.search(this.query, callback);
  },

  nonFederatedRakeLoadPage(num, callback, extraParams) {
    this.query.currentpage = num;
    this.search(this.query, callback, extraParams);
  },
  
  isFilterApplied() {
    return !Object.keys(this.query).every(key => {
      return key == "querytext" || key == "currentpage" || this.query[key] === ""
    });
  }
};

RA.CommunitySearch = Object.create(RA.KBSearch);
$.extend(RA.CommunitySearch, {
  searchUrl: Config.contextPath + "/controller/socialsearch/json"
});

RA.RakeNonFederatedSearch = Object.create(RA.KBSearch);
$.extend(RA.RakeNonFederatedSearch, {
  searchUrl: Config.contextPath + "/controller/nonfederatedrakesearch/json"
});


// === RA.LatestQuestions.js ===
RA.LatestQuestions = {
  init() {
    let url;

    url = Config.contextPath + "/controller/socialsearch/latest/";
    $.get(url)
      .done(this.latestQuestionsDone)
      .fail(RA.handleAjaxError);
  },
  latestQuestionsDone(r) {
    let component;

    if (r.results.length) {
      component = (
        <CommResultsList showIcon={false}
          hits={r.results} />
      )
    } else {
      component = (
        <NoContent message={Labels.getLabel("No recent questions")}>
          <p>
            <a href={Config.contextPath + "/controller/post/discussion/"}>
              {Labels.getLabel("Post your question")}</a>
          </p>
        </NoContent>
      );
    }

    ReactDOM.render(component, document.getElementById("latestQuestions"));
  }
}

// === RA.ListCommunities.js ===
RA.ListCommunities = {
  init() {
    let url = Config.contextPath + "/controller/socialbrowse/json";
    let data = {type: "communities" };

    $.get(url, data)
      .done(this.communitiesDone)
      .fail(RA.handleAjaxError);
  },
  communitiesDone(r) {
    let component;

    if (r.communities.length) {
      component = <CommunityShortcut communities={r.communities}  />;
    } else {
      component = <NoContent message={Labels.getLabel("No communities have been set up")} />;
    }

    ReactDOM.render(component, document.getElementById("browseCommunityTiles"));
  }
};

// === RA.MostHelpfulSolutions.js ===
RA.MostHelpfulSolutions = {
  init(options) {
    let defaultOptions = {
      timeRange: "lastweek"
    };
    options = $.extend({}, defaultOptions, options);

    let url = `${Config.contextPath}/app/portlets/popularitems/worker.jsp`;
    let data = {
      items: "effectiveViews",
      timerange: options.timeRange
    };

    $.get(url, data)
      .done(r => this.render(r.effectiveViews));
  },
  renderNoContent() {
    return <NoContent message={Labels.getLabel("No solutions found")} center={false} />;
  },
  renderList(data) {
	let slParam = simplifiedSocialLayoutParam;
	let linkParam = launchLinksInNewWindowParam;

	let target = "";
	if (launchLinksInNewWindow) {
		target = `_blank`;
	} else {
		target = `_self`;
	}

    let items = data.map(sol => {
      return (
        <li key={sol.id}>
          <a target={target} href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${sol.id}${slParam}${linkParam}`}>{sol.title}</a>
        </li>
      );
    });

    return (
      <ul className="bullet-list">
        {items}
      </ul>
    )
  },
  render(data) {
    let content = data.length > 0 ?
      this.renderList(data) : this.renderNoContent();

    ReactDOM.render(content, document.getElementById("mostHelpful"));
  }
}

// === RA.QueryStringMapper.js ===
RA.QueryStringMapper = {

  /**
   * @param {array} paramNames - array of param names that this mapper should manage
   */
  init(paramNames) {
    this.paramNames = paramNames;
    this.encodeMap = {};
    this.decodeMap = {};
  },

  /**
   * @param {string} paramName - The name of the query string parameters
   * @param {string} valueKey - The name of the property key to use when passing in or getting values
   */
  addRenameMapping(paramName, valueKey) {
    this.encodeMap[valueKey] = paramName;
    this.decodeMap[paramName] = valueKey;
  },

  /**
   * @param {object} values - The key/values that should be added to the query string, renaming properties where needed.
   */
  buildQueryString(values = {}) {
    let existingParamMap = RA.Utils.getQueryParams();

    // delete existing params that we own
    this.paramNames.forEach(paramName => delete existingParamMap[paramName]);

    // build new map of params names/values from passed in values map
    let newParamMap = $.extend({}, values);

    // do name re-map
    for (let valueKey in this.encodeMap) {
      let paramName = this.encodeMap[valueKey];
      let val = newParamMap[valueKey];

      if (val != undefined && val !== "") {
        delete newParamMap[valueKey];
        newParamMap[paramName] = val;
      }
    };

    // extend other params with our params
    $.extend(newParamMap, existingParamMap);

    // convert to query string
    return RA.Utils.buildQueryString(newParamMap);
  },

  /**
   * get the key/values for the known param names from the query string, renaming where needed.
   */
  getValues() {
    let params = RA.Utils.getQueryParams();

    let values = {};

    this.paramNames.forEach(paramName => {
      let val = params[paramName];
      let key = paramName;

      if (paramName in this.decodeMap) {
        key = this.decodeMap[paramName];
      }

      if (val != undefined && val !== "") {
        values[key] = val;
      }
    });

    return values;
  }
};

// === RA.ResultsPage.js ===
RA.ResultsPage = {
  RAKEFederatedResults: true,
  init() {
    this.setVariables();
    this.initTabs();
    this.bindEvents();

    if (!Config.isCommunityEnabled) {
      this.$commSummary.hide();
      this.$commResultsPane.hide();
    }

    if (this.RAKEFederatedResults) {
      this.$rakeNonFederatedSummary.hide();
      this.$rakeNonFederatedResultPane.hide();
    }
  },
  setVariables() {
    this.$resultTabsList = $("#resultTabsList");
    this.isAddAllTab = "auto";
    this.validSearchMethods = ["neural", "hybrid", "keyword", "hide"];

    let searchMethodAvailableList = Config.searchMethodAvailable.toLowerCase().split(",")
      .map(method => method.trim())
      .filter(method => method.length > 0 && this.validSearchMethods.includes(method));

    const validDefaultSearchMethod = this.validSearchMethods.includes(Config.searchMethodDefault.toLowerCase()) ? Config.searchMethodDefault.toLowerCase() : "keyword";

    if (!searchMethodAvailableList.includes(validDefaultSearchMethod)) {
      searchMethodAvailableList.push(validDefaultSearchMethod);
    }

    searchMethodAvailableList = searchMethodAvailableList.map(method => {
      return {
        key: method,
        label: method.charAt(0).toUpperCase() + method.slice(1)
      }
    })

    this.kbFilterData = {
      sortKeys: [
        { key: 'relevance', label: Labels.getLabel('Relevance') },
        { key: 'viewcount', label: Labels.getLabel('Most Views') },
        { key: 'solvedcount', label: Labels.getLabel('Most Helpful') },
        { key: 'problem_as_keyword', label: Labels.getLabel('Title Z-A') },
        { key: 'problem_as_keyword', descending: false, label: Labels.getLabel('Title A-Z') },
        { key: 'last_modified_date', label: Labels.getLabel('Newest on Top') },
        { key: 'last_modified_date', descending: false, label: Labels.getLabel('Oldest on Top') }
      ],
      searchCriteriaKeys: searchMethodAvailableList
    };

    this.rakeNonFederatedFilterData = {
      sortKeys: [
        { key: 'relevance', label: Labels.getLabel('Relevance') },
        { key: 'viewcount', label: Labels.getLabel('Most Views') },
        { key: 'solvedcount', label: Labels.getLabel('Most Helpful') },
        { key: 'problem_as_keyword', label: Labels.getLabel('Title Z-A') },
        { key: 'problem_as_keyword', descending: false, label: Labels.getLabel('Title A-Z') },
        { key: 'last_modified_date', label: Labels.getLabel('Newest on Top') },
        { key: 'last_modified_date', descending: false, label: Labels.getLabel('Oldest on Top') }
      ],
      searchCriteriaKeys: searchMethodAvailableList
    };

    this.commFilterData = {
      sortKeys: [
        { key: "relevance", label: Labels.getLabel("Relevance") },
        { key: "viewcount", label: Labels.getLabel("Most Views") },
        { key: "last_modified_date", label: Labels.getLabel("Newest on Top") },
        { key: "last_modified_date", descending: false, label: Labels.getLabel("Oldest on Top") }
      ]
    };

    this.otherSearchCallbacks = [];

    this.$kbSummary = $("#kbSummary");
    this.$commSummary = $("#commSummary");
    this.$kbResultsPane = $("#kbResults");
    this.$commResultsPane = $("#commResults");

    let kbParams = ["querytext", "kbsort", "kbdesc", "attributesetname", "attributes", "searchaliases", "advkeywords", "taxonomypath", "kbd0", "kbd1", "language", "kbpage", "favoritesOnly", "searchCriteria"];
    this.kbQueryString = Object.create(RA.QueryStringMapper);
    this.kbQueryString.init(kbParams);
    this.kbQueryString.addRenameMapping("kbpage", "currentpage");
    this.kbQueryString.addRenameMapping("taxonomypath", "taxlevelValue");
    this.kbQueryString.addRenameMapping("kbsort", "sortBy");
    this.kbQueryString.addRenameMapping("kbdesc", "descending");
    this.kbQueryString.addRenameMapping("kbd0", "advstartdate");
    this.kbQueryString.addRenameMapping("kbd1", "advenddate");

    let commParams = ["querytext", "commsort", "commdesc", "answered", "communityID", "topicID", "tags", "commd0", "commd1", "commpage"];
    this.commQueryString = Object.create(RA.QueryStringMapper);
    this.commQueryString.init(commParams);
    this.commQueryString.addRenameMapping("commpage", "currentpage");
    this.commQueryString.addRenameMapping("commsort", "sortBy");
    this.commQueryString.addRenameMapping("commdesc", "descending");
    this.commQueryString.addRenameMapping("commd0", "beginLastModDate");
    this.commQueryString.addRenameMapping("commd1", "endLastModDate");

    let rakeNonFederatedParams = ["querytext", "rakenonfederatedsort", "rakenonfederateddesc", "attributesetname", "attributes", "searchaliases", "taxlevelValue", "language", "rakenonfederatedpage", "favoritesOnly", "searchCriteria"];
    this.rakeNonFederatedQueryString = Object.create(RA.QueryStringMapper);
    this.rakeNonFederatedQueryString.init(rakeNonFederatedParams);
    this.rakeNonFederatedQueryString.addRenameMapping("rakenonfederatedpage", "currentpage");
    this.rakeNonFederatedQueryString.addRenameMapping("rakenonfederatedsort", "sortBy");
    this.rakeNonFederatedQueryString.addRenameMapping("rakenonfederateddesc", "descending");
  },
  bindEvents() {
    $(window).on("popstate", this.onPopState.bind(this));
    this.$resultTabsList.on("click", "a", this.tabClicked.bind(this));
  },
  initSearch() {
    let kbQuery = this.kbQueryString.getValues();
    let commQuery = this.commQueryString.getValues();
    let rakeNonFederatedQuery = this.rakeNonFederatedQueryString.getValues();

    this.loadSummaryAndResults(kbQuery, commQuery, rakeNonFederatedQuery);
    this.showTab();
  },
  loadSummaryAndResults(kbQuery, commQuery, rakeNonFederatedQuery, extraParams) {
    RA.showOverlay(this.$kbSummary);
    RA.showOverlay(this.$kbResultsPane);

    RA.KBSearch.search(kbQuery, searchResults => {
      this.showKBSummary(searchResults);
      this.showKBResults(searchResults);
      localStorage.removeItem('pauseSolutionAutoView');

      RA.hideOverlay(this.$kbSummary);
      RA.hideOverlay(this.$kbResultsPane);
    }, extraParams);

    if (!this.RAKEFederatedResults) {
      RA.showOverlay(this.$rakeNonFederatedSummary);
      RA.showOverlay(this.$rakeNonFederatedResultPane);

      RA.RakeNonFederatedSearch.search(rakeNonFederatedQuery, searchResults => {
        this.showRakeNonFederatedSummary(searchResults);
        this.showRakeNonFederatedResults(searchResults);

        RA.hideOverlay(this.$rakeNonFederatedSummary);
        RA.hideOverlay(this.$rakeNonFederatedResultPane);
      }, { searchCriteria: 'keyword' });

    }

    if (Config.isCommunityEnabled) {
      RA.showOverlay(this.$commSummary);
      RA.showOverlay(this.$commResultsPane);

      RA.CommunitySearch.search(commQuery, searchResults => {
        this.showCommSummary(searchResults);
        this.showCommResults(searchResults);

        RA.hideOverlay(this.$commSummary);
        RA.hideOverlay(this.$commResultsPane);
        this.updateCommunityContext(searchResults);
      }, extraParams);
    }
  },
  updateCommunityContext(searchResults) {
    let communityContext = {};
    let { communityID, topicID } = RA.CommunitySearch.query;
    if (communityID && searchResults.communities.length == 1) {
      let community = searchResults.communities[0];
      communityContext.community = { id: community.id, name: community.name };
    }

    if (topicID && searchResults.topics.length == 1) {
      let topic = searchResults.topics[0];
      communityContext.topic = { id: topic.id, name: topic.name };
    }

    RA.setCommunityContext(communityContext);
  },
  queryTextUpdating() {

  },

  /** Handles "instant search" */
  queryTextUpdated(e) {
    let queryText = e.value;

    let kbQuery = $.extend({}, RA.KBSearch.query, { querytext: queryText });
    let commQuery = $.extend({}, RA.CommunitySearch.query, { querytext: queryText });
    let rakeNonFederatedQuery = $.extend({}, RA.RakeNonFederatedSearch.query, { querytext: queryText });
    delete kbQuery.currentpage;
    delete commQuery.currentpage;
    delete rakeNonFederatedQuery.currentpage;

    // Do not want to log instant search for simple keypress event
    // Still want to log other events: submit (ENTER or click search) and autocomplete select
    let extraParams = {};
    if (e.type === "keypress") {
      extraParams.doSearchLogging = false;
    }

    this.loadSummaryAndResults(kbQuery, commQuery, rakeNonFederatedQuery, extraParams);

    if (e.source == "kb") {
      this.showTab("#kbResults");
    } else if (e.source == "community") {
      this.showTab("#commResults");
    }

    if (history.pushState) {
      let paramMap = RA.Utils.getQueryParams();
      paramMap.querytext = queryText;
      delete paramMap.kbpage;
      delete paramMap.commpage;

      history.pushState({}, "", RA.Utils.buildQueryString(paramMap) + location.hash);
    }

    if (this.otherSearchCallbacks.length) {
      this.otherSearchCallbacks.forEach(callback => callback(queryText));
    }
  },
  initTabs() {
    this.resultTabs = [];
    this.$resultTabsList.empty();

    this.addTab({
      target: "#kbResults",
      label: Labels.getLabel("Knowledgebase"),
      className: "-kb"
    });

    if (Config.isCommunityEnabled) {
      this.addTab({
        target: "#commResults",
        label: Labels.getLabel("Community"),
        className: "-comm"
      });
    }

    let $tabContent = $("#allResults").closest(".tab-content");
    let $summaryRow = $("#allResults").find(".result-summary-wrap");

    $summaryRow.append("<section id='rakeNonFederatedSummary' class='result-summary' />");
    $tabContent.append("<div id='rakeNonFederatedResults' class='tab-pane' />");

    this.$rakeNonFederatedSummary = $("#rakeNonFederatedSummary");
    this.$rakeNonFederatedResultPane = $("#rakeNonFederatedResults");

    if (!this.RAKEFederatedResults) {
      this.addTab({
        target: "#rakeNonFederatedResults",
        label: Labels.getLabel("Knowledgebase External Sources")
      });
    }
  },
  addTab(tab) {
    this.resultTabs.push(tab);

    if (this.resultTabs.length == 1) {
      return;
    } else if (this.resultTabs.length == 2) {
      if (this.isAddAllTab !== false) {
        this.$resultTabsList.append(createTab({
          target: "#allResults",
          label: Labels.getLabel("All")
        }));
      }
      this.$resultTabsList.append(createTab(this.resultTabs[0]));
    }

    this.$resultTabsList.append(createTab(tab));

    function createTab(t) {
      let $li = $("<li>");
      $li.addClass("tab-bar__item")
        .attr("role", "tab");

      let $link = $("<a>");
      $link.addClass("tab-bar__link")
        .attr("href", t.target)
        .text(t.label)

      if (t.className) {
        $link.addClass(t.className);
      }

      return $li.append($link);
    }
  },
  tabClicked(e) {
    e.preventDefault();

    let $link = $(e.target);
    let href = $link.attr("href");

    this.showTab(href);

    $link.blur();
  },
  showTab(selector, updateState = true) {

    if (selector && selector.length) {
      let $link = this.$resultTabsList.find("a[href='" + selector + "']");
      $link.closest("ul")
        .find("li.active")
        .removeClass("active");

      $link.closest("li")
        .addClass("active");

      $(selector).closest(".tab-content")
        .find("> .active")
        .removeClass("active")
        .attr("aria-hidden", true);

      $(selector).addClass("active")
        .attr("aria-hidden", false);

      if (updateState && history.pushState) {
        history.pushState({}, "", `#t=${selector.substring(1)}`);
      }
    } else {
      let tabShown = false;
      let tabID = RA.Utils.buildParamMap(location.hash).t;

      if (tabID && tabID.length) {
        let target = "#" + tabID;
        let isValidTarget = (this.resultTabs.length > 1 && target == "#allResults") || this.resultTabs.some(t => t.target == target);

        if (isValidTarget) {
          this.showTab("#" + tabID, false);
          tabShown = true;
        }
      }

      if (!tabShown) {
        let defaultResultTab = "#" + Config.defaultResultTab.toLowerCase();
        let target = "";

        for (let i = 0; i < this.resultTabs.length; i++) {
          let tab = this.resultTabs[i];
          if (tab.target.toLowerCase() === defaultResultTab) {
            target = tab.target;
            const baseValue = this.resultTabs.length - 5;
            let initialSlide = 0;
            if(baseValue >= 0){
              initialSlide = Math.min(baseValue, i) + 1;
              if(initialSlide % 2 != 0){
                initialSlide = initialSlide - 1;
              }
            }
            sessionStorage.setItem("initialSlide", initialSlide);
            break;
          }
        }

        if (!target) {
          target = this.resultTabs.length > 1 && this.isAddAllTab !== false ? "#allResults" : this.resultTabs[0].target;
        }
        this.showTab(target, false);
      }
    }
  },
  onPopState(e) {
    let kbQuery = this.kbQueryString.getValues();
    let commQuery = this.commQueryString.getValues();
    let rakeNonFederatedQuery = this.rakeNonFederatedQueryString.getValues();


    let doKBSearch = !RA.Utils.compareObjects(RA.KBSearch.query, kbQuery);
    let doCommSearch = !RA.Utils.compareObjects(RA.CommunitySearch.query, commQuery);
    let doRakeNonFederatedSearch = !RA.Utils.compareObjects(RA.RakeNonFederatedSearch.query, rakeNonFederatedQuery);

    RA.SearchBar.setSearchText(kbQuery.querytext);

    if (kbQuery.querytext != RA.KBSearch.query.querytext) {
      this.loadSummaryAndResults(kbQuery, commQuery, rakeNonFederatedQuery);
    } else {
      if (doKBSearch) {
        RA.KBSearch.search(kbQuery, this.showKBResults.bind(this));
      }

      if (doCommSearch) {
        RA.CommunitySearch.search(commQuery, this.showCommResults.bind(this));
      }

      if (doRakeNonFederatedSearch) {
        RA.RakeNonFederatedSearch.search(rakeNonFederatedQuery, this.showRakeNonFederatedResults.bind(this), { searchCriteria: 'keyword' });
      }
    }

    this.showTab();
  },
  scrollToTopOfResults() {
    let topOffset = this.$resultTabsList.length ?
      this.$resultTabsList.offset().top - 15 : 0;

    if (window.scrollY > topOffset) {
      window.scrollTo(0, topOffset);
    }
  },

  showRakeNonFederatedSummary(searchResults) {
    ReactDOM.render(
      <RakeNonFederatedSummary
        searchResults={searchResults}
        eventHandler={this.handleRakeNonFederatedResultsEvent.bind(this)}
        onEmailClicked={this.emailClicked.bind(this)}
        onPreviewClicked={this.previewClicked.bind(this)} />,
      document.getElementById("rakeNonFederatedSummary")
    );
  },

  showRakeNonFederatedResults(searchResults) {
    ReactDOM.render(
      <RakeNonFederatedResults
        searchResults={searchResults}
        showCollectionFilter={RA.RakeNonFederatedSearch.getShowCollectionFilter()}
        showAttributeFilter={RA.RakeNonFederatedSearch.getShowAttributeFilter()}
        showFavoriteFilter={RA.RakeNonFederatedSearch.getShowFavoriteFilter()}
        filterData={this.rakeNonFederatedFilterData}
        eventHandler={this.handleRakeNonFederatedResultsEvent.bind(this)}
        onEmailClicked={this.emailClicked.bind(this)}
        onPreviewClicked={this.previewClicked.bind(this)} />,
      document.getElementById("rakeNonFederatedResults")
    );
  },

  showKBSummary(searchResults) {
    ReactDOM.render(
      <KBSummary
        searchResults={searchResults}
        eventHandler={this.handleKBResultsEvent.bind(this)}
        onEmailClicked={this.emailClicked.bind(this)}
        onPreviewClicked={this.previewClicked.bind(this)} />,
      document.getElementById("kbSummary")
    );
  },
  showKBResults(searchResults) {
    ReactDOM.render(
      <KBResults
        searchResults={searchResults}
        showCollectionFilter={RA.KBSearch.getShowCollectionFilter()}
        showAttributeFilter={RA.KBSearch.getShowAttributeFilter()}
        showFavoriteFilter={RA.KBSearch.getShowFavoriteFilter()}
        filterData={this.kbFilterData}
        eventHandler={this.handleKBResultsEvent.bind(this)}
        onEmailClicked={this.emailClicked.bind(this)}
        onPreviewClicked={this.previewClicked.bind(this)} />,
      document.getElementById("kbResults")
    );
  },
  emailClicked(hit, e) {
    let addData = {
      solutionID: hit.solution.id,
      solutionTitle: hit.solution.title,
      type: "regular",
      SToken: Config.csrf.value
    };

    RAEmail.init(addData, true);
  },
  previewClicked(hit, e) {

    e.preventDefault();

    // Configure preview solution for this result
    ExtQuickLinks.resultInfo = {
      id: hit.solution.id,
      title: hit.solution.title
    };

    ExtQuickLinks.previewResult(e);
  },
  showCommSummary(searchResults) {
    ReactDOM.render(
      <CommSummary
        searchResults={searchResults}
        eventHandler={this.handleCommResultsEvent.bind(this)} />,
      document.getElementById("commSummary")
    );
  },
  showCommResults(searchResults) {
    ReactDOM.render(
      <CommResults
        searchResults={searchResults}
        filterData={this.commFilterData}
        eventHandler={this.handleCommResultsEvent.bind(this)} />,
      document.getElementById("commResults")
    );
  },
  handleKBResultsEvent(event) {
    let callback = this.kbSearchComplete.bind(this);

    RA.showOverlay(this.$kbResultsPane);
    this.scrollToTopOfResults();

    switch (event.actionType) {
      case 'pageClicked':
        RA.KBSearch.loadPage(event.num, callback);
        break;
      case 'sortChanged':
        let { sortKey } = event;
        let descending = sortKey.descending == undefined ? "" : sortKey.descending;

        RA.KBSearch.applyFilter({ sortBy: sortKey.key, descending: descending, sortChanged: true },
          callback);
        break;
      case 'searchCriteriaChanged':
        let { searchCriteriaKey } = event;
        RA.KBSearch.applyFilter({ searchCriteria: searchCriteriaKey.key }, callback, { isbrowse: false });
        break;
      case 'attributeSetChanged':
        RA.KBSearch.applyFilter({ attributesetname: event.setName },
          callback);
        break;
      case 'attributesChanged':
        let { setName, attributes } = event;

        RA.KBSearch.applyFilter({
          attributesetname: setName,
          attributes: attributes.join(';')
        }, callback);
        break;
      case 'collectionsChanged':
        RA.KBSearch.applyFilter({ searchaliases: event.collections.join(';') },
          callback);
        break;
      case 'typesChanged':
        RA.KBSearch.applyFilter({ advkeywords: event.types.join(';') },
          callback);
        break;
      case 'categoryChanged':
        RA.KBSearch.applyFilter({ taxlevelValue: event.taxPath },
          callback);
        break;
      case 'dateChanged':
        let { startDate, endDate } = event;
        RA.KBSearch.applyFilter({
          advstartdate: startDate,
          advenddate: endDate
        }, callback);
        break;
      case 'favoriteChanged':
        RA.KBSearch.applyFilter({ favoritesOnly: event.favorite },
          callback);
        break;
      case 'languagesChanged':
        RA.KBSearch.applyFilter({
          language: event.languages && event.languages.length > 0 ? event.languages[0] : '',
          selectedLanguages: event.languages && event.languages.length > 0 ? event.languages.join(',') : ''
        }, callback);
        break;
      case 'resetFilters':
        RA.KBSearch.resetFilters(callback);
        break;
    }
  },
  handleRakeNonFederatedResultsEvent(event) {
    let callback = this.rakeNonFederatedSearchComplete.bind(this);
    let additionalParams = { searchCriteria: 'keyword' };

    RA.showOverlay(this.$rakeNonFederatedResultPane);
    this.scrollToTopOfResults();

    switch (event.actionType) {
      case 'pageClicked':
        RA.RakeNonFederatedSearch.nonFederatedRakeLoadPage(event.num, callback, additionalParams);
        break;
      case 'sortChanged':
        let { sortKey } = event;
        let descending = sortKey.descending == undefined ? "" : sortKey.descending;

        RA.RakeNonFederatedSearch.applyFilter({ sortBy: sortKey.key, descending: descending, sortChanged: true },
          callback, additionalParams);
        break;
      case 'searchCriteriaChanged':
        let { searchCriteriaKey } = event;
        RA.RakeNonFederatedSearch.applyFilter({ searchCriteria: searchCriteriaKey.key }, callback, { isbrowse: false });
        break;
      case 'attributeSetChanged':
        RA.RakeNonFederatedSearch.applyFilter({ attributesetname: event.setName },
          callback, additionalParams);
        break;
      case 'attributesChanged':
        let { setName, attributes } = event;

        RA.RakeNonFederatedSearch.applyFilter({
          attributesetname: setName,
          attributes: attributes.join(';')
        }, callback, additionalParams);
        break;
      case 'collectionsChanged':
        RA.RakeNonFederatedSearch.applyFilter({ searchaliases: event.collections.join(';') },
          callback, additionalParams);
        break;
      case 'categoryChanged':
        RA.RakeNonFederatedSearch.applyFilter({ taxlevelValue: event.taxPath },
          callback, additionalParams);
        break;
      case 'favoriteChanged':
        RA.RakeNonFederatedSearch.applyFilter({ favoritesOnly: event.favorite },
          callback, additionalParams);
        break;
      case 'languagesChanged':
        RA.RakeNonFederatedSearch.applyFilter({
          language: event.languages && event.languages.length > 0 ? event.languages[0] : '',
          selectedLanguages: event.languages && event.languages.length > 0 ? event.languages.join(',') : ''
        }, callback, additionalParams);
        break;
      case 'resetFilters':
        RA.RakeNonFederatedSearch.resetNonFederatedRakeTabFilters(callback, additionalParams);
        break;
    }
  },
  kbSearchComplete(searchResults) {
    this.showKBResults(searchResults);
    RA.hideOverlay(this.$kbResultsPane);

    if (history.pushState) {
      let qs = this.kbQueryString.buildQueryString(RA.KBSearch.query);
      history.pushState({}, "", qs + location.hash);
    }
  },
  rakeNonFederatedSearchComplete(searchResults) {
    this.showRakeNonFederatedResults(searchResults);
    RA.hideOverlay(this.$rakeNonFederatedResultPane);

    if (history.pushState) {
      let qs = this.rakeNonFederatedQueryString.buildQueryString(RA.RakeNonFederatedSearch.query);
      history.pushState({}, "", qs + location.hash);
    }
  },
  handleCommResultsEvent(event) {
    let callback = this.commSearchComplete.bind(this);
    RA.showOverlay(this.$commResultsPane);
    this.scrollToTopOfResults();

    switch (event.actionType) {
      case 'pageClicked':
        RA.CommunitySearch.loadPage(event.num, callback);
        break;
      case 'sortChanged':
        let { sortKey } = event;
        let descending = sortKey.descending == undefined ? "" : sortKey.descending;

        RA.CommunitySearch.applyFilter({ sortBy: sortKey.key, descending: descending },
          callback);
        break;
      case 'searchCriteriaChanged':
        let { searchCriteriaKey } = event;
        RA.KBSearch.applyFilter({ searchCriteria: searchCriteriaKey.key }, callback, { isbrowse: false });
        break;
      case 'answerStatusChanged':
        RA.CommunitySearch.applyFilter({ answered: event.statusCode },
          callback);
        break;
      case 'communityChanged':
        RA.CommunitySearch.applyFilter({
          communityID: event.communityID,
          topicID: ""
        }, callback);
        break;
      case 'topicChanged':
        RA.CommunitySearch.applyFilter({ topicID: event.topicID },
          callback);
        break;
      case 'tagsChanged':
        RA.CommunitySearch.applyFilter({ tags: event.tagIDs.join(";") }, callback);
        break;
      case 'dateChanged':
        let { startDate, endDate } = event;

        RA.CommunitySearch.applyFilter({
          beginLastModDate: startDate,
          endLastModDate: endDate
        }, callback);
        break;
      case 'resetFilters':
        RA.CommunitySearch.resetFilters(callback);
        break;
    }
  },
  commSearchComplete(searchResults) {
    this.showCommResults(searchResults);
    RA.hideOverlay(this.$commResultsPane);

    if (history.pushState) {
      let qs = this.commQueryString.buildQueryString(RA.CommunitySearch.query);
      history.pushState({}, "", qs + location.hash);
    }

    this.updateCommunityContext(searchResults);
  }
};

// === RA.SearchBar.js ===
RA.SearchBar = {
  init: function() {
    this.setVariables();
    this.bindEvents();
    // RPS Sage customization not to use docked search
    //this.initDock();
  },
  setVariables: function() {
    this.$queryInput = $(".main-search__input");
    this.$searchForm = $(".main-search__form");
    this.searchDockEnabled = true;
    this.isResultsPage = false;
    this.currentQueryText = this.$queryInput.val();
    this.lastQueryText = this.currentQueryText;
  },
  bindEvents: function() {
    this.$searchForm .on("submit.ra.searchBar", $.proxy(this.formSubmitted, this));
    this.$queryInput.on("keydown.ra.searchBar", $.proxy(this.keyPressed, this));
  },
  setSearchText: function(text) {
    this.$queryInput.val(text);
  },
  search: function(event) {
    if (this.isResultsPage) {
      if (Config.autoSearchEnabled || event.type === "submit") {
        RA.ResultsPage.queryTextUpdated(event);
      }
    } else {
      if (RA.Utils.isBlank(this.$queryInput.val())) {
        this.focusInput();
        return;
      }

      this.goToResultsPage(event);
    }
  },
  goToResultsPage: function(event) {
    var queryText = this.$queryInput.val();

    var extraParams = {};
    var setKBTab, setCommunityTab = false;
    if (event) {
      if (event.source == "community") {
        setCommunityTab = true;
      }

      if (event.source == "kb") {
        setKBTab = true;
      }

      if (event.community) {
        extraParams.communityID = event.community.id;
        setCommunityTab = true;
      }

      if (event.topic) {
        extraParams.topicID = event.topic.id;
        setCommunityTab = true;
      }
    }

    var searchUrl = RA.buildSearchUrl(queryText, extraParams);
	searchUrl += simplifiedSocialLayoutParam;
	searchUrl += launchLinksInNewWindowParam;

    //RPS-565 Sage upgrade collection auto select for search
    let aliases = $('#searchaliases').val();

    if (aliases === undefined) {
      aliases = '';
    }

    searchUrl += '&searchaliases=' + aliases;

    if (setKBTab) {
      searchUrl += "#t=kbResults";
    } else if (setCommunityTab) {
      searchUrl += "#t=commResults";
    }

    //console.log(searchUrl);
    location.href = searchUrl;
  },
  focusInput: function() {
    var $queryInput = this.$queryInput;

    $queryInput.focus();

    if (!$queryInput.hasClass("-error")) {
      $queryInput.addClass("-error");

      setTimeout(function() {
        $queryInput.removeClass("-error");
      }, 3000);
    }
  },
  initAutocomplete: function() {
    if (!window.autocomplete) return;

    var lastQuery = "";
    var searchesCallback, kbCallback, communityCallback;

    // debounce to rate-limit server requests
    var getSuggestions = debounce(function(query) {
      if (query.length < 3) return;
      lastQuery = query;

      var data = {
        querytext: query,
        doKBSearches: true,
        doKBSolutions: true,
        doCommunityDiscussions: Config.isCommunityEnabled
      };

      $.get(Config.contextPath + "/controller/searchsuggestions/", data)
        .done(function(r) {
          // show context & searches
          var searchItems = getContextSuggestions(query);
          searchItems = searchItems.concat(r.kbSearches.slice(0, 5));
          searchesCallback(searchItems, query);

          // show KB solutions
          kbCallback(r.kbSolutions.slice(0, 3), query);

          // show community discussions
          communityCallback(r.communityDiscussions.slice(0, 3), query);
        })
        .fail(function() {
          this.$queryInput.autocomplete.destroy();
        }.bind(this))
    }.bind(this), 800);

    // community context suggestions
    var getContextSuggestions = function(query) {
      var items = [];

      if (!Config.isCommunityEnabled) {
        return items;
      }

      if (!this.isResultsPage) {
        var context = RA.getCommunityContext();
        if (context.community && context.community.id) {
          items.push({suggestion: query, community: context.community});
        }

        if (context.topic && context.topic.id) {
          items.push({suggestion: query, community: context.community, topic: context.topic});
        }
      }

      return items;
    }.bind(this);

    // main server source
    // using 1 server call to populate suggestions other sources
    // this source never uses its callback
    var serverSource = function(query) {
      var isChanged = $.trim(lastQuery) != $.trim(query)

      if (isChanged) {
        getSuggestions(query);
      }
    };

    // searches source
    var searchesSource = function(query, callback) {
      // used in getSuggestions
      searchesCallback = callback;
    }

    // kb source
    var kbSource = function(query, callback) {
      // used in getSuggestions
      kbCallback = callback;
    }

    // community source
    var communitySource = function(query, callback) {
      // used in getSuggestions
      communityCallback = callback;
    };

    var hightlightQueryWords = function(value, query) {
      query = query || "";
      var words = query.split(/\s/);

      words.forEach(function(word) {
        value = value.replace(word, "<em>" + word + "</em>");
      });

      return value;
    };

    var searchesTemplates = {
      header: function() {
        return "<div class='aa-dataset-header'>"
          + "<span class='glyphicon glyphicon-search'></span> "
          + Labels.getLabel("Search Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        if (obj.topic) {
          return "<div>" + obj.suggestion + " in <span class='aa-suggestion__ctx'>" + obj.community.name + " &gt; " + obj.topic.name + "</span></div>";
        } else if (obj.community) {
          return "<div>" + obj.suggestion + " in <span class='aa-suggestion__ctx'>" + obj.community.name + "</span></div>";
        } else {
          return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
        }
      }
    }

    var kbTemplates = {
      header: function() {
        return "<div class='aa-dataset-header -kb'>"
          + "<span class='glyphicon glyphicon-book'></span> "
          + Labels.getLabel("Knowledgebase Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
      }
    }

    var communityTemplates = {
      header: function() {
        return "<div class='aa-dataset-header -comm'>"
          + "<span class='glyphicon glyphicon-comment'></span> "
          + Labels.getLabel("Community Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
      }
    };

    // init the plugin
    // jQuery version of this plugin conflicts with a jQueryUI plugin
    // with the same name - so using global function version instead
    var $plugIn = autocomplete(".main-search__input",
      {
        hint: false
      },
      [
        {
          source: serverSource
        },
        {
          source: searchesSource,
          name: "search",
          displayKey: "suggestion",
          templates: searchesTemplates
        },
        {
          source: kbSource,
          name: "kb",
          displayKey: "suggestion",
          templates: kbTemplates
        },
        {
          source: communitySource,
          name: "community",
          displayKey: function(obj) {
            return obj.community ? obj.value : obj.suggestion;
          },
          templates: communityTemplates
        }
      ]
    );

    // plugin event handlers
    $plugIn.on("autocomplete:selected", function(e, value, name) {
      var eventData = { type: "autocomplete", value: value.suggestion, source: name };
      if (value.community) eventData.community = value.community;
      if (value.topic) eventData.topic = value.topic;
      this.search(eventData);
    }.bind(this));

    // store reference to plugin function on $queryInput
    this.$queryInput.autocomplete = $plugIn.autocomplete;
  },
  initDock: function() {
    this.$mainSearch = $(".main-search");
    this.$placeHolder = $("<div />");

    if (!this.$mainSearch.length) {
      return;
    }

    var initBottom = this.$mainSearch.offset().top + this.$mainSearch.outerHeight();

    this.$placeHolder.css({ display: "none",
      height: this.$mainSearch.outerHeight() });
    this.$mainSearch.after(this.$placeHolder);

    var $window = $(window);
    $window.on("scroll", function() {
      if (initBottom - $window.scrollTop() < 0) {
        this.dockSearch();
      } else {
        this.undockSearch();
      }
    }.bind(this));

    $window.on("resize", debounce(function() {
      this.undockSearch();
    }.bind(this), 50));
  },
  dockSearch: function() {
    if (!this.searchDockEnabled) return;

    this.$mainSearch.addClass("-docked");
    this.$placeHolder.css("display", "block");
  },
  undockSearch: function() {
    this.$mainSearch.removeClass("-docked");
    this.$placeHolder.css("display", "none");
  },
  keyPressed: function(e) {
    if (e.keyCode == 13) {
      this.lastQueryText = this.$queryInput.val();
      return;
    }

    if (this.isResultsPage) {
      RA.ResultsPage.queryTextUpdating();

      clearTimeout(this.keyPressTimeout);
      this.keyPressTimeout = setTimeout(this.keyPressSearch.bind(this), 1000);
    }
  },
  keyPressSearch: function() {
    var currentQueryText = this.$queryInput.val();

    if (this.lastQueryText.trim() !== currentQueryText.trim()) {
      this.lastQueryText = currentQueryText;

      var eventData = { type: "keypress", value: currentQueryText };
      this.search(eventData);
    }
  },
  formSubmitted: function(e) {
    clearTimeout(this.keyPressTimeout);
    this.lastQueryText = this.$queryInput.val();

    var eventData = { type: "submit", value: this.$queryInput.val() };

    if (this.isResultsPage && this.$queryInput.autocomplete && Config.autoSearchEnabled) {
      this.$queryInput.autocomplete.close();
    }

    this.search(eventData);
    return false;
  }
};


// === RA.SearchBarHeader.js ===
RA.SearchBarHeader = {
  init: function() {
    this.setVariables();
    this.bindEvents();
    //this.initDock();
  },
  setVariables: function() {
    this.$queryInput = $(".main-search__input-header");
    this.$searchForm = $(".main-search__form");
    this.searchDockEnabled = true;
    this.isResultsPage = false;
    this.currentQueryText = this.$queryInput.val();
  },
  bindEvents: function() {
    this.$searchForm .on("submit.ra.searchBar", $.proxy(this.formSubmitted, this));
    this.$queryInput.on("keydown.ra.searchBar", $.proxy(this.keyPressed, this));
  },
  setSearchText: function(text) {
    this.$queryInput.val(text);
  },
  search: function(event) {
    if (this.isResultsPage) {
      RA.ResultsPage.queryTextUpdated(event);
    } else {
      if (RA.Utils.isBlank(this.$queryInput.val())) {
        this.focusInput();
        return;
      }

      this.goToResultsPage(event);
    }
  },
  goToResultsPage: function(event) {
    var queryText = this.$queryInput.val();

    var extraParams = {};
    var setKBTab, setCommunityTab = false;
    if (event) {
      if (event.source == "community") {
        setCommunityTab = true;
      }

      if (event.source == "kb") {
        setKBTab = true;
      }

      if (event.community) {
        extraParams.communityID = event.community.id;
        setCommunityTab = true;
      }

      if (event.topic) {
        extraParams.topicID = event.topic.id;
        setCommunityTab = true;
      }
    }

    var searchUrl = RA.buildSearchUrl(queryText, extraParams);
	searchUrl += simplifiedSocialLayoutParam;
	searchUrl += launchLinksInNewWindowParam;
	
	//RPS-565 Sage upgrade collection auto select for search
	let aliases = $('#searchaliases').val(); 
	
	if (aliases === undefined) {
		aliases = '';
	}
	
	searchUrl += '&searchaliases=' + aliases;
	//Ends here 
    if (setKBTab) {
      searchUrl += "#t=kbResults";
    } else if (setCommunityTab) {
      searchUrl += "#t=commResults";
    }

    //console.log(searchUrl);
    location.href = searchUrl;
  },
  focusInput: function() {
    var $queryInput = this.$queryInput;

    $queryInput.focus();

    if (!$queryInput.hasClass("-error")) {
      $queryInput.addClass("-error");

      setTimeout(function() {
        $queryInput.removeClass("-error");
      }, 3000);
    }
  },
  initAutocomplete: function() {
    if (!window.autocomplete) return;

    var lastQuery = "";
    var searchesCallback, kbCallback, communityCallback;

    // debounce to rate-limit server requests
    var getSuggestions = debounce(function(query) {
      lastQuery = query;

      var data = {
        querytext: query,
        doKBSearches: true,
        doKBSolutions: true,
        doCommunityDiscussions: Config.isCommunityEnabled
      };

      $.get(Config.contextPath + "/controller/searchsuggestions/", data)
        .done(function(r) {
          // show context & searches
          var searchItems = getContextSuggestions(query);
          searchItems = searchItems.concat(r.kbSearches.slice(0, 5));
          searchesCallback(searchItems, query);

          // show KB solutions
          kbCallback(r.kbSolutions.slice(0, 3), query);

          // show community discussions
          communityCallback(r.communityDiscussions.slice(0, 3), query);
        })
        .error(function() {
          this.$queryInput.autocomplete.destroy();
        }.bind(this))
    }.bind(this), 150);

    // community context suggestions
    var getContextSuggestions = function(query) {
      var items = [];

      if (!Config.isCommunityEnabled) {
        return items;
      }

      if (!this.isResultsPage) {
        var context = RA.getCommunityContext();
        if (context.community && context.community.id) {
          items.push({suggestion: query, community: context.community});
        }

        if (context.topic && context.topic.id) {
          items.push({suggestion: query, community: context.community, topic: context.topic});
        }
      }

      return items;
    }.bind(this);

    // main server source
    // using 1 server call to populate suggestions other sources
    // this source never uses its callback
    var serverSource = function(query) {
      var isChanged = $.trim(lastQuery) != $.trim(query)

      if (isChanged) {
        getSuggestions(query);
      }
    };

    // searches source
    var searchesSource = function(query, callback) {
      // used in getSuggestions
      searchesCallback = callback;
    }

    // kb source
    var kbSource = function(query, callback) {
      // used in getSuggestions
      kbCallback = callback;
    }

    // community source
    var communitySource = function(query, callback) {
      // used in getSuggestions
      communityCallback = callback;
    };

    var hightlightQueryWords = function(value, query) {
      query = query || "";
      var words = query.split(/\s/);

      words.forEach(function(word) {
        value = value.replace(word, "<em>" + word + "</em>");
      });

      return value;
    };

    var searchesTemplates = {
      header: function() {
        return "<div class='aa-dataset-header'>"
          + "<span class='glyphicon glyphicon-search'></span> "
          + Labels.getLabel("Search Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        if (obj.topic) {
          return "<div>" + obj.suggestion + " in <span class='aa-suggestion__ctx'>" + obj.community.name + " &gt; " + obj.topic.name + "</span></div>";
        } else if (obj.community) {
          return "<div>" + obj.suggestion + " in <span class='aa-suggestion__ctx'>" + obj.community.name + "</span></div>";
        } else {
          return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
        }
      }
    }

    var kbTemplates = {
      header: function() {
        return "<div class='aa-dataset-header -kb'>"
          + "<span class='glyphicon glyphicon-book'></span> "
          + Labels.getLabel("Knowledgebase Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
      }
    }

    var communityTemplates = {
      header: function() {
        return "<div class='aa-dataset-header -comm'>"
          + "<span class='glyphicon glyphicon-comment'></span> "
          + Labels.getLabel("Community Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
      }
    };

    // init the plugin
    // jQuery version of this plugin conflicts with a jQueryUI plugin
    // with the same name - so using global function version instead
    var $plugIn = autocomplete(this.$queryInput.selector,
      {
        hint: true
      },
      [
        {
          source: serverSource
        },
        {
          source: searchesSource,
          name: "search",
          displayKey: "suggestion",
          templates: searchesTemplates
        },
        {
          source: kbSource,
          name: "kb",
          displayKey: "suggestion",
          templates: kbTemplates
        },
        {
          source: communitySource,
          name: "community",
          displayKey: function(obj) {
            return obj.community ? obj.value : obj.suggestion;
          },
          templates: communityTemplates
        }
      ]
    );

    // plugin event handlers
    $plugIn.on("autocomplete:selected", function(e, value, name) {
      var eventData = { type: "autocomplete", value: value.suggestion, source: name };
      if (value.community) eventData.community = value.community;
      if (value.topic) eventData.topic = value.topic;
      this.search(eventData);
    }.bind(this));

    // store reference to plugin function on $queryInput
    this.$queryInput.autocomplete = $plugIn.autocomplete;
  },
  initDock: function() {
    this.$mainSearch = $(".main-search");
    this.$placeHolder = $("<div />");

    if (!this.$mainSearch.length) {
      return;
    }

    var initBottom = this.$mainSearch.offset().top + this.$mainSearch.outerHeight();
    var MIN_WIDTH = 768;

    this.$placeHolder.css({ display: "none",
      width: this.$mainSearch.outerWidth(),
      height: this.$mainSearch.outerHeight() });
    this.$mainSearch.after(this.$placeHolder);

    var $window = $(window);
    $window.on("scroll", function() {
      if ($window.width() < MIN_WIDTH) return;

      if (initBottom - $window.scrollTop() < 0) {
        this.dockSearch();
      } else {
        this.undockSearch();
      }
    }.bind(this));

    $window.on("resize", debounce(function() {
      if ($window.width() < MIN_WIDTH) {
        this.undockSearch();
      }
    }.bind(this), 50));
  },
  dockSearch: function() {
    if (!this.searchDockEnabled) return;

    this.$mainSearch.addClass("-docked");
    this.$placeHolder.css("display", "block");
  },
  undockSearch: function() {
    this.$mainSearch.removeClass("-docked");
    this.$placeHolder.css("display", "none");
  },
  keyPressed: function(e) {
    if (e.keyCode == 13) return;

    if (this.isResultsPage) {
      RA.ResultsPage.queryTextUpdating();

      clearTimeout(this.keyPressTimeout);
      this.keyPressTimeout = setTimeout(this.keyPressSearch.bind(this), 1000);
    }
  },
  keyPressSearch: function() {
    var currentQueryText = this.$queryInput.val();
    var lastQueryText = this.lastQueryText || "";

    if (lastQueryText.trim() !== currentQueryText.trim()) {
      this.lastQueryText = currentQueryText;

      var eventData = { type: "keypress", value: currentQueryText };
      this.search(eventData);
    }
  },
  formSubmitted: function(e) {
    clearTimeout(this.keyPressTimeout);

    var eventData = { type: "submit", value: this.$queryInput.val() };

    if (this.isResultsPage && this.$queryInput.autocomplete) {
      this.$queryInput.autocomplete.close();
    }

    this.search(eventData);
    return false;
  }
};


// === RA.SearchHighlight.js ===
RA.SearchHighlight = {
  init(stopWords, paramValue) {
	this.solutionContent = $('#solutionContent');
	this.solutionTitle = $('.solution-head__title');
    this.paramValue = paramValue;
	this.stopWords = stopWords;
	this.bindEvents();
	return this;
  },

  removeStopWords(stopWords) {
	var splitWords = this.paramValue.split(" ");
	var wordArray = [];
	$.each( splitWords, function( index, value ){
		value.replace(/\b[\w]+\b/g,
			function($0) {
			   var regex = new RegExp("\\b"+$0+"\\b","i");	
			   if (stopWords.search(regex) < 0) {
				 wordArray.push($0.trim());
			   }
			}
		); 
	});
	
	return wordArray;
  },

showHighlight() {
	  this.solutionContent.highlight(this.removeStopWords(this.stopWords));
	  this.solutionTitle.highlight(this.removeStopWords(this.stopWords));
  },
  
  removeHighlight() {
	  this.solutionContent.unhighlight();
	  this.solutionTitle.unhighlight();
  },
  bindEvents(){
	  var searchHighlight = this;
		$("#search-highlight-input").click(function(){
			let settingValue = $("#search-highlight-input").prop('checked');
			let data = {settingName: "SolutionSearchHighlight", settingValue: settingValue, action: "save", SToken: Config.csrf.value};
			let url = Config.contextPath + "/controller/userPreferences/";
			$.post(url, data).done(function(res) {
				if(res.status === "done") {
					if(settingValue === true){
						searchHighlight.showHighlight();
					}else{
						searchHighlight.removeHighlight();
					}
				} 
			});
		});
  }
};

// === RA.TitlePrefs.js ===
RA.TitlePrefs = {
  loaded() {
    var $iframe = $("#titlesFrame");
    var doc = $iframe[0].contentWindow.document;
    $iframe.height(doc.body.scrollHeight);
  }
};

// === RA.TrendingQuestions.js ===
RA.TrendingQuestions = {
  init() {
    let url;

    url = Config.contextPath + "/controller/socialsearch/trending/";
    $.get(url)
      .done(this.trendingQuestionsDone)
      .fail(RA.handleAjaxError);
  },
  trendingQuestionsDone(r) {
    let component;

    if (r.results.length) {
      component = (
        <CommResultsList showIcon={false}
          hits={r.results} />
      )
    } else {
      component = <NoContent message={Labels.getLabel("Nothing trending right now")} />;
    }

    ReactDOM.render(component, document.getElementById("trendingQuestions"));
  }
}

// === RA.ViewKB.js ===
RA.ViewKB = {
  init() {
    if (this.user && !this.user.isGuest) {
      ReactDOM.render(
        <Favorite />,
        document.getElementById("favAction")
      );
    }

    ReactDOM.render(
      <SolutionFeedback
        viewCount={RA.ViewKB.stats.views}
        initalSolvedCount={RA.ViewKB.stats.solved} />,
      document.getElementById("solutionFeedback")
    );

    if (this.config && this.config.showComments) {
      this.Comments.load();
    }

    this.initImageResize();
    this.initTranslations();
    this.initRelatedTitles();
    this.initContentBlocks();
    this.initLogLinks();
    this.RightPath.init(this.user);
    this.initSelectpicker();

    this.initMailToLink();
    this.initDiagBackAction();
  },
  initMailToLink() {
	let addData = {
	 solutionID: RA.ViewKB.solution.id,
	 solutionTitle: RA.ViewKB.solution.title,
	 type: "regular",
	 SToken: Config.csrf.value
	};

	RAEmail.init(addData);
  },
  initDiagBackAction() {
    $("#diagBack").click( function(e) {
        e.preventDefault();

        var url = Config.contextPath + "/app/core/remove-dt-capture.jsp";
        var data = { SToken: Config.csrf.value };
        $.post(url, data)
          .always(function() {
            window.history.go( -1 );
          });
      });
  },
  initImageResize() {
      // Resize images and add listener to resize images on window resize
      // using img load event is inconsistent cross-browser. Using timeout.
      setTimeout(this.resizeImages, 250);

      $(window).resize(debounce(this.resizeImages, 200));
  },
  resizeImages() {
   $(".solution-content img").each(function() {
      var $img = $(this);
      var $container = $(".solution-content");
      var maxWidth = $container.width();
      var fullWidth = $img.data("fullWidth");
      if (!fullWidth) {
        $img.data("fullWidth", $img.width());
        fullWidth = $img.width();
      }

      if ($img.width() > maxWidth) {
        $img.width(maxWidth);
        $img.attr("height", null).css("height", "auto");
      } else if ($img.width() < fullWidth) {
        $img.width(Math.min(fullWidth, maxWidth));
      }
    });
  },
  initTranslations() {
    let $select = $("#translationSelect");

    $select.on("change", function() {
      location.href = "viewsolution.jsp?solutionid=" + $select.val() + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
    });
  },
  initRelatedTitles() {
    let $links = $("#relatedTitlesList a[data-taxonomy]");

    $links.each(function() {
      let $link = $(this);
      let taxPath = $link.data("taxonomy");
      $link.attr("href", `${Config.contextPath}/${Config.portalInterface}/?taxonomypath=${encodeURIComponent(taxPath)}&tabid=${Config.resultsTabID}#t=kbResults`);
    });
  },
  initContentBlocks() {
    $("[data-cb-collapsed]").wrap("<a data-cb-collapsed-anchor='true' href='#'></a>");
    $("[data-cb-collapsed-anchor]").on("click", function(){
      $(this).next("div").collapse('toggle');
    });
    var $cParent = $("[data-cb-collapsed='true']").parent();	
	$cParent.next("div").removeClass('in');
	$cParent.next("div").addClass('collapse');
	
	var $eParent = $("[data-cb-collapsed='false']").parent();	
	$eParent.next("div").collapse('toggle');
  },
  initLogLinks() {
    $("[data-log]").on("click", function(e) {
      let $link = $(e.currentTarget);
      let action = $link.data("log");
      RA.ViewKB.logAction(action);
    });
  },
  logAction(action) {
    RA.logAction(RA.ViewKB.getLogString(action));
  },
  getLogString(action) {
    let $logForm = $("#logform");
    let $accessmethod = $logForm.find("[name=accessmethod]");
    let $action = $logForm.find("[name=action]");

    if ($action.length) {
      $action.val(action);
    }
    $accessmethod.val(sessionStorage.getItem("accessmethod"));

    return $logForm.serialize();
  },
  Comments: {
    currentPage: 1,
    load(pageNumber) {
      if (arguments.length == 0) {
        pageNumber = 1;
      }

      let url = Config.contextPath + "/controller/get/solution/comment/";
      let data = {
        solutionID: RA.ViewKB.solution.id,
        page: pageNumber
      };
      this.currentPage = pageNumber;

      $.get(url, data)
        .done(r => {
          this.show(r)
        });
    },
    show(data) {
      ReactDOM.render(
        <SolutionComments data={data}
          isGuest={RA.ViewKB.user.isGuest} />,
        document.getElementById("comments")
      );

      ReactDOM.render(
        <CommentCountAction count={data.totalComments} />,
        document.getElementById("commentAction")
      );
    },
    add(comment, cb) {
      let isFromDiagnostic = false;
      let windowUrl = window.location.href;
      if (windowUrl.indexOf("isfromdiagnostic=true") >= 0) {
        isFromDiagnostic = true;
      }

      let url = Config.contextPath + "/controller/saveComment/solution/comment/";
      let data = {
        SToken: Config.csrf.value,
        comments: comment.text,
        parentID: comment.parentID,
        solutionID: RA.ViewKB.solution.id,
        isfromdiagnostic: isFromDiagnostic,
        mentionedUsersList: comment.mentionedUsersList
      };

      RA.ViewKB.logAction("SUBMITNOTE");

      $.post(url, data)
        .done(res => {
          if (cb) cb(res)
      });
    },
    scrollTo() {
      let scrollTop = $("#comments").offset().top - 100;
      window.scrollTo(0, scrollTop);
    }
  },
  RightPath: {
    init(user) {
      var idPrefix = "solcheck";
      var $checks = $("[id^=" + idPrefix + "]");
      var totalChecks = $checks.length;

      if (totalChecks == 0) {
        return;
      }

      if (user && user.isGuest) {
		$checks.each(function(){
			$(this).attr("disabled", true);
		});

        return;
      }

      this.load();

      $checks.on("change", debounce(this.save, 500));
    },
    load() {
      var $usernameToCheck = $("#usernametocheck_sol");
      var idPrefix = "solcheck";
      var $checks = $("[id^=" + idPrefix + "]");
      var totalChecks = $checks.length;

      if (totalChecks == 0) {
        return;
      }

      var solutionID =  document.logform.docid.value;
      var data = { operation: "query",
        solutionid: solutionID,
		SToken: Config.csrf.value};

      if ($usernameToCheck.length) {
        data["usernametocheck"] = $usernameToCheck.val();
      }

      var url = Config.contextPath + "/app/core/solchecks.jsp";

      $.post(url, data)
        .done( function(r) {
          r = $.trim(r);
          var checkedSteps = r.split(";");

          $.each(checkedSteps, function(index, value) {
            $("#" + idPrefix + value).prop("checked", true);
          });
        });
    },
    save() {
      var $usernameToCheck = $("#usernametocheck_sol");
      var idPrefix = "solcheck";
      var $checks = $("[id^=" + idPrefix + "]");
      var totalChecks = $checks.length;

      if ($usernameToCheck.length > 0 || totalChecks == 0) {
        return;
      }

      var solutionID =  document.logform.docid.value;
      var solutionTitle =  document.logform.description.value;

      var checkedSteps = $checks.filter(":checked").map( function() {
        var id = $(this).attr("id");
        return id.substring(idPrefix.length);
      }).get();


      var operation = checkedSteps.length ? "insert" : "delete";
      var data = { operation: operation,
          solutionid: solutionID,
          solutiontitle: solutionTitle,
          stepscompleted: checkedSteps.join(";"),
          numberofsteps: totalChecks
      };

      var url = Config.contextPath + "/app/core/solchecks.jsp?SToken=" + Config.csrf.value;
      $.post(url, data);
    }
  },
  initSelectpicker() {
      try {
          $("#translationSelect").selectpicker('refresh');
      } catch (e) {
          //Do nothing in case bootstrap-select library is not found.
      }
  }
};

// === RACheck.js ===
var RACheck = React.createClass({
  propTypes: {
    isChecked: React.PropTypes.bool.isRequired,
    label: React.PropTypes.string,
    value: React.PropTypes.any.isRequired,
    onClick: React.PropTypes.func.isRequired
  },
  checkClicked() {
    this.props.onClick(this.props.value);
  },

  render() {
    let checkClass = "ra-check" + (this.props.isChecked ? " checked" : "");
	let ariaChecked = (this.props.isChecked ? true : false);

    return (
      <div className={checkClass} role="checkbox" onClick={this.checkClicked} aria-checked={ariaChecked} tabIndex="0" aria-label="Solution filter option">
        <span className="ra-check__box"></span><a href="#" tabIndex="-1" className="ra-check__label">{this.props.label}</a>
      </div>
    )
  }
});

// === RAResolveComment.js ===
var RAResolveComment = {
    init: function (data) {
        this.setVariables();
        this.bindEvents();
        this.setData(data);
        this.initModal();
        this.showResolveCommentForm();
        this.$resolve.off(".resolveCommentModal");
        this.$resolveresults.off(".resolveCommentModal");
    }, setVariables: function () {
        this.$itemsol = $(".portlet-container");
        this.$resolve = $(".resolve-btn");
        this.$resolveresults = this.$itemsol.find(".resolve-btn");
        this.resolutionCategoryOffset = 0;
        this.resolutionCategoryLimit = 10;
        this.resolutionCategoryIsLoading = false;
        this.resolutionCategoryAllowSearch = true;
    }, bindEvents: function () {
        this.$resolve.off(".resolveCommentModal");
        this.$resolveresults.off(".resolveCommentModal");
        this.$resolve.on("click.ra.resolveCommentModal", $.proxy(this.showResolveCommentForm, this));
        this.$resolveresults.on("click.ra.resolveCommentModal", $.proxy(this.showResolveCommentForm, this));
    }, showResolveCommentForm: function () {
        var url = Config.contextPath + "/app/portlets/resolve-comment/resolve-comment.jsp";
        var _self = this;

        $.post(url, this.data)
            .done(function (r) {
                _self.$modal.append(r);
                _self.modalLoaded();
                _self.$modal.modal("show");
            });
    }, setData: function (data) {
        this.data = data;
    }, initModal: function () {
        this.$modal = $("#resolveCommentModal");

        if (this.$modal.length === 0) {
            this.$modal = $("<div id='#resolveCommentModal' class='modal fade'></div>");
            this.$modal.css({display: "none"});
            $("body").append(this.$modal);
            this.$modal.on("hidden.bs.modal", $.proxy(this.modalHidden, this));
        }
    }, modalLoaded: function () {
        this.$form = this.$modal.find("form");
        this.$cancelButton = this.$form.find("[data-action=cancel]");
        this.$saveButton = this.$form.find("[data-action=save]");
        this.$answerToQuestion = this.$form.find("#addAnswerToQuestion");
        this.$cancelButton.on("click", $.proxy(this.cancelClicked, this));
        this.$saveButton.on("click", $.proxy(this.saveClicked, this));
        this.$form.find("resolutionCategorySearch").val("");
        this.$form.find("resolutionCategoryResults").css({display:"none"});
        this.searchResolutionCategories("", false);
        this.$form.find("#clearResolutionCategory").on("click", $.proxy(this.clearResolutionCategory, this));
        this.$form.find("#resolutionCategorySearch").on("input", (event) => {
            const query = event.target.value.trim();
            $("#resolveButton").attr("disabled", true);
            this.$form.find("resolutionCategoryResults").css({ display: "none"});
            if (query.length > 0) {
                this.$form.find("#clearResolutionCategory").removeClass("hide");
            } else {
                this.$form.find("#clearResolutionCategory").addClass("hide");
            }
            if (query.length === 0 || query.length >= 3) {
                RAResolveComment.searchResolutionCategories(query);
            }
        })

        const box = this.$form.find("#resolutionCategoryResults");
        let lastScrollTop = box.scrollTop();
        let scrollTimeout;

        this.$form.find("#resolutionCategoryResults").on("scroll", (event) => {
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }

            const current = box.scrollTop();

            scrollTimeout = setTimeout(() => {
                if (current > lastScrollTop) {
                    this.resolutionCategoryAllowSearch = true;
                    const query = this.$form.find("#resolutionCategorySearch").val().trim();
                    RAResolveComment.searchResolutionCategories(query, true);
                }
            }, 300)
        });
    }, hideModal: function () {
        this.$modal.modal("hide");
    }, modalShown: function () {
        this.$titleText.focus();
    }, modalHidden: function () {
        this.$modal.empty();
    }, cancelClicked: function () {
        this.hideModal();
    }, saveClicked: function () {

        let resolutionCategory = this.$form.find("#resolutionCategorySearch").attr("data-name");
        let resolutionAnswer = this.$answerToQuestion.val();

        if (this.$form.find("#resolutionCategorySearch").attr("data-enable-comment") === "true" && resolutionAnswer.trim() === "") {
            this.showError(Labels.getLabel("Please add resolution details before saving"), this.$answerToQuestion);
            return false;
        }

        this.$saveButton.attr("disabled", true);
        let loaderContainer = this.$saveButton.closest("form");
        this.showSpinner(loaderContainer);

        let url = Config.contextPath + "/controller/resolveComment/solution/comment/";
        let data = {
            action: "resolveComment",
            solutionID: this.data.solutionID,
            commentID: this.data.commentID,
            isResolved: true,
            resolutionCategory: resolutionCategory,
            resolutionAnswer: resolutionAnswer,
            SToken: Config.csrf.value
        }
        let _self = this;
        $.post(url, data)
            .done(function () {
                _self.$saveButton.removeAttr("disabled");
                _self.hideSpinner(loaderContainer);
                _self.hideModal();
                RA.ViewKB.Comments.load(RA.ViewKB.Comments.currentPage);
            })
            .fail(function (response) {
                let errorMsg = response && response.responseJSON && response.responseJSON.message ? response.responseJSON.message : "An unexpected error has occurred.";
                _self.showError(Labels.getLabel(errorMsg));
                _self.$saveButton.removeAttr("disabled");
                _self.hideSpinner(loaderContainer);
            });

    }, showError: function (msg, $element) {
        this.$form.find(".alert").remove();
        let $alert = $("<div class='alert alert-danger'></div>");

        $alert.append("<strong>" + Labels.getLabel("Error") + ": </strong>");
        $alert.append(msg);

        $alert.hide();

        this.$form.prepend($alert);

        $alert.fadeIn();

        if ($element) {
            $element.focus();
        }
    }, showSuccess: function (msg, $element) {
        var $alert = $("<div class='alert alert-success'></div>");

        $alert.append("<strong>" + Labels.getLabel("Success") + ": </strong>");
        $alert.append(msg);

        $alert.hide();

        this.$form.prepend($alert);

        $alert.fadeIn();

        if ($element) {
            $element.focus();
        }
    }, showSpinner: function (elem) {
        var img = $("<img>")
            .attr("src", Config.contextPath + "/app/images/loading.gif")
            .attr("alt", "loading..");

        var loader = $("<div>")
            .attr("class", "loading")
            .append(img);

        if (typeof elem !== "undefined") {
            elem.append(loader);
        }
    }, hideSpinner: function (elem) {
        if (typeof elem !== "undefined") {
            elem.find(".loading").remove();
        }
    }, searchResolutionCategories(query, append = false) {
        const url = Config.contextPath + "/controller/searchResolutionCategory/solution/comment/";

        // Abort the previous request if it exists
        if (this.currentRequest) {
            this.currentRequest.abort();
        }

        // Throttle the API call
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            if (this.resolutionCategoryIsLoading && !this.resolutionCategoryAllowSearch) return;

            this.resolutionCategoryIsLoading = true;

            const resultsContainer = this.$form.find("#resolutionCategoryResults");
            if (!append) {
                resultsContainer.html("");
                this.$form.find("#resolvingNoteDiv").addClass("hide");
                this.resolutionCategoryOffset = 0;

                // Reset the Set for a new search session
                this.resolutionCategoryIdSet = new Set();
            }

            const postData = {
                action: "searchResolutionCategory",
                filter: query,
                offset: this.resolutionCategoryOffset,
                limit: this.resolutionCategoryLimit,
                SToken: Config.csrf.value
            };

            this.currentRequest = $.ajax({
                url: url,
                method: "POST",
                data: postData
            }).done((res) => {
                const resolutionCategories = res.resolutionCategories || [];
                if (resolutionCategories.length > 0) {
                    resolutionCategories.forEach((category) => {
                        if (!this.resolutionCategoryIdSet.has(category.id)) {
                            this.resolutionCategoryIdSet.add(category.id);
                            const div = document.createElement("div");
                            div.className = "resolution-category-item";
                            div.textContent = category.displayName;
                            div.addEventListener("click", () => {
                                this.$form.find("#resolutionCategorySearch").val(category.displayName);
                                // Set the data-enable-comment attribute
                                this.$form.find("#resolutionCategorySearch").attr("data-enable-comment", category.enforceComment);
                                this.$form.find("#resolutionCategorySearch").attr("data-description", category.description);
                                this.$form.find("#resolutionCategorySearch").attr("data-name", category.name);
                                this.$form.find("#resolvingNoteDiv").removeClass("hide");
                                this.$form.find("#clearResolutionCategory").removeClass("hide");
                                this.$form.find("#ResolvingNote").text(category.description);
                                $("#resolveButton").attr("disabled", false);
                                resultsContainer.css({ display: "none" });
                            });
                            resultsContainer.append(div);
                        }
                    });
                    resultsContainer.css({ display: "block" });
                    this.resolutionCategoryOffset += this.resolutionCategoryLimit;
                    this.resolutionCategoryAllowSearch = true;
                } else {
                    this.resolutionCategoryAllowSearch = false;
                    this.$form.find("#resolvingNoteDiv").addClass("hide");
                }
                this.resolutionCategoryIsLoading = false;
            }).fail((jqXHR, textStatus) => {
                if (textStatus === "abort") {
                    console.log("Request aborted");
                } else {
                    console.error("Error in searchResolutionCategories:", textStatus);
                }
                this.resolutionCategoryIsLoading = false;
            });
        }, 300); // Throttle delay of 300ms
    }, clearResolutionCategory() {
        this.$form.find("#resolutionCategorySearch").val("");
        this.$form.find("#resolutionCategorySearch").removeAttr("data-name");
        this.$form.find("#resolutionCategorySearch").removeAttr("data-description");
        this.$form.find("#resolutionCategorySearch").removeAttr("data-enable-comment");
        this.$form.find("#resolutionCategoryResults").css({display:"none"});
        this.$form.find("#clearResolutionCategory").addClass("hide");
        $("#resolveButton").attr("disabled", true);
        this.searchResolutionCategories("", false);
    }
};

// === RakeNonFederatedResultItem.js ===
var RakeNonFederatedResultItem = React.createClass({
  propTypes: {
    hit: React.PropTypes.object.isRequired,
    showStars: React.PropTypes.bool,
    showSummary: React.PropTypes.bool,
    showHitSummary: React.PropTypes.bool,
	queryText: React.PropTypes.string,
    onEmailClicked: React.PropTypes.func.isRequired,
    onPreviewClicked: React.PropTypes.func.isRequired
  },
  emailClicked(hit, e) {
    this.props.onEmailClicked(hit, e);
  },
  previewClicked(hit, e) {
    this.props.onPreviewClicked(hit, e);
  },
  getDefaultProps() {
    return {
      showStars: false,
      showSummary: true,
      showHitSummary: true,
	  queryText: ""
    }
  },
  getCleanHitSummary() {
    let hitSummary = this.props.hit.hitSummary;
	if(hitSummary === null || hitSummary === undefined) {
		return "";
	}
    hitSummary = hitSummary.replace(/<B>/g, "raopenbold").replace(/<\/B>/g, "raclosebold");
    hitSummary = hitSummary.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    return hitSummary.replace(/raopenbold/g, "<B>").replace(/raclosebold/g, "</B>");
  },
  getIconClassName() {
    return "glyphicon-transfer";
  },
  renderSummary() {
    if (!this.props.showSummary) return;

    let { hit } = this.props;

    let fileTypeTag = hit.solution.type == "Document" ? <span>[{hit.solution.iconCode}] </span> : null;

    return (
      <div className="view-link__summary">
        {fileTypeTag}
        <span dangerouslySetInnerHTML={{__html:hit.summary}}></span>
      </div>
    );
  },
  renderHitSummary() {
    if (!this.props.showHitSummary) return;

    return <div className="view-link__hit-summary" dangerouslySetInnerHTML={{__html: this.getCleanHitSummary()}}></div>;
  },
  renderStarImage() {
    if (!this.props.showStars) return;

    let score = this.props.hit.score;
    let stars = 1;

    if (score > .8) {
      stars = 5;
    } else if (score > .6 && score < .8) {
      stars = 4;
    } else if (score > .4 && score < .6) {
      stars = 3;
    } else if (score > .2 && score < .4) {
      stars = 2;
    }

    return <span className={"star-rating -star" + stars}></span>;
  },
  renderIsNewUpdatedLabel() {
      if (!this.props.hit.solution.isNewUpdated) return;

      let displayIsNewUpdated = (this.props.hit.solution.isNewUpdated === 1 ? Labels.getLabel('NEW') : Labels.getLabel('UPDATED'));

      if (this.renderStarImage() === undefined) {
        return (
          <span className="label label-default">{displayIsNewUpdated}</span>
        );
      } else {
        return(
          <span>
            <span>&nbsp;</span>
            <span className="label label-default">{displayIsNewUpdated}</span>
          </span>
        );
      }
  },
  openLink(e) {
    let { hit } = this.props;

    let positionParams = "";
	let q = this.props.queryText;

	if ("page" in hit && "position" in hit) {
      positionParams = `&page=${hit.page}&position=${hit.position}&q=` + encodeURIComponent(q);
    }

    let ticketId = "";
    if(Config.copyToIncidentEnabled) {
        ticketId = `&ticketid=` + $("#ticketID").val();
    }

    let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}${ticketId}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;

    if (hit.solution.type === "Rake Solution" && Config.openRakeResultDirectly) {
        url = hit.solution.rakeUrl;

        let logData = {
            action: "VIEWRAKEDOCUMENT",
            docid: hit.solution.id,
            description: hit.solution.title,
            typeofview: "other_externalsource",
            page: hit.page,
            position: hit.position,
            accessmethod: sessionStorage.getItem("accessmethod")
        };

        RA.logAction(logData);

        // Configure external feedback modal for this result
        ExtFeedbackModal.resultInfo = {
            id: hit.solution.id,
            title: hit.solution.title,
            url: hit.solution.rakeUrl,
            page: hit.page,
            position: hit.position
        };
        ExtFeedbackModal.loadModal();
    }

	if (launchLinksInNewWindow) {
		e.preventDefault();
		RA.Utils.openCenteredWindow(url, '1100', '800');
	}
  },
  renderEmailButton(divStyle, hit) {
    if (!Config.ShowResultEmail) return;
    return (
        <li>
          <a href="#" className="email-link" style={divStyle} title={Labels.getLabel("Email Solution")} onClick={this.emailClicked.bind(this, hit)}>
            <small><i className="glyphicon glyphicon-envelope"></i></small>
          </a>
        </li>
    )
  },
  renderPreviewButton(divStyle, hit) {
    if (!Config.ShowResultEmail) return;
    return (
        <li>
          <a href="#" className="preview-link" style={divStyle} title={Labels.getLabel("Preview")} onClick={this.previewClicked.bind(this, hit)}>
            <small><i className="glyphicon glyphicon-search"></i></small>
          </a>
        </li>
    )
  },
  render() {
    let { hit } = this.props;

    let positionParams = "";
	let q = this.props.queryText;

	if ("page" in hit && "position" in hit) {
      positionParams = `&page=${hit.page}&position=${hit.position}&q=` + encodeURIComponent(q);
    }

	var divStyle = {
        float: "right",
        margin: "7px"
    };

    let target = "_self";
    let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
    let className = `view-link__title s-${hit.solution.isSolr}`;

    if (hit.solution.type == "Rake Solution" && Config.openRakeResultDirectly) {
        url = hit.solution.rakeUrl;
        target = "_blank";
    }

    return (
      <li className="view-link">
        <div className="view-link__icon">
          <i className={"glyphicon " + this.getIconClassName()}></i>
        </div>
        <div className="view-link__content">
          <a onClick={this.openLink} href={url} target={target} className={className} dangerouslySetInnerHTML={{__html: hit.solution.title}}></a>
          <div className="view-link__subhead">
            <ul className="actions">
              {this.renderEmailButton(divStyle, hit)}
              {this.renderPreviewButton(divStyle, hit)}
            </ul>
            {this.renderSummary()}
            {this.renderHitSummary()}
            <div className="view-link__sub-line">
              {this.renderStarImage()}
              {this.renderIsNewUpdatedLabel()}
            </div>
          </div>
        </div>
        <div className="preview-pane muted">
          <div className="content">
            <div >
              <strong>{Labels.getLabel("Preview")}</strong>
            </div>
            <div className="solution"></div>
          </div>
        </div>
      </li>
    )
  }
})

// === RakeNonFederatedResults.js ===
var RakeNonFederatedResults = React.createClass({
    propTypes: {
        searchResults: React.PropTypes.object.isRequired,
        filterData: React.PropTypes.object.isRequired,
        eventHandler: React.PropTypes.func.isRequired,
        showCollectionFilter: React.PropTypes.bool,
        showAttributeFilter: React.PropTypes.bool,
        onEmailClicked: React.PropTypes.func.isRequired,
        onPreviewClicked: React.PropTypes.func.isRequired,
        directView: React.PropTypes.bool
    },
    pageClicked(num) {
        this.props.eventHandler({actionType: 'pageClicked', num: num});
    },
    sortChanged(sortKey, index) {
        this.props.eventHandler({actionType: 'sortChanged', sortKey: sortKey});
    },
    searchCriteriaChanged(searchCriteriaKey, index) {
        this.props.eventHandler({actionType: 'searchCriteriaChanged', searchCriteriaKey: searchCriteriaKey});
    },
    attributeSetChanged(setName) {
        this.props.eventHandler({actionType: 'attributeSetChanged', setName: setName});
    },
    attributesChanged(setName, attributes) {
        this.props.eventHandler({
            actionType: 'attributesChanged', setName: setName,
            attributes: attributes
        });
    },
    collectionsChanged(collections) {
        this.props.eventHandler({actionType: 'collectionsChanged', collections: collections});
    }, favoriteChanged(favorite) {
        this.props.eventHandler({actionType: 'favoriteChanged', favorite: favorite});
    },
    categoryChanged(taxPath) {
        this.props.eventHandler({actionType: 'categoryChanged', taxPath: taxPath});
    },
    languagesChanged(languages) {
        this.props.eventHandler({actionType: 'languagesChanged', languages: languages});
    },
    resetFiltersClicked() {
        this.props.eventHandler({actionType: 'resetFilters'});
    },
    findSelectedSortIndex() {
        let { searchResults, filterData} = this.props;
        let querySortBy = searchResults.query.sortBy.toLowerCase();
        let queryDescending = searchResults.query.sortDescending;

        for (let i = 0; i < filterData.sortKeys.length; i++) {
            let sortKey = filterData.sortKeys[i];
            let thisSortBy = sortKey.key.toLowerCase();
            let thisDescending = sortKey.descending;

            if (thisDescending == undefined) thisDescending = true;

            if (thisSortBy == querySortBy && thisDescending == queryDescending) {
                return i;
            }
        }

        return 0;
    },

    findSelectedSearchCriteriaIndex() {
        let {searchResults, filterData} = this.props;

        const neuralSearchEnabled = searchResults.query.neuralSearchEnabled;
        if (!neuralSearchEnabled) {
            return -1;
        }

        let querySearchCriteria = searchResults.query.searchCriteria.toLowerCase();

        for (let i = 0; i < filterData.searchCriteriaKeys.length; i++) {
            let searchCriteriaKey = filterData.searchCriteriaKeys[i];
            let thisSearchCriteria = searchCriteriaKey.key.toLowerCase();

            if (thisSearchCriteria === querySearchCriteria) {
                return i;
            }
        }

        return 0;
    },
    paramToArray(paramName) {
        let val = RA.RakeNonFederatedSearch.query[paramName];
        return typeof val == "string" ? val.split(";") : [];
    },
    getParam(paramName) {
        return RA.RakeNonFederatedSearch.query[paramName];
    },
    getPager() {
        let searchResults = this.props.searchResults;
        let pagerDetail = searchResults.pagerDetail;
        return searchResults.totalHits > 0 && pagerDetail.totalPages > 1 ?
            <ResultsPager pagerDetail={pagerDetail} onPageClicked={this.pageClicked}/> : null;
    },
    autoClicked() {
        let hit = this.props.searchResults.results[0];
        let positionParams = `&page=${hit.page}&position=${hit.position}&linw=true&q=` + encodeURIComponent(RA.RakeNonFederatedSearch.query.querytext);

        let ticketId = "";
        if (Config.copyToIncidentEnabled) {
            ticketId = `&ticketid=` + $("#ticketID").val();
        }

        let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}${ticketId}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
        window.open(url);
    },
    getResultsSection() {
        let {filterData, searchResults} = this.props;
        let didYouMean = searchResults.didYouMean;

        return (
            <div>
                <div className="result-col__head clearfix">
                    <ResultCountSummary
                        totalHits={searchResults.totalHits}
                        pageStart={searchResults.pagerDetail.pageStart}
                        pageEnd={searchResults.pagerDetail.pageEnd}
                    />
                    <div className="result-col__head-right">
                        <ResultSort sortKeys={filterData.sortKeys}
                                    selectedIndex={this.findSelectedSortIndex()}
                                    onSortChanged={this.sortChanged}
                        />
                    </div>
                </div>
                <KBDidYouMean didYouMean={didYouMean}/>
                <RakeNonFederatedResultsList hits={searchResults.results} onEmailClicked={this.props.onEmailClicked}
                                             onSolClicked={(searchResults.results.length == 1 && Config.viewOneSolutionResult && this.props.directView) ? this.autoClicked() : this.props.onSolClicked}
                                             onPreviewClicked={this.props.onPreviewClicked}/>
                {this.getPager()}
            </div>
        )
    },
    getEmptyResultSection: function (filterData) {
        return <div>
            <NoResults showResetFilters={RA.RakeNonFederatedSearch.isFilterApplied()} onFilterResetClicked={this.resetFiltersClicked}/>
        </div>;
    },
    render() {
        let {filterData, searchResults} = this.props;
        let didYouMean = searchResults.didYouMean;
        let pauseSolutionAutoView = localStorage.getItem('pauseSolutionAutoView');
        this.props.directView = ((searchResults.totalHits == 1) && pauseSolutionAutoView !== 'true');

        let hitsCount = searchResults.totalHits === 0;
        let resultsContent = hitsCount ? this.getEmptyResultSection(filterData) : this.getResultsSection();

        let noResultDymSection = hitsCount ? <KBDidYouMean didYouMean={didYouMean}/> : '';

        let isFiltered = RA.KBSearch.nonFederatedKbFilterApplied;

        return (
            <div className="row">
                <ResponsiveFilterColumn className="col-xs-12 col-sm-3 filter-col">
                    <FavoriteFilter showFavoriteFilter={this.props.showFavoriteFilter}
                                    favoritesOnly={this.getParam("favoritesOnly")}
                                    onFavoriteChanged={this.favoriteChanged} resetFiltersClicked={this.resetFiltersClicked} 
                                    isFiltered={isFiltered}/>
                    <CategoryFilter categories={searchResults.browsePaths}
                                    currentPath={RA.RakeNonFederatedSearch.query.taxlevelValue}
                                    onCategoryChanged={this.categoryChanged}/>
                    <AttributeFilter showAttributeFilter={this.props.showAttributeFilter}
                                     attributeSets={searchResults.attributeSets}
                                     attributes={searchResults.attributes}
                                     selectedSetName={RA.RakeNonFederatedSearch.query.attributesetname}
                                     selectedAttributeKeys={this.paramToArray("attributes")}
                                     onAttributeSetChanged={this.attributeSetChanged}
                                     onAttributesChanged={this.attributesChanged}/>
                    <CollectionFilter showCollectionFilter={this.props.showCollectionFilter}
                                      customCollections={this.props.filterData.customCollections}
                                      selectedCollections={this.paramToArray("searchaliases")}
                                      onCollectionsChanged={this.collectionsChanged}/>
                    <LanguageFilter searchLanguages={this.props.filterData.searchLanguages}
                                    selectedLanguages={searchResults.query.selectedLanguages}
                                    onLanguagesChanged={this.languagesChanged}/>
                </ResponsiveFilterColumn>
                <section className="col-xs-12 col-sm-9 result-col" role="region" aria-label={Labels.getLabel("Results")}
                         title={Labels.getLabel("Results")}>
                    {resultsContent}
                    {noResultDymSection}
                </section>
            </div>
        )
    }
})

// === RakeNonFederatedResultsList.js ===
var RakeNonFederatedResultsList = React.createClass({
    propTypes: {
        hits: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
        onEmailClicked: React.PropTypes.func.isRequired,
        onPreviewClicked: React.PropTypes.func.isRequired
    },

    render() {
        if (this.props.hits.length == 0) {
            return <span />
        }

        let showStars = RA.RakeNonFederatedSearch.showRelevancyStars && RA.Utils.isNotBlank(RA.RakeNonFederatedSearch.query.querytext);
        let queryText = RA.RakeNonFederatedSearch.query.querytext;

        if (showStars) {
            queryText = queryText.split(/\s+/).slice(0,30).join(" ");
        }

        return (
            <ul className="solution-list">
                {this.props.hits.map(hit =>
                    <RakeNonFederatedResultItem
                        key={hit.solution.id}
                        hit={hit}
                        showStars={showStars}
                        queryText={queryText}
                        showHitSummary={RA.RakeNonFederatedSearch.showHitSummary}
                        onEmailClicked={this.props.onEmailClicked}
                        onPreviewClicked={this.props.onPreviewClicked}
                        {...this.props} />
                )
                }
            </ul>
        )
    }
});

// === RakeNonFederatedSummary.js ===
var RakeNonFederatedSummary = React.createClass({
    propTypes: {
        eventHandler: React.PropTypes.func.isRequired,
        searchResults: React.PropTypes.object.isRequired,
        resultCount: React.PropTypes.number,
        categoryCount: React.PropTypes.number,
        onSolClicked: React.PropTypes.func.isRequired,
        onEmailClicked: React.PropTypes.func.isRequired,
        onPreviewClicked: React.PropTypes.func.isRequired
    },
    getDefaultProps() {
        return {
            resultCount: 5,
            categoryCount: 2
        }
    },
    categoryClicked(taxPath) {
        this.props.eventHandler({actionType: 'categoryChanged', taxPath: taxPath});
        this.showRakeTab();
    },
    showRakeTab() {
        RA.ResultsPage.showTab("#rakeNonFederatedResults");
    },
    getSummaryHits() {
        let results = this.props.searchResults.results;
        let ubound = Math.min(results.length, this.props.resultCount);

        results = results.slice(0, ubound);

        return results;
    },
    getSummaryBrowsePaths() {
        let categories = this.props.searchResults.browsePaths;

        // sort affects other components using this variable - use map, then sort instead
        //categories.sort((a, b) => b.hits - a.hits);

        // convert to map of array {index, hit count}
        let hitCounts = categories.map((cat, i) => {
            return {index: i, count: cat.hits }
        });

        // sort by hit count - descending
        hitCounts.sort((a, b) => b.count - a.count);

        // get slice
        let ubound = Math.min(hitCounts.length, this.props.categoryCount);
        hitCounts = hitCounts.slice(0, ubound);

        // return array of categories with index position from the hitCount array
        return hitCounts.map(hitCount => {
            return categories[hitCount.index];
        });

    },
    renderSummary() {
        let { searchResults } = this.props;

        if (searchResults.totalHits == 0) {
            return <NoResults />
        }

        let resultsLabel = searchResults.totalHits == 1 ? Labels.getLabel("result") : Labels.getLabel("results");
        let didYouMean = searchResults.didYouMean;
        let selectedTaxonomy = searchResults.query.taxPath;
        let selectedTaxonomyLabel = Labels.getLabel("Currently searching");

        return (
            <div>
                <div className="result-summary__stats">
                    <span className="text-muted">{`${searchResults.totalHits} ${resultsLabel} - `}</span>
                    <a href="#" className="text-muted" onClick={this.showRakeTab}>
                        {Labels.getLabel("Show All")}
                    </a>
                    <KBDidYouMean didYouMean={didYouMean}/>
                </div>
                <RakeNonFederatedResultsList hits={this.getSummaryHits()} showSummary={false} showHitSummary={false} onEmailClicked={this.props.onEmailClicked}
                                             onSolClicked={this.props.onSolClicked} onPreviewClicked={this.props.onPreviewClicked}/>
                { selectedTaxonomy ? <div className="cat-matches"><h3 className="cat-matches__title"><span className="alltab_taxonomy_clicked">{selectedTaxonomyLabel} </span> {selectedTaxonomy}</h3></div> : <span></span>}
                <RakeNonFederatedSummaryCategories browsePaths={this.getSummaryBrowsePaths()} onCategoryClicked={this.categoryClicked} />
            </div>
        )
    },
    render() {
        return (
            <div>
                <h3 className="result-summary__head">
                    <a href="#" className="result-summary__head-link -kb" onClick={this.showRakeTab}>
                        <i className="glyphicon glyphicon-book result-summary__head-icon"></i>
                        {Labels.getLabel("Knowledgebase External Sources")}
                    </a>
                </h3>
                {this.renderSummary()}
            </div>
        )
    }
});

// === RakeNonFederatedSummaryCategories.js ===
var RakeNonFederatedSummaryCategories = React.createClass({
    propTypes: {
        browsePaths: React.PropTypes.array,
        onCategoryClicked: React.PropTypes.func.isRequired
    },
    getDefaultProps() {
        return {
            browsePaths: []
        }
    },
    categoryClicked(path) {
        this.props.onCategoryClicked(path);
    },
    renderItem(path) {
        let pathArray = path.value.split("//");
        let displayName = pathArray[pathArray.length - 1];

        return (
            <li className="" key={path.value}>
                <a href="#" onClick={this.categoryClicked.bind(this, path.value)}>{displayName}</a> <span className="text-muted">({path.hits})</span>
            </li>
        )
    },

    render() {
        if (this.props.browsePaths.length == 0) {
            return <div></div>;
        }

        let items = this.props.browsePaths.map(this.renderItem);

        return (
            <div className="cat-matches">
                <h3 className="cat-matches__title">{Labels.getLabel("Show results in these categories")}:</h3>
                <ul className="cat-matches__list bullet-list">
                    {items}
                </ul>
            </div>
        )
    }
});

// === RecentActivity.js ===
var RecentActivity = React.createClass({
  propTypes: {
    solutions: React.PropTypes.arrayOf(React.PropTypes.object),
    searches: React.PropTypes.arrayOf(React.PropTypes.string)
  },
  render() {

    return (
      <div>
        <h2 className="aside__title">{Labels.getLabel("Recent Activity")}</h2>

        <h5 className="aside__subtitle">
          <span className="glyphicon glyphicon-search search-icon" role="presentation"></span> {Labels.getLabel("Searches")}
        </h5>
        <RecentSearches
          className="bullet-list -indent"
          searches={this.props.searches} />

        <h5 className="aside__subtitle">
          <span className="glyphicon glyphicon-book kb-icon" role="presentation"></span> {Labels.getLabel("Solutions Viewed")}
        </h5>
        <RecentViews
          className="bullet-list -indent"
          solutions={this.props.solutions} />
      </div>
    )
  }
})

// === RecentSearches.js ===
var RecentSearches = React.createClass({
  propTypes: {
    searches: React.PropTypes.arrayOf(React.PropTypes.string),
    className: React.PropTypes.string
  },
  componentDidMount() {
    if (window.PortalContentCoordinator) {
      PortalContentCoordinator.markComponentLoaded('recentSearches');
    }
  },
  render() {
    let {className} = this.props;
    className = classNames(className, {"bullet-list": className == undefined});

    return (
      <ul className={className} aria-hidden={!this.props.searches.length}>
        {this.props.searches.map((queryText, i) =>
          <li key={i}>
            <a href={RA.buildSearchUrl(queryText)}>{queryText}</a>
          </li>
        )}
      </ul>
    )
  }
})

// === RecentViews.js ===
var RecentViews = React.createClass({
  propTypes: {
    solutions: React.PropTypes.arrayOf(React.PropTypes.object)
  },
  componentDidMount() {
    if (window.PortalContentCoordinator) {
      PortalContentCoordinator.markComponentLoaded('recentViews');
    }
  },
  render() {
    let {className} = this.props;
    className = classNames(className, {"bullet-list": className == undefined});

    return (
      <ul className={className} aria-hidden={!this.props.solutions.length}>
        {this.props.solutions.map((sol, i) =>
          <li key={i}>
            <a href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${sol.id}`}>{sol.title}</a>
          </li>
        )}
      </ul>
    )
  }
})

// === ResponsiveFilterColumn.js ===
var ResponsiveFilterColumn = React.createClass({
  propTypes: {
    className: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      className: "filter-col"
    }
  },
  getInitialState() {
    return {
      isOpen: false
    }
  },
  toggleOpen() {
    let newState = !this.state.isOpen;
    this.setState({isOpen: newState});

    if (newState) {
      document.addEventListener("click", this.documentClicked);
    } else {
      document.removeEventListener("click", this.documentClicked);
    }
  },
  documentClicked(e) {
    let $target = $(e.target);
    let $parent = $(this.refs.parent);

    if ($target.closest($parent).length == 0) {
      this.toggleOpen();
    }
  },
  filterColClicked(e) {

  },

  render() {
    let className = classNames(this.props.className, {open: this.state.isOpen});
    const childrenWithProps = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        isOpen: this.state.isOpen,
      });
    });

    return (
      <section className={className} ref="parent" onClick={this.filterColClicked}>
        <div className="filter-toggle" onClick={this.toggleOpen}>
          <i className="glyphicon glyphicon-filter"></i>
        </div>
        {childrenWithProps}
      </section>
    )
  }
});

// === ResultCountSummary.js ===
var ResultCountSummary = React.createClass({
  propTypes: {
    totalHits: React.PropTypes.number.isRequired,
    pageStart: React.PropTypes.number,
    pageEnd: React.PropTypes.number,
    resultName: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      pageStart: 0,
      pageEnd: 0,
    }
  },
  getRange() {
    return <span><strong>{this.props.pageStart}-{this.props.pageEnd}</strong> {Labels.getLabel("of")} </span>;
  },
  render() {
    let {resultName, totalHits, pageStart, pageEnd} = this.props;
    let showRange = pageStart > 0 && pageEnd > 0 && !(pageStart == 1 && pageEnd == totalHits);
    resultName = resultName ? resultName : totalHits == 1 ? Labels.getLabel("result") : Labels.getLabel("results");

    return (
      <div className="result-col__counts" tabIndex="0">
        {`${Labels.getLabel("Showing")}`} {showRange ? this.getRange() : ""} <strong>{totalHits}</strong> {resultName}
      </div>
    )
  }
});

// === ResultSearchCriteria.js ===
const ResultSearchCriteria = React.createClass({
    propTypes: {
        searchCriteriaKeys: React.PropTypes.array.isRequired,
        selectedIndex: React.PropTypes.number,
        onSearchCriteriaChanged: React.PropTypes.func,
        align: React.PropTypes.oneOf(["left", "center", "right"])
    }, getDefaultProps() {
        return {
            selectedIndex: 0, onSearchCriteriaChanged: function () {
            }, align: "right"
        }
    }, handleSearchCriterieChange(searchCriteriaIndex) {
        let selectedKey = this.props.searchCriteriaKeys[searchCriteriaIndex];
        this.props.onSearchCriteriaChanged(selectedKey, searchCriteriaIndex);
    }, render: function () {
        let {
            searchCriteriaKeys, selectedIndex
        } = this.props;
        if (selectedIndex === -1) return null;
        const isHide = searchCriteriaKeys.find(searchCriteria => searchCriteria.key === "hide");
        if (isHide) return null;
        return (
            <div className="search-criteria">
                <ul className="pagination">
                    {searchCriteriaKeys.map((searchCriteriaKey, i) =>
                        <li className={selectedIndex === i ? "active" : ""}
                            id={searchCriteriaKey.label}
                            onClick={() => this.handleSearchCriterieChange(i)}>
                            <a href="#">{Labels.getLabel(searchCriteriaKey.label)}</a>
                        </li>)
                    }
                </ul>
            </div>
        )
    }
});

// === ResultSort.js ===
var ResultSort = React.createClass({
    propTypes: {
        sortKeys: React.PropTypes.array.isRequired,
        selectedIndex: React.PropTypes.number,
        onSortChanged: React.PropTypes.func,
        align: React.PropTypes.oneOf(["left", "center", "right"])
    }, getDefaultProps() {
        return {
            selectedIndex: 0, onSortChanged: function () {
            }, align: "right"
        }
    }, sortChanged(e) {
        let selectedIndex = parseInt(e.currentTarget.value);
        let selectedKey = this.props.sortKeys[selectedIndex];

        this.props.onSortChanged(selectedKey, selectedIndex);
    }, componentDidMount: function () {
        try {
            $('.result-sort__control').selectpicker('refresh');
        } catch (e) {
            //Do nothing in case bootstrap-select library is not found.
        }
    }, componentDidUpdate: function () {
        try {
            $('.result-sort__control').selectpicker('refresh');
        } catch (e) {
            //Do nothing in case bootstrap-select library is not found.
        }
    }, render() {
        let {
            sortKeys, selectedIndex, align
        } = this.props;
        let className = (align === "right" || align === "center") ? " -" + align : "";

        return (<form hidden={selectedIndex === -1} id="resultSortForm"
                      className={"result-sort form-inline" + className + " col-xs-6 col-lg-4"}>
            <div className="has-float-label">
                <select id="resultSort"
                        name="resultSort"
                        className="form-control result-sort__control"
                        value={selectedIndex} onChange={this.sortChanged}>
                    {sortKeys.map((sortKey, i) => <option key={i} value={i}>{sortKey.label}</option>)}
                </select>
                <label htmlFor="resultSort" className="result-sort__label">{Labels.getLabel("Sort") + ":"}</label>
            </div>
        </form>)
    }
});

// === ResultsPager.js ===
var ResultsPager = React.createClass({
  propTypes: {
    pagerDetail: React.PropTypes.object.isRequired,
    onPageClicked: React.PropTypes.func.isRequired
  },
  pageClicked(num) {
    this.props.onPageClicked(num);
  },
  getNextPage() {
    let nextPage = this.props.pagerDetail.currentPage + 1;
    return <li>{this.getLink(nextPage, <span className="fa fa-chevron-right"></span>)}</li>;
  },
  getPreviousPage() {
    let prevPage = this.props.pagerDetail.currentPage - 1;
    return <li>{this.getLink(prevPage, <span className="fa fa-chevron-left"></span>)}</li>;
  },
  getFirstPage() {
    return <li>{this.getLink(1, <span className="fa fa-fast-backward"></span>)}</li>;
  },
  getItem(num) {
    let isCurrentPage = num == this.props.pagerDetail.currentPage;
    let pageItem = isCurrentPage ?
      <span>{num}</span> : this.getLink(num);

    return (
      <li key={num} className={isCurrentPage ? "active" : ""}>
        {pageItem}
      </li>
    )
  },
  getLink(num, innerItem = num) {
    return <a href="#" onClick={this.pageClicked.bind(this, num)}>{innerItem}</a>;
  },
  render() {
    let { pagerDetail } = this.props;

    if (pagerDetail.totalPages == 0) {
      return <span />
    }

    let pageLinks = pagerDetail.pageNumbers.map(this.getItem);

    return (
      <nav className="text-center">
        <ul className="pagination">
          {pagerDetail.previousDisplayed ? this.getPreviousPage() : null}
          {pageLinks}
          {pagerDetail.nextDisplayed ? this.getNextPage() : null}
        </ul>
      </nav>
    )
  }
});

// === SocialFaqsPortlet.js ===
var SocialFaqsPortlet = {
  init: function(socialMaxFaq) {
    this.setVariables();
    this.retrieveFaqs();
	this.socialMaxFaq = socialMaxFaq;
  },
  setVariables: function() {
    this.$faqsList = $("#socialFaqsList");
    this.$faqMoreLink = $("#faqMoreLink");
    this.$noContent = $("#noSocialFaqs");
  },
  retrieveFaqs: function() {
    var url = Config.contextPath + "/controller/view/faq/"
    var data = {
      SToken: Config.csrf.value,
      format: "json"
    };

    $.post(url, data)
      .done($.proxy(this.handleResponse, this));
  },
  handleResponse: function(r) {
    var MAX_FAQ_COUNT = this.socialMaxFaq,
      count = 0,
      showMore = false,
      faqs;

    var hasItems = r !== undefined && r.faqs !== undefined && r.faqs.length > 0;

    if (!hasItems) {
      this.showNoContent();
      return;
    }

    var faqs = r.faqs.filter(function(faq) {
      return faq.isActive;
    });

    if (faqs.length == 0) {
      this.showNoContent();
      return;
    }

    if (faqs.length > MAX_FAQ_COUNT) {
      faqs = faqs.slice(0, Math.min(faqs.length, MAX_FAQ_COUNT));
      showMore = true;
    }

    faqs = faqs.map(this.getFaqItem);
    this.$faqsList.append(faqs);

    if (showMore) {
      this.$faqMoreLink.removeClass("hide");
    }
  },
  showNoContent: function() {
    this.$noContent.removeClass("hide");
    this.$faqsList.addClass("hide");
  },
  getFaqItem: function(faq) {
    var $li = $("<li></li>");
    var $href = $("<a></a>");

    $href.attr("href", Config.contextPath + "/controller/view/faq/?id=" + faq.id);
    $href.html(faq.question);
    $li.append($href);

    return $li;
  }
};

// === SocialLatestQuestions.js ===
var SocialLatestQuestions = {
  init: function() {
    this.setVariables();
    this.retrieveQuestions();
  },
  setVariables: function() {
    this.$latestQuestionsList = $("#latestQuestionsList");
    this.$noLatestQuestions = $("#noLatestQuestions");
  },
  retrieveQuestions: function() {
    var _self = this;

    $.get(Config.contextPath + "/controller/socialsearch/latest/")
      .done(function(r) {

        var count = r.results.length;
        if (count <= 0) {
          _self.$noLatestQuestions.removeClass("hide");
          _self.$latestQuestionsList.addClass("hide");
          return;
        }

        $.each(r.results, function(i, question) {
          var $li = $("<li></li>");
          var $href = $("<a></a>");
          $href.attr("href", Config.contextPath + "/controller/view/discussion/" + question.discussion.id);
          $href.html(question.discussion.title);
          $li.append($href);
          _self.$latestQuestionsList.append($li);
        });
      });
  }
};

// === SocialLatestSolutions.js ===
var SocialLatestSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveSolutions();
  },
  setVariables: function() {
    this.$latestSolutionsList = $("#latestSolutionsList");
    this.$noLatestSolutions = $("#noLatestSolutions");
  },
  retrieveSolutions: function() {
    var _self = this;

    var url = Config.contextPath + "/controller/search/recentsolutions/"
    var data = {
      hitcount: 5,
      timerange: "lastweek",
      SToken: Config.csrf.value,
      format: "json"
    };

    $.post(url, data)
      .done(function(r) {

        if(r.error){
          alert(r.errorMessage);
          return;
        }

        var count = r.recentSolutions.length;
        if (count <= 0) {
          _self.$noLatestSolutions.removeClass("hide");
          _self.$latestSolutionsList.addClass("hide");
          return;
        }

		let target = "";
		if (launchLinksInNewWindow) {
			target = `_blank`;
		} else {
			target = `_self`;
		}

        $.each(r.recentSolutions, function(i, solution) {
          var $li = $("<li></li>");
          var $href = $("<a></a>");
          $href.attr("href", Config.contextPath + "/app/portlets/results/viewsolution.jsp?solutionid=" + solution.id + simplifiedSocialLayoutParam + launchLinksInNewWindowParam);
		  $href.attr("target", target);
          $href.html(solution.problem);
          $li.append($href);
          _self.$latestSolutionsList.append($li);
        });

      });
  }
};


// === SocialPopularDownloadSolutions.js ===
var SocialPopularDownloadSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveSolutions();
  },
  setVariables: function() {
    this.$solutionList = $('#socialPopularDownloadSolutions');
    this.$noContent = $('#noSocialPopularDownloadSolutions');
    this.$popularCollection = $("#searchaliases").val();
  },
  retrieveSolutions: function() {
    var _self = this;

    var url = Config.contextPath + "/app/customportlets/sage/popularitems/worker.jsp";
    var data = {
      SToken: Config.csrf.value,
      items: "sagePopularItems",
      timerange: "lastweek",
      collection: this.$popularCollection,
      target: 'download'
    };

    $.post(url, data)
      .done(function(r) {

        var hasItems = r !== undefined && r.sagePopularItems !== undefined && r.sagePopularItems.length > 0;

        if (hasItems) {
          var items = r.sagePopularItems;

          for (var i = 0; i < items.length; i++) {
            var $link = $("<a>");
            $link.text(items[i].title);
            $link.attr("href", Config.contextPath + "/app/portlets/results/viewsolution.jsp?solutionid=" + items[i].id);
            var $li = $("<li></li>");
            $li.append($link);
            _self.$solutionList.append($li);
          }
        } else {
          _self.$solutionList.addClass("hide");
          _self.$noContent.removeClass("hide");
        }
      });
  }
};

// === SocialPopularErrorSolutions.js ===
var SocialPopularErrorSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveSolutions();
  },
  setVariables: function() {
    this.$solutionList = $('#socialPopularErrorSolutions');
    this.$noContent = $('#noSocialPopularErrorSolutions');
    this.$popularCollection = $("#searchaliases").val();
  },
  retrieveSolutions: function() {
    var _self = this;

    var url = Config.contextPath + "/app/customportlets/sage/popularitems/worker.jsp";
    var data = {
      SToken: Config.csrf.value,
      items: "sagePopularItems",
      timerange: "lastweek",
      collection: this.$popularCollection,
      target: 'error'
    };

    $.post(url, data)
      .done(function(r) {

        var hasItems = r !== undefined && r.sagePopularItems !== undefined && r.sagePopularItems.length > 0;

        if (hasItems) {
          var items = r.sagePopularItems;

          for (var i = 0; i < items.length; i++) {
            var $link = $("<a>");
            $link.text(items[i].title);
            $link.attr("href", Config.contextPath + "/app/portlets/results/viewsolution.jsp?solutionid=" + items[i].id);
            var $li = $("<li></li>");
            $li.append($link);
            _self.$solutionList.append($li);
          }
        } else {
          _self.$solutionList.addClass("hide");
          _self.$noContent.removeClass("hide");
        }
      });
  }
};

// === SocialPopularHowtoSolutions.js ===
var SocialPopularHowtoSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveSolutions();
  },
  setVariables: function() {
    this.$solutionList = $('#socialPopularHowtoSolutions');
    this.$noContent = $('#noSocialPopularHowtoSolutions');
    this.$popularCollection = $("#searchaliases").val();
  },
  retrieveSolutions: function() {
    var _self = this;

    var url = Config.contextPath + "/app/customportlets/sage/popularitems/worker.jsp";
    var data = {
      SToken: Config.csrf.value,
      items: "sagePopularItems",
      timerange: "lastweek",
      collection: this.$popularCollection,
      target: 'howto'
    };

    $.post(url, data)
      .done(function(r) {

        var hasItems = r !== undefined && r.sagePopularItems !== undefined && r.sagePopularItems.length > 0;

        if (hasItems) {
          var items = r.sagePopularItems;

          for (var i = 0; i < items.length; i++) {
            var $link = $("<a>");
            $link.text(items[i].title);
            $link.attr("href", Config.contextPath + "/app/portlets/results/viewsolution.jsp?solutionid=" + items[i].id);
            var $li = $("<li></li>");
            $li.append($link);
            _self.$solutionList.append($li);
          }
        } else {
          _self.$solutionList.addClass("hide");
          _self.$noContent.removeClass("hide");
        }
      });
  }
};

// === SocialPopularSearches.js ===
var SocialPopularSearches = {
  init: function() {
    this.setVariables();
    this.retrieveSearches();
  },
  setVariables: function() {
    this.$searchList = $("#socialPopularSearches");
    this.$noContent = $("#noSocialPopularSearches");
  },
  retrieveSearches: function() {
    var _self = this;

    var url = Config.contextPath + "/app/portlets/popularitems/worker.jsp";
    var data = {
      SToken: Config.csrf.value,
      items: "companySearches",
      timerange: "lastweek"
    };

    $.post(url, data)
      .done(function(r) {
        var hasItems = r !== undefined && r.companySearches !== undefined && r.companySearches.length > 0;

        if (hasItems) {
          var items = r.companySearches;

          for (var i = 0; i < items.length; i++) {
            var $link = $("<a>");
            var $li = $("<li></li>");
            var url = RA.buildSearchUrl(items[i]);

            $link.attr("href", url);
            $link.text(items[i]);
            $li.append($link);

            _self.$searchList.append($li);
          }
        } else {
          _self.$searchList.addClass("hide");
          _self.$noContent.removeClass("hide");
        }
      });
  }
};

// === SocialPopularSolutions.js ===
var SocialPopularSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveSolutions();
  },
  setVariables: function() {
    this.$solutionList = $("#socialPopularSolutions");
    this.$noContent = $("#noSocialPopularSolutions");
  },
  retrieveSolutions: function() {
    var _self = this;

    var url = Config.contextPath + "/app/portlets/popularitems/worker.jsp";
    var data = {
      SToken: Config.csrf.value,
      items: "companyViews",
      timerange: "lastweek"
    };

    $.post(url, data)
      .done(function(r) {

        var hasItems = r !== undefined && r.companyViews !== undefined && r.companyViews.length > 0;

        if (hasItems) {
          var items = r.companyViews;

          for (var i = 0; i < items.length; i++) {
            var $link = $("<a>");
            $link.text(items[i].title);
            $link.attr("href", Config.contextPath + "/app/portlets/results/viewsolution.jsp?solutionid=" + items[i].id);
            var $li = $("<li></li>");
            $li.append($link);
            _self.$solutionList.append($li);
          }
        } else {
          _self.$solutionList.addClass("hide");
          _self.$noContent.removeClass("hide");
        }
      });
  }
};

// === SocialSSAnnouncements.js ===
var SocialSSAnnouncements = {
  init: function () {
    this.setVariables();
    this.retrieveAnnouncements();
  },
  setVariables: function () {
    this.$announcementSection = $("#announcementSection");
    this.$announcementList = $("#annPanel .announce__list");
    this.$announcementCount = $("#announcementCount");
    this.$announce__title = $("#announce__title");
    this.$noAnnouncement = $("#noAnnouncement");
    this.$announcementPanel = $("#annPanel");
  },
  retrieveAnnouncements: function () {
    var url = Config.contextPath + "/controller/get/announcement/";
    $.get(url)
      .done(this.handleResponse.bind(this));
  },
  handleResponse: function (response) {
    if (!response.announcements || !Array.isArray(response.announcements) || response.announcements.length === 0) {
      this.$announcementSection.hide();
      this.$noAnnouncement.removeClass('hide');
      return;
    }
    if (response.announcementDisplayFormat.toLowerCase() === 'carousel') {
      this.displayCarousel(response);
    } else {
      this.displayList(response);
    }
  },
  displayCarousel: function (response) {
    $(".announce__arrow").css("display", "none");
    $("#annPanel").css("display", "none");
    const $slider = $('<div class="slider"></div>');
    const $slides = $('<div class="slides"></div>');
    const $controls = $('<div class="controls"></div>');
    const $prevBtn = $('<button class="slide-prev">&#10094;</button>');
    const $nextBtn = $('<button class="slide-next">&#10095;</button>');
    const $dots = $('<div class="dots"></div>');
    let newCount = 0;
    let timer;
    const delay = response.announcementCarouselRotation;

    response.announcements.sort((a, b) => b.isNew - a.isNew);

    response.announcements.forEach((announcement, index) => {
      const $slide = $(`
        <div class="slide">
          <div>
            <h3 class="new-tag">${announcement.isNew ? 'NEW' : ''}</h3>
            <div class="announcement-content"></div>
          </div>
        </div>
      `);
      $slide.find(".announcement-content").append(announcement.text);
      $slides.append($slide);

      const $dot = $('<span class="dotItem"></span>');
      if (index === 0) $dot.addClass('active');
      $dots.append($dot);

      if (announcement.isNew) {
        newCount++;
      }
    });

    if (newCount > 0) {
      this.$announcementCount.html(newCount).show();
      this.$announcementSection.addClass("-new");
    }

    $controls.append($prevBtn, $dots, $nextBtn);
    $slider.append($slides, $controls);
    this.$announcementSection.append($slider);

    let currentSlide = 0;
    const $slideItems = $slides.children('.slide');
    const $dotItems = $dots.children('.dotItem');

    const showSlide = (index) => {
      if (timer) {
        clearInterval(timer);
      }
      if (delay > 0) {
        timer = setInterval(() =>
          showSlide(currentSlide + 1), (delay > 60 ? 60 : delay) * 1000
        );
      }
      currentSlide = (index + $slideItems.length) % $slideItems.length;
      const offset = -currentSlide * 100;
      $slides.css('transform', `translateX(${offset}%)`);
      $dotItems.removeClass('active').eq(currentSlide).addClass('active');
    };

    $nextBtn.on('click', () => {
      showSlide(currentSlide + 1);
      $nextBtn.addClass('activeBtn');
      $prevBtn.removeClass('activeBtn');
    });
    $prevBtn.on('click', () => {
      showSlide(currentSlide - 1);
      $nextBtn.removeClass('activeBtn');
      $prevBtn.addClass('activeBtn');
    });
    $dotItems.on('click', function () { showSlide($(this).index()); });

    showSlide(currentSlide);
  },
  displayList: function (response) {
    let newCount = 0;
    const announcementDisplaySettings = response.announcementDisplaySettings.toLowerCase();
    
    if (announcementDisplaySettings === "show expanded") {
      this.$announcementPanel.addClass("in");
    }
    else {
      if (announcementDisplaySettings === "show collapsible") {
        this.$announcementPanel.removeClass("in");
      }
    }

    if (announcementDisplaySettings !== "show expanded" &&
        announcementDisplaySettings !== "show collapsible" &&
        announcementDisplaySettings !== "show expanded when new") {
          this.$announcementPanel.addClass("in");
    }

    response.announcements.forEach((announcement, index) => {
      const $li = $("<li></li>").addClass("announce__item");
      const $accordionLink = $("<a class='announce__toggle-link single-announcement' role='button' data-toggle='collapse' aria-expanded='false'></a>");
      const $contentDiv = $("<div></div>").html(announcement.text);

      if (announcement.isNew) {
        newCount++;
        $li.addClass("-new");
      }

      $accordionLink.attr("href", "#" + index);
      $accordionLink[0].innerHTML = "<div>" + announcement.displayText.substring(0, 121) + "</div><span class='glyphicon glyphicon-menu-up'></span>";
      $accordionLink.attr("aria-controls", index + "");
      $contentDiv.attr("id", index + "");
      $contentDiv.addClass("collapse in");
      $li.append($accordionLink);
      $li.append($contentDiv);
      this.$announcementList.append($li);
    });

    if (newCount > 0) {
      this.$announcementCount.html(newCount).show();
      this.$announcementSection.addClass("-new");
      if (announcementDisplaySettings === "show expanded when new") {
        this.$announcementPanel.addClass("in");
      }
    }
  }
};

// === SocialSSComplianceSolutions.js ===
var SocialSSComplianceSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveComplianceSolutions();
  },
  setVariables: function() {
    this.$complianceSolutionSection = $("#complianceSolutionSection");
	this.$complianceCount = $("#complianceSolutionCount");
  },
  retrieveComplianceSolutions: function() {
    var url = Config.contextPath + "/controller/view/solution/compliance?action=getComplianceIds";
    $.get(url)
      .done(this.handleResponse.bind(this));
  },
  handleResponse: function(r) {
    if (!r.needsCompliance) {
		this.$complianceSolutionSection.hide();
    }else{
		this.$complianceCount.html(r.count);
		this.$complianceCount.show();
		this.$complianceSolutionSection.show();
	}
  }
};

// === SocialShortcutPanels.js ===
var SocialShortcutPanels = {
  init: function() {
    this.setVariables();

    this.$links.each(this.updateHref);
  },
  setVariables: function() {
    this.$links = $(".shortcut-panel__link");
  },
  updateHref: function() {
    var $this = $(this);
    var action = $this.data("action");
    var detail = $this.data("detail");

    var url = Config.contextPath + "/" + Config.portalInterface + "/";

    if (action == "search") {
      url = RA.buildSearchUrl(detail);
    } else if (action == "browse") {
      url += "?tabid=" + Config.resultsTabID + "&taxonomypath=" + encodeURIComponent(detail) + "#t=kbResults";
    } else if (action == "community") {
      if (Config.isCommunityEnabled) {
        url += "?tabname=community&communityID=" + detail;
      } else {
        url = "#";
        $this.parent().hide();
      }
    } else if (action == "url") {
	  url = detail+"";//append blank in case the detail is a number we need to convert to string.
	  if (url.indexOf('new_window-') === 0) {
		  $this.attr("target", "_blank");
		  url = url.substr(url.indexOf("new_window-") + 11);
		  $this.data("detail", url);
	  }
    }

    $this.attr("href", url);
  }
};


// === SocialViewFaqs.js ===
var SocialViewFaqs = {
  init: function() {
    var urlParams,
        loggedViewIDs = [],
        $collapseItems = $("#faqItems").find(".collapse"),
        $allLink = $("#faqToggleAllLink");

    $allLink.on("click", toggleAll);
    $collapseItems.on("shown.bs.collapse", onShow);
    $collapseItems.on("hidden.bs.collapse", onHide);

    parseUrlParams();

    if (urlParams.id) {
      pageLoadView(urlParams.id);
    }

    function parseUrlParams() {
      var match,
          pl     = /\+/g,  // Regex for replacing addition symbol with a space
          search = /([^&=]+)=?([^&]*)/g,
          decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
          query  = window.location.search.substring(1);

      urlParams = {};
      while (match = search.exec(query))
         urlParams[decode(match[1])] = decode(match[2]);
    }

    function pageLoadView(id) {
      var $item = $("#faqCollapse_" + id),
        $li = $item.closest("li");

      setTimeout(function() {
        $li.addClass("-highlight");

        setTimeout(function() {
          $li.removeClass("-highlight")
        }, 3000);
      }, 200);

      $item.collapse("show");
    }

    function toggleAll() {
      isAllOpen() ? hideAll() : showAll();
    }

    function updateAllLink() {
      if (isAllOpen()) {
        $allLink.text(Labels.getLabel("Hide all"));
      } else {
        $allLink.text(Labels.getLabel("Show all"));
      }
    }

    function isAllOpen() {
      return $collapseItems.length == $collapseItems.filter(".in").length;
    }

    function onShow() {
      var id = $(this).attr("id");
      id = id.substring(id.indexOf("_") + 1);

      if (loggedViewIDs.indexOf(id) == -1) {
        loggedViewIDs.push(id);
        logView(id);
      }

      updateAllLink();
    }

    function onHide() {
      updateAllLink();
    }

    function showAll() {
      $collapseItems.collapse("show");
      updateAllLink();
    }

    function hideAll() {
      $collapseItems.collapse("hide");
      updateAllLink();
    }

    function logView(id) {
      var $item = $("#faqCollapse_" + id);

      var data = {
        action: "VIEWFAQ",
        description: $item.find(".collapse-list__title").text(),
        docid: id,
        accessmethod: sessionStorage.getItem("accessmethod")
      };

      RA.logAction(data);
    }
  }
};

// === SolutionComments.js ===
var SolutionComments = React.createClass({
  getDefaultProps() {
    return {
      data: null,
      isGuest: false
    };
  },
  commentSaved(comment) {
    RA.ViewKB.Comments.load();
  },
  replySaved(comment) {
    RA.ViewKB.Comments.load(RA.ViewKB.Comments.currentPage);
  },
  reloadComments() {
    this.pageClicked(1);
  },
  pageClicked(pageNumber) {
    RA.ViewKB.Comments.load(pageNumber);
  },
  render() {
    let data = this.props.data;
    let inputForm, comments, pager, actions;

    if (!this.props.isGuest) {
      inputForm = <CommentBox onCommentSaved={this.commentSaved} />;
      actions =
        <div className="comments__actions">
          <SubscribeCommentsAction solutionID={RA.ViewKB.solution.id}
            defaultEmailAddress={RA.ViewKB.user.emailAddress} />
        </div>;
    } else {
		let redirTarget = (window.location.pathname + (window.location.search || "?") + "&guest=0").replace(/&/g, "_amp_");
		redirTarget = encodeURIComponent(redirTarget);
		let url = `${Config.contextPath}/${Config.portalInterface}/logout.jsp?redir=${redirTarget}`;
      let signUpUrl = `${Config.contextPath}/${Config.portalInterface}/logout.jsp?redir=${redirTarget}`;
      inputForm = <div className="comments__no-login-msg">{Labels.getLabel("Please")} <a href={url}>{Labels.getLabel("login")}</a> {Labels.getLabel("or")} <a href={signUpUrl}>{Labels.getLabel("sign up")}</a> {Labels.getLabel("to comment")}</div>
    }

    if (data && data.comments.length) {
      comments = (
        <div>
          <CommentsHead totalComments={data.totalComments} />
          <CommentsList comments={data.comments}
            showReplyLink={!this.props.isGuest}
            onReplySaved={this.replySaved}
            currentUserID={data.currentUserID}
            isResolutionAllowed={data.isResolutionAllowed}/>
        </div>
      );

      if (data.pagerDetail && data.pagerDetail.totalPages > 1) {
        pager = (
          <ResultsPager pagerDetail={data.pagerDetail}
            onPageClicked={this.pageClicked} />
        )
      }
    } else {
      comments = <span></span>;
    }

    return (
      <div>
        {actions}
        {inputForm}
        {comments}
        {pager}
      </div>
    );
  }
});

// === SolutionFeedback.js ===
var SolutionFeedback = React.createClass({
  VOTE_YES: "yes",
  VOTE_NO: "no",
  propTypes: {
    viewCount: React.PropTypes.number,
    initalSolvedCount: React.PropTypes.number
  },
  getInitialState() {
    return {
      solvedCount: this.props.initalSolvedCount || 0
    }
  },
  yesClicked() {
    if (this.state.userVote) return;

	let disableSurveyUrl = `${Config.contextPath}/app/portlets/survey/disablesurvey.jsp`;
	$.get(disableSurveyUrl);

    RA.ViewKB.logAction("SOLVED");

    this.setState({solvedCount: this.state.solvedCount + 1,
      userVote: this.VOTE_YES});
  
	let {survey} = RA.ViewKB;
    if (survey.showSurveyOnYes && survey.yesSurveyID > 0) {
		let url = `${Config.contextPath}/app/portlets/survey/survey.jsp`;
		let params = {
			issolutionsurvey: true,
			surveyid: RA.ViewKB.survey.yesSurveyID,
			solutionid: RA.ViewKB.solution.id,
			solutiontitle: encodeURIComponent(RA.ViewKB.solution.title),
			solutioncollections: encodeURIComponent(RA.ViewKB.solution.collections),
			collectionsdescription: encodeURIComponent(RA.ViewKB.solution.collectionsDescription)
		};

		$.post(url, params, function (res) {
			res = res.replaceAll('action="survey.jsp"', 'action="../survey/survey.jsp"');

			let newWin = window.open(url, "ra.survey", "width=800,height=600,location=no,menubar=no,resizable=yes,status=yes,titlebar=yes,toolbar=no,scrollbars=yes");
			newWin.document.write(res);
		});
    }
  },
  noClicked() {
    if (this.state.userVote) return;

	let disableSurveyUrl = `${Config.contextPath}/app/portlets/survey/disablesurvey.jsp`;
	$.get(disableSurveyUrl);

    let ssLogPromise = new Promise(resolve => {
        this.unsolvedLogAction(RA.ViewKB.getLogString("UNSOLVED"), resolve);
    });

    let ssSurveyPromise = Promise.resolve(); // Default resolved promise if no survey
    this.setState({userVote: this.VOTE_NO});

    let {survey} = RA.ViewKB;
    if (survey.showSurveyOnNo && survey.id > 0) {
		let url = `${Config.contextPath}/app/portlets/survey/survey.jsp`;
		let params = { 
			issolutionsurvey: true, 
			surveyid: RA.ViewKB.survey.id, 
			solutionid: RA.ViewKB.solution.id, 
			solutiontitle: encodeURIComponent(RA.ViewKB.solution.title), 
			solutioncollections: encodeURIComponent(RA.ViewKB.solution.collections), 
			collectionsdescription: encodeURIComponent(RA.ViewKB.solution.collectionsDescription) 
		};

        ssSurveyPromise = new Promise(resolve => {
            $.post(url, params, function(res) {
                res = res.replaceAll('action="survey.jsp"', 'action="../survey/survey.jsp"');

                let newWin = window.open(url, "ra.survey", "width=800,height=600,location=no,menubar=no,resizable=yes,status=yes,titlebar=yes,toolbar=no,scrollbars=yes");
                newWin.document.write(res);
                resolve();
            });
        });
    }

    Promise.all([ssLogPromise, ssSurveyPromise]).then(() => {
        if (Config.copyToIncidentEnabled) {
            window.close();
        }
    });
  },
  unsolvedLogAction: function(data, callback) {
    // Data can be query string or object
    let url = Config.contextPath + "/app/core/ralogger.jsp";
    $.post(url, data).always(function() {
        if (callback) {
            callback();
        }
    });
  },
  render() {
    let yesClassName = "feedback__link",
      noClassName = "feedback__link",
      viewsLabel = this.props.viewCount == 1 ? "view" : "views";

    if (this.state.userVote == this.VOTE_YES) {
      yesClassName += " -up -voted";
      noClassName += " -disabled";
    } else if (this.state.userVote == this.VOTE_NO) {
      yesClassName += " -disabled";
      noClassName += " -down -voted";
    } else {
      yesClassName += " -up";
      noClassName += " -down";
    }

    return (
      <div className="feedback">
        <h3 className="aside__title">{Labels.getLabel("Did this help?")}</h3>

        <div className="feedback__vote">
          <a href="#" onClick={this.yesClicked} className={yesClassName}>
            <span className="glyphicon glyphicon-thumbs-up"></span>
            <span>{` ${Labels.getLabel("Yes")}`}</span>
          </a>
          <a href="#" onClick={this.noClicked} className={noClassName}>
            <span className="glyphicon glyphicon-thumbs-down"></span>
            <span>{` ${Labels.getLabel("No")}`}</span>
          </a>
        </div>

        <div className="aside__footer text-center">
          <div className="feedback__stat">
            <span className="glyphicon glyphicon-eye-open"></span>
            {` ${this.props.viewCount} ${Labels.getLabel(viewsLabel)}`}
          </div>
          <div className="feedback__stat">
            <span className="glyphicon glyphicon-thumbs-up"></span>
            {` ${this.state.solvedCount} ${Labels.getLabel("voted yes")}`}
          </div>
        </div>
      </div>
    );
  }
});

// === SubscribeCommentsAction.js ===
var SubscribeCommentsAction = React.createClass({
  propTypes: {
    solutionID: React.PropTypes.string.isRequired,
    defaultEmailAddress: React.PropTypes.string
  },
  getInitialState() {
    return {
      isOpen: false,
      isSubscribed: false,
      emailAddress: "",
      errorMsg: ""
    }
  },
  componentDidMount() {
    let url = `${Config.contextPath}/controller/status/mysubscriptions/`;
    let data = { solutionID: this.props.solutionID,
     SToken: Config.csrf.value };

    $.post(url, data)
      .done(this.handleResponse);
  },
  handleResponse(r) {
    this.setState({isSubscribed: r.isSubscribed,
        emailAddress: r.emailAddress || this.props.defaultEmailAddress,
        isOpen: false });
  },
  emailChanged(e) {
    this.setState({emailAddress: e.target.value});
  },
  confirmClicked(e) {
    e.preventDefault();

    let url, data;

    if (this.state.isSubscribed) {
      url = `${Config.contextPath}/controller/delete/mysubscriptions/`;
      data = { solutionID: this.props.solutionID,
       SToken: Config.csrf.value };
    } else {
      if (!this.validateForm()) {
        return;
      }

      url = `${Config.contextPath}/controller/add/mysubscriptions/`;
      data = {
        solutionID: this.props.solutionID,
        emailAddress: this.state.emailAddress,
        SToken: Config.csrf.value
      };
    }

    $.post(url, data)
      .done(this.handleResponse);
  },
  validateForm() {
    let msg = "";

    let emailPattern = /^([a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,};?\s*)+$/;
    if (!emailPattern.test(this.state.emailAddress)) {
      msg = Labels.getLabel("Invalid email address");
    }

    this.setState({errorMsg: msg});
    return !msg.length;
  },
  toggleClicked(e) {
    if (this.state.isOpen) {
      this.setState({isOpen: false});
      $(document).off("click.ra.dropdown");
    } else {
      this.setState({isOpen: true});
      $(document).on("click.ra.dropdown", this.pageClicked);
    }
  },
  pageClicked(e) {
    if (e.target == this.refs.popup
     || this.refs.popup.contains(e.target)
     || e.target == this.refs.toggle) {
      return;
    }

    this.toggleClicked(e);
  },
  getErrorMessage() {
    if (!this.state.errorMsg.length) {
      return;
    }

    return (
      <div className="alert alert-danger">
        <span className="glyphicon glyphicon-exclamation-sign"></span>
        <strong>{" " + Labels.getLabel("Error")}:</strong>{" " + this.state.errorMsg}
      </div>
    );
  },
  getSubscribeForm() {
    return (
      <div>
        {this.getErrorMessage()}

        <p>{Labels.getLabel("Enter your email address to receive notifications when comments are added.")}</p>

        <form>
          <div className="input-group">
            <input type="text" className="form-control" placeholder="Email Address" onChange={this.emailChanged} value={this.state.emailAddress} />
            <span className="input-group-btn">
              <button className="btn btn-default" type="submit" onClick={this.confirmClicked}><span className="glyphicon glyphicon-ok"></span></button>
            </span>
          </div>
        </form>

      </div>
    );
  },
  getUnsubscribeForm() {
    return (
      <div>
        <p>Turn off notifications for this solution sent to <span className="text-success">{this.state.emailAddress}</span>?</p>

        <div className="text-right">
          <button className="btn btn-default" type="button" onClick={this.confirmClicked}><span className="glyphicon glyphicon-ok"></span></button>
        </div>
      </div>
    );
  },
  render() {
    let label = this.state.isSubscribed ? Labels.getLabel("Unsubscribe") : Labels.getLabel("Subscribe");

    return (
      <div className={"dropdown " + (this.state.isOpen ? " open" : "")}>
        <button type="button" className="btn btn-sm btn-default" ref="toggle" onClick={this.toggleClicked}>
          {label + " "}
          <span className="caret"></span>
        </button>
        <div className="dropdown-menu dropdown-menu-right -no-list" ref="popup">
          {this.state.isSubscribed ? this.getUnsubscribeForm() : this.getSubscribeForm()}
        </div>
      </div>
    );
  }
});

// === Tab.js ===
var Tab = React.createClass({
  propTypes: {
    eventKey: React.PropTypes.any.isRequired,
    active: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      active: false
    }
  },
  tabClicked() {
    this.props.onClick(this.props.eventKey);
  },
  render() {
    return (
      <li className={classNames("tab-bar__item", {active: this.props.active})}>
        <a href="#" className="tab-bar__link" onClick={this.tabClicked}>{this.props.children}</a>
      </li>
    )
  }
})

// === TabBar.js ===
var TabBar = React.createClass({
  propTypes: {
    onChange: React.PropTypes.func,
    activeKey: React.PropTypes.any,
    className: React.PropTypes.string
  },
  tabClicked(key) {
    if (this.props.onChange) this.props.onChange(key);
  },
  render() {
    let {
      children,
      activeKey
    } = this.props;

    let tabs = React.Children.map(children, child => {
      return React.cloneElement(child, {
          onClick: this.tabClicked,
          active: activeKey === child.props.eventKey
        });
      }
    );

    return (
      <ul className={classNames("tab-bar", "clearfix", this.props.className)}>
        {tabs}
      </ul>
    )
  }
})

// === TagFilter.js ===
var TagFilter = React.createClass({
  propTypes: {
    tags: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    selectedTagIDs: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
    onTagsChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedTagIDs: []
    }
  },
  tagClicked(tagID) {
    let selectedTagIDs = this.props.selectedTagIDs;

    if (this.isTagSelected(tagID)) {
      selectedTagIDs = selectedTagIDs.filter(id => id != tagID);
    } else {
      selectedTagIDs.push(tagID);
    }

    if (this.props.onTagsChanged) {
      this.props.onTagsChanged(selectedTagIDs);
    }
  },
  resetSelectedTags() {
    if (this.props.onTagsChanged) {
      this.props.onTagsChanged([]);
    }
  },
  isTagSelected(id) {
    return this.props.selectedTagIDs.indexOf(id) > -1;
  },
  getItem(tag) {
    let className = classNames("filter__item", {"-active": this.isTagSelected(tag.id)});

    return (
      <li className={className} key={tag.id}>
        <a href="#" className="filter__link" onClick={this.tagClicked.bind(this, tag.id)}>{tag.tag}</a>
      </li>
    )
  },
  getClearLink() {
    if (this.props.selectedTagIDs.length == 0) return;

    return (
      <ul className="filter__list">
        <li className="filter__item">
          <a href="#" onClick={this.resetSelectedTags}>{Labels.getLabel("Clear")}</a>
        </li>
      </ul>
    )
  },
  render() {
    if (this.props.tags.length == 0) {
      return <span />
    }

    let items = this.props.tags.map(this.getItem);

    return (
      <BrowseFilter title={Labels.getLabel("Tags")}>
        {this.getClearLink()}

        <CollapsingFilterList
          items={items}
          listClassName="filter__list -tags"
          displayBeforeFold={10} />

      </BrowseFilter>
    )
  }
});

// === TypeFilter.js ===
var TypeFilter = React.createClass({
  propTypes: {
    selectedTypes: React.PropTypes.arrayOf(React.PropTypes.string),
    onTypesChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      defaultTypes:[{code:"raserviceRequest",description:"Service Request"},{code:"rarightPath",description:"Right Path"},{code:"ravideo",description:"Video"}],
      selectedTypes: []
    }
  },
 typeClicked(code) {
    let checkedTypes = this.props.selectedTypes;
    let isSelected = this.isTypeSelected(code);
    if (!isSelected) {
      checkedTypes.push(code);
    } else {
      checkedTypes = checkedTypes.filter(val => val != code);
    }

    if (this.props.onTypesChanged) {
      this.props.onTypesChanged(checkedTypes);
    }
  },
  isTypeSelected(code) {
    return this.props.selectedTypes.indexOf(code) != -1;
  },
  getItem(type) {
    return (
      <li className="filter__item" key={type.code}>
        <RACheck label={Labels.getLabel(type.description)}
          value={type.code}
          isChecked={this.isTypeSelected(type.code)}
          onClick={this.typeClicked} />
      </li>
    )
  },
  render() {
    if (this.props.defaultTypes.length == 0) {
      return <span />
    }

    return (
      <BrowseFilter title={Labels.getLabel("Type")} filterType="filter-type__type" ariaLabel="Solution type filter" isOpen={this.props.isOpen}>
        <ul className="filter__list">
        {this.props.defaultTypes.map(this.getItem)}

        </ul>
      </BrowseFilter>
    )
  }
});

// === UserGameSummary.js ===
var UserGameSummary = React.createClass({
  propTypes: {
    gameData: React.PropTypes.object.isRequired
  },
  getInitialState() {
    return {
      modalVisible: false,
      gameEvents: [],
      progressWidth: 0
    }
  },
  componentDidMount() {
    let game = this.props.gameData;
    if (!game.nextLevel) return;

    let progress = ((game.totalPoints / game.nextLevel.minPoints) * 100).toPrecision(3);

    setTimeout(() => {
      this.setState({progressWidth: progress});
    }, 250);
  },
  getLevelDescription(level) {
    if (isNaN(level.description)) {
      return level.description
    } else {
      return `${Labels.getLabel("Level")} ${level.description}`;
    }
  },
  showGameDetail() {
    if (this.state.gameEvents.length == 0) {
      let url = `${Config.contextPath}/controller/report/gamification/getAllEventsForUser`;
      $.get(url)
        .done(r => this.setState({gameEvents: r.events, modalVisible: true}));
    } else {
      this.setState({modalVisible: true});
    }
  },
  hideModal() {
    this.setState({modalVisible: false});
  },
  formatNumber(val) {
    return Number.prototype.toLocaleString ? val.toLocaleString() : val;
  },
  renderProgress() {
    let game = this.props.gameData;
    let {progressWidth} = this.state;

    if (!game.nextLevel) return;

    return (
      <div>
        <span className="pull-right">{this.formatNumber(game.nextLevel.minPoints)}</span>
        <span>{Labels.getLabel("Next Level")}</span>

        <div className="progress game-summary__progress">
          <div
            className="progress-bar"
            role="progressbar"
            aria-valuenow={progressWidth}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{width: (progressWidth<100?progressWidth:100) + "%"}}>
          </div>
        </div>
      </div>
    )
  },
  render() {
    let game = this.props.gameData;

    return (
      <div>
        <div className="game-summary">
          <div className="game-summary__icon">
            <span className="fa fa-trophy" role="presentation"></span>
          </div>

          <h3 className="game-summary__title">
            {Labels.getLabel("My Score")}
          </h3>

          <div className="game-summary__detail">
            <ChildDelimited
              delimiter={<span className="dot" role="presentation"></span>}>
              <strong>{this.getLevelDescription(game.level)}</strong>
              <span>{this.formatNumber(game.totalPoints)} {Labels.getLabel("points")}</span>
            </ChildDelimited>

            <a href="#"
              className="game-summary__help-link"
              role="button"
              onClick={this.showGameDetail}>
              {Labels.getLabel("How do I get points?")}
            </a>
          </div>

          {this.renderProgress()}
        </div>

        <Modal
          show={this.state.modalVisible}
          onHide={this.hideModal}>
          <Modal.Header closeButton>
            <Modal.Title>{Labels.getLabel("How do I get points?")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{Labels.getLabel("Event")}</th>
                  <th className="text-right">{Labels.getLabel("Points")}</th>
                </tr>
              </thead>
              <tbody>
                {this.state.gameEvents.map((data, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{data.description}</td>
                      <td className="text-right">{data.points}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-default" onClick={this.hideModal}>{Labels.getLabel("Close")}</button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
})

// === components-utility.js ===
var PortalContentCoordinator = {
  loadedComponents: new Set(),
  pendingScrollTargets: [],
  
  // Track when a component has finished loading
  markComponentLoaded: function(componentName) {
    this.loadedComponents.add(componentName);
    this.checkAndScroll();
  },
  
  // Set what element should be scrolled to after all components load
  scrollWhenReady: function(targetElement, requiredComponents) {
    if (!targetElement) return;
    
    this.pendingScrollTargets.push({
      element: targetElement,
      required: requiredComponents || []
    });
    this.checkAndScroll();
  },
  
  // Check if we can scroll yet
  checkAndScroll: function() {
    if (this.pendingScrollTargets.length === 0) return;
    
    this.pendingScrollTargets = this.pendingScrollTargets.filter(target => {
      if (!target || !target.element) return false;
      
      const allLoaded = target.required.every(comp => 
        this.loadedComponents.has(comp)
      );
      
      if (allLoaded) {
        setTimeout(() => {
          if (target && target.element && target.element.offsetParent !== null) {
            try {
              target.element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            } catch(e) {
              console.warn('Failed to scroll to element:', e);
            }
          }
        }, 100);
        return false; // Remove from pending list after processing
      }
      return true; // Keep in pending list if not ready yet
    });
  }
};

// === GLOBAL EXPOSURE ===
if (typeof AlertMessage !== 'undefined') { window.AlertMessage = AlertMessage; }
if (typeof AnswerStatusFilter !== 'undefined') { window.AnswerStatusFilter = AnswerStatusFilter; }
if (typeof AttributeFilter !== 'undefined') { window.AttributeFilter = AttributeFilter; }
if (typeof AttributeSetsList !== 'undefined') { window.AttributeSetsList = AttributeSetsList; }
if (typeof AttributesList !== 'undefined') { window.AttributesList = AttributesList; }
if (typeof BasicPager !== 'undefined') { window.BasicPager = BasicPager; }
if (typeof BasicPagerList !== 'undefined') { window.BasicPagerList = BasicPagerList; }
if (typeof BrowseFilter !== 'undefined') { window.BrowseFilter = BrowseFilter; }
if (typeof CategoryBrowser !== 'undefined') { window.CategoryBrowser = CategoryBrowser; }
if (typeof CategoryFilter !== 'undefined') { window.CategoryFilter = CategoryFilter; }
if (typeof ChangeUserPasswordForm !== 'undefined') { window.ChangeUserPasswordForm = ChangeUserPasswordForm; }
if (typeof ChildDelimited !== 'undefined') { window.ChildDelimited = ChildDelimited; }
if (typeof ClearFilters !== 'undefined') { window.ClearFilters = ClearFilters; }
if (typeof CollapsingFilterList !== 'undefined') { window.CollapsingFilterList = CollapsingFilterList; }
if (typeof CollectionFilter !== 'undefined') { window.CollectionFilter = CollectionFilter; }
if (typeof CommDidYouMean !== 'undefined') { window.CommDidYouMean = CommDidYouMean; }
if (typeof CommResultItem !== 'undefined') { window.CommResultItem = CommResultItem; }
if (typeof CommResults !== 'undefined') { window.CommResults = CommResults; }
if (typeof CommResultsList !== 'undefined') { window.CommResultsList = CommResultsList; }
if (typeof CommSummary !== 'undefined') { window.CommSummary = CommSummary; }
if (typeof CommSummaryCommunities !== 'undefined') { window.CommSummaryCommunities = CommSummaryCommunities; }
if (typeof CommTopicFilter !== 'undefined') { window.CommTopicFilter = CommTopicFilter; }
if (typeof Comment !== 'undefined') { window.Comment = Comment; }
if (typeof url !== 'undefined') { window.url = url; }
if (typeof id !== 'undefined') { window.id = id; }
if (typeof element !== 'undefined') { window.element = element; }
if (typeof CommentBox !== 'undefined') { window.CommentBox = CommentBox; }
if (typeof tempMentionedUsersList !== 'undefined') { window.tempMentionedUsersList = tempMentionedUsersList; }
if (typeof mentionedUsersList !== 'undefined') { window.mentionedUsersList = mentionedUsersList; }
if (typeof mentionedUser !== 'undefined') { window.mentionedUser = mentionedUser; }
if (typeof doneTypingInterval !== 'undefined') { window.doneTypingInterval = doneTypingInterval; }
if (typeof textareaID !== 'undefined') { window.textareaID = textareaID; }
if (typeof mentionsMenuTextarea !== 'undefined') { window.mentionsMenuTextarea = mentionsMenuTextarea; }
if (typeof CommentCountAction !== 'undefined') { window.CommentCountAction = CommentCountAction; }
if (typeof CommentsHead !== 'undefined') { window.CommentsHead = CommentsHead; }
if (typeof CommentsList !== 'undefined') { window.CommentsList = CommentsList; }
if (typeof CommunityShortcut !== 'undefined') { window.CommunityShortcut = CommunityShortcut; }
if (typeof CommunityTitle !== 'undefined') { window.CommunityTitle = CommunityTitle; }
if (typeof DateFilter !== 'undefined') { window.DateFilter = DateFilter; }
if (typeof EditBasicUserForm !== 'undefined') { window.EditBasicUserForm = EditBasicUserForm; }
if (typeof emailPattern !== 'undefined') { window.emailPattern = emailPattern; }
if (typeof EditLinkToggle !== 'undefined') { window.EditLinkToggle = EditLinkToggle; }
if (typeof EditableListItem !== 'undefined') { window.EditableListItem = EditableListItem; }
if (typeof Favorite !== 'undefined') { window.Favorite = Favorite; }
if (typeof FavoriteFilter !== 'undefined') { window.FavoriteFilter = FavoriteFilter; }
if (typeof FilterLinkList !== 'undefined') { window.FilterLinkList = FilterLinkList; }
if (typeof GlossaryTooltip !== 'undefined') { window.GlossaryTooltip = GlossaryTooltip; }
if (typeof IncompleteSolutions !== 'undefined') { window.IncompleteSolutions = IncompleteSolutions; }
if (typeof KBDidYouMean !== 'undefined') { window.KBDidYouMean = KBDidYouMean; }
if (typeof KBResultItem !== 'undefined') { window.KBResultItem = KBResultItem; }
if (typeof divStyle !== 'undefined') { window.divStyle = divStyle; }
if (typeof KBResults !== 'undefined') { window.KBResults = KBResults; }
if (typeof KBResultsList !== 'undefined') { window.KBResultsList = KBResultsList; }
if (typeof KBSummary !== 'undefined') { window.KBSummary = KBSummary; }
if (typeof KBSummaryCategories !== 'undefined') { window.KBSummaryCategories = KBSummaryCategories; }
if (typeof LanguageFilter !== 'undefined') { window.LanguageFilter = LanguageFilter; }
if (typeof ManageFavorites !== 'undefined') { window.ManageFavorites = ManageFavorites; }
if (typeof ManageProfileImage !== 'undefined') { window.ManageProfileImage = ManageProfileImage; }
if (typeof ManageUserAccount !== 'undefined') { window.ManageUserAccount = ManageUserAccount; }
if (typeof Modal !== 'undefined') { window.Modal = Modal; }
if (typeof MyPosts !== 'undefined') { window.MyPosts = MyPosts; }
if (typeof NoContent !== 'undefined') { window.NoContent = NoContent; }
if (typeof NoResults !== 'undefined') { window.NoResults = NoResults; }
if (typeof Overlay !== 'undefined') { window.Overlay = Overlay; }
if (typeof AIChat !== 'undefined') { window.AIChat = AIChat; }
if (typeof AIChatMessage !== 'undefined') { window.AIChatMessage = AIChatMessage; }
if (typeof headers !== 'undefined') { window.headers = headers; }
if (typeof self !== 'undefined') { window.self = self; }
if (typeof AIChatWindow !== 'undefined') { window.AIChatWindow = AIChatWindow; }
if (typeof chatItem !== 'undefined') { window.chatItem = chatItem; }
if (typeof chatItems !== 'undefined') { window.chatItems = chatItems; }
if (typeof newUserMessage !== 'undefined') { window.newUserMessage = newUserMessage; }
if (typeof updatedMessages !== 'undefined') { window.updatedMessages = updatedMessages; }
if (typeof AIMessageInput !== 'undefined') { window.AIMessageInput = AIMessageInput; }
if (typeof TopicsFilter !== 'undefined') { window.TopicsFilter = TopicsFilter; }
if (typeof $menu !== 'undefined') { window.$menu = $menu; }
if (typeof queryText !== 'undefined') { window.queryText = queryText; }
if (typeof extraParams !== 'undefined') { window.extraParams = extraParams; }
if (typeof searchUrl !== 'undefined') { window.searchUrl = searchUrl; }
if (typeof $queryInput !== 'undefined') { window.$queryInput = $queryInput; }
if (typeof lastQuery !== 'undefined') { window.lastQuery = lastQuery; }
if (typeof getSuggestions !== 'undefined') { window.getSuggestions = getSuggestions; }
if (typeof data !== 'undefined') { window.data = data; }
if (typeof searchItems !== 'undefined') { window.searchItems = searchItems; }
if (typeof getContextSuggestions !== 'undefined') { window.getContextSuggestions = getContextSuggestions; }
if (typeof items !== 'undefined') { window.items = items; }
if (typeof context !== 'undefined') { window.context = context; }
if (typeof serverSource !== 'undefined') { window.serverSource = serverSource; }
if (typeof isChanged !== 'undefined') { window.isChanged = isChanged; }
if (typeof searchesSource !== 'undefined') { window.searchesSource = searchesSource; }
if (typeof kbSource !== 'undefined') { window.kbSource = kbSource; }
if (typeof communitySource !== 'undefined') { window.communitySource = communitySource; }
if (typeof hightlightQueryWords !== 'undefined') { window.hightlightQueryWords = hightlightQueryWords; }
if (typeof words !== 'undefined') { window.words = words; }
if (typeof searchesTemplates !== 'undefined') { window.searchesTemplates = searchesTemplates; }
if (typeof kbTemplates !== 'undefined') { window.kbTemplates = kbTemplates; }
if (typeof communityTemplates !== 'undefined') { window.communityTemplates = communityTemplates; }
if (typeof $plugIn !== 'undefined') { window.$plugIn = $plugIn; }
if (typeof eventData !== 'undefined') { window.eventData = eventData; }
if (typeof initBottom !== 'undefined') { window.initBottom = initBottom; }
if (typeof $window !== 'undefined') { window.$window = $window; }
if (typeof currentQueryText !== 'undefined') { window.currentQueryText = currentQueryText; }
if (typeof MIN_WIDTH !== 'undefined') { window.MIN_WIDTH = MIN_WIDTH; }
if (typeof lastQueryText !== 'undefined') { window.lastQueryText = lastQueryText; }
if (typeof splitWords !== 'undefined') { window.splitWords = splitWords; }
if (typeof wordArray !== 'undefined') { window.wordArray = wordArray; }
if (typeof regex !== 'undefined') { window.regex = regex; }
if (typeof searchHighlight !== 'undefined') { window.searchHighlight = searchHighlight; }
if (typeof $iframe !== 'undefined') { window.$iframe = $iframe; }
if (typeof doc !== 'undefined') { window.doc = doc; }
if (typeof $img !== 'undefined') { window.$img = $img; }
if (typeof $container !== 'undefined') { window.$container = $container; }
if (typeof maxWidth !== 'undefined') { window.maxWidth = maxWidth; }
if (typeof fullWidth !== 'undefined') { window.fullWidth = fullWidth; }
if (typeof $cParent !== 'undefined') { window.$cParent = $cParent; }
if (typeof $eParent !== 'undefined') { window.$eParent = $eParent; }
if (typeof idPrefix !== 'undefined') { window.idPrefix = idPrefix; }
if (typeof $checks !== 'undefined') { window.$checks = $checks; }
if (typeof totalChecks !== 'undefined') { window.totalChecks = totalChecks; }
if (typeof $usernameToCheck !== 'undefined') { window.$usernameToCheck = $usernameToCheck; }
if (typeof solutionID !== 'undefined') { window.solutionID = solutionID; }
if (typeof checkedSteps !== 'undefined') { window.checkedSteps = checkedSteps; }
if (typeof solutionTitle !== 'undefined') { window.solutionTitle = solutionTitle; }
if (typeof operation !== 'undefined') { window.operation = operation; }
if (typeof RACheck !== 'undefined') { window.RACheck = RACheck; }
if (typeof RAResolveComment !== 'undefined') { window.RAResolveComment = RAResolveComment; }
if (typeof _self !== 'undefined') { window._self = _self; }
if (typeof $alert !== 'undefined') { window.$alert = $alert; }
if (typeof img !== 'undefined') { window.img = img; }
if (typeof loader !== 'undefined') { window.loader = loader; }
if (typeof RakeNonFederatedResultItem !== 'undefined') { window.RakeNonFederatedResultItem = RakeNonFederatedResultItem; }
if (typeof RakeNonFederatedResults !== 'undefined') { window.RakeNonFederatedResults = RakeNonFederatedResults; }
if (typeof RakeNonFederatedResultsList !== 'undefined') { window.RakeNonFederatedResultsList = RakeNonFederatedResultsList; }
if (typeof RakeNonFederatedSummary !== 'undefined') { window.RakeNonFederatedSummary = RakeNonFederatedSummary; }
if (typeof RakeNonFederatedSummaryCategories !== 'undefined') { window.RakeNonFederatedSummaryCategories = RakeNonFederatedSummaryCategories; }
if (typeof RecentActivity !== 'undefined') { window.RecentActivity = RecentActivity; }
if (typeof RecentSearches !== 'undefined') { window.RecentSearches = RecentSearches; }
if (typeof RecentViews !== 'undefined') { window.RecentViews = RecentViews; }
if (typeof ResponsiveFilterColumn !== 'undefined') { window.ResponsiveFilterColumn = ResponsiveFilterColumn; }
if (typeof ResultCountSummary !== 'undefined') { window.ResultCountSummary = ResultCountSummary; }
if (typeof ResultSort !== 'undefined') { window.ResultSort = ResultSort; }
if (typeof ResultsPager !== 'undefined') { window.ResultsPager = ResultsPager; }
if (typeof SocialFaqsPortlet !== 'undefined') { window.SocialFaqsPortlet = SocialFaqsPortlet; }
if (typeof MAX_FAQ_COUNT !== 'undefined') { window.MAX_FAQ_COUNT = MAX_FAQ_COUNT; }
if (typeof hasItems !== 'undefined') { window.hasItems = hasItems; }
if (typeof faqs !== 'undefined') { window.faqs = faqs; }
if (typeof $li !== 'undefined') { window.$li = $li; }
if (typeof $href !== 'undefined') { window.$href = $href; }
if (typeof SocialLatestQuestions !== 'undefined') { window.SocialLatestQuestions = SocialLatestQuestions; }
if (typeof count !== 'undefined') { window.count = count; }
if (typeof SocialLatestSolutions !== 'undefined') { window.SocialLatestSolutions = SocialLatestSolutions; }
if (typeof SocialPopularDownloadSolutions !== 'undefined') { window.SocialPopularDownloadSolutions = SocialPopularDownloadSolutions; }
if (typeof $link !== 'undefined') { window.$link = $link; }
if (typeof SocialPopularErrorSolutions !== 'undefined') { window.SocialPopularErrorSolutions = SocialPopularErrorSolutions; }
if (typeof SocialPopularHowtoSolutions !== 'undefined') { window.SocialPopularHowtoSolutions = SocialPopularHowtoSolutions; }
if (typeof SocialPopularSearches !== 'undefined') { window.SocialPopularSearches = SocialPopularSearches; }
if (typeof SocialPopularSolutions !== 'undefined') { window.SocialPopularSolutions = SocialPopularSolutions; }
if (typeof SocialSSAnnouncements !== 'undefined') { window.SocialSSAnnouncements = SocialSSAnnouncements; }
if (typeof SocialSSComplianceSolutions !== 'undefined') { window.SocialSSComplianceSolutions = SocialSSComplianceSolutions; }
if (typeof SocialShortcutPanels !== 'undefined') { window.SocialShortcutPanels = SocialShortcutPanels; }
if (typeof $this !== 'undefined') { window.$this = $this; }
if (typeof action !== 'undefined') { window.action = action; }
if (typeof detail !== 'undefined') { window.detail = detail; }
if (typeof SocialViewFaqs !== 'undefined') { window.SocialViewFaqs = SocialViewFaqs; }
if (typeof $item !== 'undefined') { window.$item = $item; }
if (typeof SolutionComments !== 'undefined') { window.SolutionComments = SolutionComments; }
if (typeof SolutionFeedback !== 'undefined') { window.SolutionFeedback = SolutionFeedback; }
if (typeof SubscribeCommentsAction !== 'undefined') { window.SubscribeCommentsAction = SubscribeCommentsAction; }
if (typeof Tab !== 'undefined') { window.Tab = Tab; }
if (typeof TabBar !== 'undefined') { window.TabBar = TabBar; }
if (typeof TagFilter !== 'undefined') { window.TagFilter = TagFilter; }
if (typeof TypeFilter !== 'undefined') { window.TypeFilter = TypeFilter; }
if (typeof UserGameSummary !== 'undefined') { window.UserGameSummary = UserGameSummary; }
if (typeof PortalContentCoordinator !== 'undefined') { window.PortalContentCoordinator = PortalContentCoordinator; }
